window.TCB_FINDER_DATA = window.TCB_FINDER_DATA || {};

window.TCB_FINDER_DATA.products = [
  {
    "id": "walk-behind-floor-scrubbers",
    "name": "Walk-Behind Floor Scrubbers",
    "url": "/collections/walk-behind-floor-scrubbers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "school",
      "office",
      "restaurant",
      "gym",
      "small_medium",
      "5000_25000",
      "floor_scrubber"
    ]
  },
  {
    "id": "ride-on-floor-scrubbers",
    "name": "Ride-On Floor Scrubbers",
    "url": "/collections/rider-floor-scrubbers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "warehouse",
      "large",
      "75000_plus",
      "multiple",
      "25000_75000"
    ]
  },
  {
    "id": "floor-scrubbers",
    "name": "Floor Scrubbers",
    "url": "/collections/floor-scrubbers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "entire_facility",
      "floor_scrubber",
      "not_sure"
    ]
  },
  {
    "id": "sweepers",
    "name": "Sweepers",
    "url": "/collections/floor-sweepers",
    "type": "product-category",
    "bestFor": [
      "warehouse_concrete",
      "warehouse",
      "dust",
      "debris",
      "sweeper"
    ]
  },
  {
    "id": "wet-dry-vacuums",
    "name": "Wet/Dry Vacuums",
    "url": "/collections/commercial-vacuums",
    "type": "product-category",
    "bestFor": [
      "wet_dry",
      "warehouse_concrete",
      "warehouse",
      "restrooms",
      "greasy_floors",
      "1000_3000",
      "under_1000"
    ]
  },
  {
    "id": "commercial-vacuums",
    "name": "Commercial Vacuums",
    "url": "/collections/commercial-vacuums",
    "type": "product-category",
    "bestFor": [
      "office_spaces",
      "commercial_vacuum",
      "wet_dry",
      "school",
      "church",
      "hotel",
      "contractor",
      "under_1000",
      "1000_3000"
    ]
  },
  {
    "id": "carpet-extractors",
    "name": "Carpet Extractors",
    "url": "/collections/carpet-extractors",
    "type": "product-category",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "hotel",
      "property_manager",
      "church",
      "contractor"
    ]
  },
  {
    "id": "floor-buffers",
    "name": "Floor Buffers",
    "url": "/collections/buffers-burnishers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "floor_buffer",
      "floor_care",
      "school",
      "office"
    ]
  },
  {
    "id": "burnishers",
    "name": "Burnishers",
    "url": "/collections/buffers-burnishers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "burnisher",
      "floor_shine",
      "office",
      "school"
    ]
  },
  {
    "id": "industrial-cleaning-equipment",
    "name": "Industrial Cleaning Equipment",
    "url": "/collections/shop-all-equipment",
    "type": "product-category",
    "bestFor": [
      "warehouse",
      "industrial",
      "warehouse_concrete",
      "large",
      "entire_facility",
      "75000_plus"
    ]
  },
  {
    "id": "parts",
    "name": "Replacement Parts",
    "url": "/collections/shop-all-parts",
    "type": "product-category",
    "bestFor": [
      "parts",
      "replacement_parts",
      "maintenance"
    ]
  },
  {
    "id": "chemicals",
    "name": "Chemicals & Supplies",
    "url": "/collections/cleaning-chemicals",
    "type": "product-category",
    "bestFor": [
      "chemicals",
      "greasy_floors",
      "restrooms",
      "carpet",
      "supplies",
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-portable-carpet-extractor-15-gallon",
    "name": "Commercial Portable Carpet Extractor — 15 Gallon",
    "url": "https://thecleaningbusiness.com/products/commercial-portable-carpet-extractor-15-gallon",
    "type": "product",
    "productCategory": "machine",
    "price": 4995,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ChatGPTImageJun13_2026_05_00_45AM.png?v=1781341325",
    "searchKeywords": "",
    "sku": "",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "chemical-mytee-2002cs-contractor-s-special-carpet-cleaner-extractor",
    "name": "Mytee 2002CS Contractor's Special Carpet Cleaner Extractor",
    "url": "https://thecleaningbusiness.com/products/mytee-2002cs-contractor-s-special-carpet-cleaner-extractor",
    "type": "product",
    "productCategory": "chemical",
    "price": 2366,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-2002cs-carpet-cleaning-extractor-rear-wheels_500x500_500b2d2c-045e-4868-922d-5d3546b17a1c.webp?v=1781630544",
    "searchKeywords": "",
    "sku": "MYT-2002CS",
    "bestFor": [
      "carpet_extraction",
      "commercial_cleaning_contractors",
      "route_carpet_cleaning",
      "upholstery",
      "and_restoration_jobs",
      "hotels_hospitality",
      "guest_rooms",
      "hallways",
      "lobby_carpet_maintenance",
      "schools_universities",
      "classrooms",
      "corridors",
      "and_auditorium_carpet_care",
      "property_management",
      "multi_unit_carpet_cleaning_and_turnover_services",
      "commercial_carpet_rugs"
    ]
  },
  {
    "id": "machine-rt50-lithium-floor-scrubber-22-inch",
    "name": "22\" Walk-Behind Commercial Floor Scrubber — RT50 Series",
    "url": "https://thecleaningbusiness.com/products/rt50-lithium-floor-scrubber-22-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 2299,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/5_b61e1869-5cb7-4f58-a240-c2c28a07e7fd.webp?v=1781782688",
    "searchKeywords": "",
    "sku": "100014",
    "bestFor": [
      "hard_floor_scrubbing",
      "warehouses_logistics",
      "30",
      "000_sq_ft_hr_coverage_for_distribution_centers",
      "healthcare",
      "quiet_operation_for_hospitals_and_clinics",
      "education",
      "daily_maintenance_for_schools_and_campuses",
      "retail_grocery",
      "nightly_floor_programs_for_high_traffic_stores",
      "concrete",
      "excellent",
      "epoxy_coated",
      "terrazzo",
      "recommended",
      "vct_tile"
    ]
  },
  {
    "id": "machine-cleanfreak-120-psi-heated-extractor",
    "name": "CleanFreak 120 PSI Heated Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-120-psi-heated-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 2799,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-120-psi-heated-extractor.jpg?v=1782204824",
    "searchKeywords": "",
    "sku": "CF-120HT",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-mytee-2008cs-220-psi-heated-extractor",
    "name": "Mytee 2008CS 220 PSI Heated Carpet Extractor Package",
    "url": "https://thecleaningbusiness.com/products/mytee-2008cs-220-psi-heated-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 3899,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-2008cs-220-psi-heated-extractor.jpg?v=1782204829",
    "searchKeywords": "",
    "sku": "MYT-2008CS",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-mytee-1001dx-200-speedster-deluxe",
    "name": "Mytee 1001DX-200 Speedster Deluxe Heated Extractor",
    "url": "https://thecleaningbusiness.com/products/mytee-1001dx-200-speedster-deluxe",
    "type": "product",
    "productCategory": "machine",
    "price": 4299,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-1001dx-200-speedster-deluxe.png?v=1782204834",
    "searchKeywords": "",
    "sku": "MYT-1001DX",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-cleanfreak-500-psi-heated-portable-extractor",
    "name": "CleanFreak 500 PSI Heated Portable Extractor",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-500-psi-heated-portable-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 3599,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-500-psi-heated-portable-extractor.jpg?v=1782204838",
    "searchKeywords": "",
    "sku": "CF-500HT",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-trusted-clean-ultimate-heated-extractor",
    "name": "Trusted Clean Ultimate Heated Box Extractor",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-ultimate-heated-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 2899,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-ultimate-heated-extractor.jpg?v=1782204842",
    "searchKeywords": "",
    "sku": "TC-ULTHT",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-trusted-clean-maximum-220-psi-heated-extractor",
    "name": "Trusted Clean Maximum 220 PSI Heated Extractor — 17 Gallon",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-maximum-220-psi-heated-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 3299,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-maximum-220-psi-heated-extractor.jpg?v=1782204846",
    "searchKeywords": "",
    "sku": "TC-MAX220",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-cleanfreak-500-psi-commercial-extractor",
    "name": "CleanFreak 500 PSI Commercial Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-500-psi-commercial-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 2999,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-500-psi-commercial-extractor.jpg?v=1782204849",
    "searchKeywords": "",
    "sku": "CF-500NH",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-mytee-220-psi-extractor-25ft-hose",
    "name": "Mytee 220 PSI Carpet Extractor with 25' Hose Package",
    "url": "https://thecleaningbusiness.com/products/mytee-220-psi-extractor-25ft-hose",
    "type": "product",
    "productCategory": "machine",
    "price": 3499,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-220-psi-extractor-25ft-hose.jpg?v=1782204853",
    "searchKeywords": "",
    "sku": "MYT-220PKG",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-sandia-sniper-100-psi-heated-extractor",
    "name": "Sandia Sniper 100 PSI Heated Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/sandia-sniper-100-psi-heated-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 2599,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sandia-sniper-100-psi-heated-extractor.jpg?v=1782204857",
    "searchKeywords": "",
    "sku": "SN-S100HT",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-cleanfreak-120-psi-non-heated-12-gallon-extractor",
    "name": "CleanFreak 120 PSI Non-Heated 12 Gallon Box Extractor",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-120-psi-non-heated-12-gallon-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 2199,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-120-psi-non-heated-12-gallon-extractor.jpg?v=1782204861",
    "searchKeywords": "",
    "sku": "CF-120NH",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "chemical-cleanfreak-extraction-care-carpet-upholstery-cleaner-2-5-gal",
    "name": "CleanFreak Extraction Care Carpet & Upholstery Cleaner (2.5 Gallon FlexMax Pouch)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-extraction-care-carpet-upholstery-cleaner-2-5-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 62.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-extraction-care-carpet-upholstery-cleaner-2-5-gal.jpg?v=1782204864",
    "searchKeywords": "",
    "sku": "MPL-0924-125P",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "part-cleanfreak-defoamer-vacuum-motor-protectant-2-5-gal",
    "name": "CleanFreak Defoamer Vacuum Motor Protectant (2.5 Gallon FlexMax Pouch)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-defoamer-vacuum-motor-protectant-2-5-gal",
    "type": "product",
    "productCategory": "part",
    "price": 78.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-defoamer-vacuum-motor-protectant-2-5-gal.jpg?v=1782204868",
    "searchKeywords": "",
    "sku": "MPL-0950-125P",
    "bestFor": [
      "carpet_extraction",
      "daily_vacuuming",
      "carpet",
      "parts",
      "carpet_extractor",
      "15000_plus",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-extraction-rinse-carpet-cleaner-2-5-gal",
    "name": "CleanFreak Extraction Rinse Carpet Cleaner (2.5 Gallon FlexMax Pouch)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-extraction-rinse-carpet-cleaner-2-5-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 58.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-extraction-rinse-carpet-cleaner-2-5-gal.svg?v=1782205165",
    "searchKeywords": "",
    "sku": "MPL-0925-125P",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-prespray-traffic-lane-cleaner-1-gal",
    "name": "CleanFreak Prespray Traffic Lane Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-prespray-traffic-lane-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 36.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-prespray-traffic-lane-cleaner-1-gal.jpg?v=1782204872",
    "searchKeywords": "",
    "sku": "MPL-0901-1G",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-urine-odor-neutralizer-1-gal",
    "name": "CleanFreak Urine Odor Neutralizer (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-urine-odor-neutralizer-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 44.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-urine-odor-neutralizer-1-gal.svg?v=1782205170",
    "searchKeywords": "",
    "sku": "MPL-0930-1G",
    "bestFor": [
      "carpet_extraction",
      "odor_control",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-enzyme-digestant-carpet-cleaner-1-gal",
    "name": "CleanFreak Enzyme Digestant Carpet Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-enzyme-digestant-carpet-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 39.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-enzyme-digestant-carpet-cleaner-1-gal.svg?v=1782205175",
    "searchKeywords": "",
    "sku": "MPL-0935-1G",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-winterizing-windshield-washer-fluid-1-gal-2-pack",
    "name": "Winterizing Windshield Washer Fluid (1 Gallon, 2-Pack)",
    "url": "https://thecleaningbusiness.com/products/winterizing-windshield-washer-fluid-1-gal-2-pack",
    "type": "product",
    "productCategory": "machine",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/winterizing-windshield-washer-fluid-1-gal-2-pack.svg?v=1782205180",
    "searchKeywords": "",
    "sku": "TCB-WWF-2G",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-8400-stainless-steel-upholstery-tool-4-inch",
    "name": "Mytee #8400 Stainless Steel Upholstery Tool — 4\" Head",
    "url": "https://thecleaningbusiness.com/products/mytee-8400-stainless-steel-upholstery-tool-4-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 169,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-8400-stainless-steel-upholstery-tool-4-inch.png?v=1782204876",
    "searchKeywords": "",
    "sku": "MYT-8400",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-8400g-glider-upholstery-tool-4-inch",
    "name": "Mytee #8400G Glider Upholstery Tool — 4\" Head",
    "url": "https://thecleaningbusiness.com/products/mytee-8400g-glider-upholstery-tool-4-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 149,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-8400g-glider-upholstery-tool-4-inch.jpg?v=1782204879",
    "searchKeywords": "",
    "sku": "MYT-8400G",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-t-rex-12-inch-dual-jet-drag-wand",
    "name": "Mytee T-Rex 12\" Dual Jet Drag Wand",
    "url": "https://thecleaningbusiness.com/products/mytee-t-rex-12-inch-dual-jet-drag-wand",
    "type": "product",
    "productCategory": "machine",
    "price": 289,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-t-rex-12-inch-dual-jet-drag-wand.png?v=1782204883",
    "searchKeywords": "",
    "sku": "MYT-TREX12",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-15-foot-crush-proof-vac-solution-hose",
    "name": "Mytee 15' Crush-Proof Vacuum & Solution Hose Combo",
    "url": "https://thecleaningbusiness.com/products/mytee-15-foot-crush-proof-vac-solution-hose",
    "type": "product",
    "productCategory": "machine",
    "price": 189,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-15-foot-crush-proof-vac-solution-hose.png?v=1782204887",
    "searchKeywords": "",
    "sku": "MYT-H15V",
    "bestFor": [
      "carpet_extraction",
      "daily_vacuuming",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-25-foot-extension-solution-hose",
    "name": "Mytee 25' Extension Solution Hose",
    "url": "https://thecleaningbusiness.com/products/mytee-25-foot-extension-solution-hose",
    "type": "product",
    "productCategory": "machine",
    "price": 129,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-25-foot-extension-solution-hose.png?v=1782204890",
    "searchKeywords": "",
    "sku": "MYT-H25S",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-h141v-hose-connector-adapter",
    "name": "Mytee #H141V Hose Connector Adapter (1.5\" to 2\")",
    "url": "https://thecleaningbusiness.com/products/mytee-h141v-hose-connector-adapter",
    "type": "product",
    "productCategory": "machine",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-h141v-hose-connector-adapter.png?v=1782204894",
    "searchKeywords": "",
    "sku": "MYT-H141V",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-air-lite-upholstery-tool",
    "name": "Mytee Air Lite Upholstery Tool",
    "url": "https://thecleaningbusiness.com/products/mytee-air-lite-upholstery-tool",
    "type": "product",
    "productCategory": "machine",
    "price": 119,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-air-lite-upholstery-tool.png?v=1782204898",
    "searchKeywords": "",
    "sku": "MYT-ARLITE",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-6-inch-upholstery-hand-tool",
    "name": "Mytee 6\" Upholstery Hand Tool",
    "url": "https://thecleaningbusiness.com/products/mytee-6-inch-upholstery-hand-tool",
    "type": "product",
    "productCategory": "machine",
    "price": 89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-6-inch-upholstery-hand-tool.png?v=1782204901",
    "searchKeywords": "",
    "sku": "MYT-8600",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "part-mytee-vacuum-motor-gasket-kit-2002cs",
    "name": "Mytee Vacuum Motor Gasket Kit (2002CS / 2008CS)",
    "url": "https://thecleaningbusiness.com/products/mytee-vacuum-motor-gasket-kit-2002cs",
    "type": "product",
    "productCategory": "part",
    "price": 18.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-vacuum-motor-gasket-kit-2002cs.png?v=1782204905",
    "searchKeywords": "",
    "sku": "MYT-GSK2002",
    "bestFor": [
      "carpet_extraction",
      "daily_vacuuming",
      "maintenance",
      "carpet",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "part-mytee-pump-diaphragm-replacement-kit",
    "name": "Mytee Pump Diaphragm Replacement Kit (120 PSI)",
    "url": "https://thecleaningbusiness.com/products/mytee-pump-diaphragm-replacement-kit",
    "type": "product",
    "productCategory": "part",
    "price": 34.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-pump-diaphragm-replacement-kit.png?v=1782204910",
    "searchKeywords": "",
    "sku": "MYT-DIA120",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-mytee-inline-heater-element-1200w",
    "name": "Mytee In-Line Heater Element — 1200W",
    "url": "https://thecleaningbusiness.com/products/mytee-inline-heater-element-1200w",
    "type": "product",
    "productCategory": "part",
    "price": 89.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-inline-heater-element-1200w.png?v=1782204915",
    "searchKeywords": "",
    "sku": "MYT-HT1200",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-mytee-vacuum-switch-assembly-2002cs",
    "name": "Mytee Vacuum Switch Assembly (2002CS Series)",
    "url": "https://thecleaningbusiness.com/products/mytee-vacuum-switch-assembly-2002cs",
    "type": "product",
    "productCategory": "part",
    "price": 42.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-vacuum-switch-assembly-2002cs.png?v=1782204919",
    "searchKeywords": "",
    "sku": "MYT-SWV2002",
    "bestFor": [
      "carpet_extraction",
      "daily_vacuuming",
      "maintenance",
      "carpet",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "part-commercial-carpet-dryer-air-mover-3-speed",
    "name": "XPOWER X-800TF 3-Speed Commercial Air Mover — Timer & Filter Kit",
    "url": "https://thecleaningbusiness.com/products/commercial-carpet-dryer-air-mover-3-speed",
    "type": "product",
    "productCategory": "part",
    "price": 349,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/commercial-carpet-dryer-air-mover-3-speed.jpg?v=1782204923",
    "searchKeywords": "",
    "sku": "800X800TF",
    "bestFor": [
      "maintenance",
      "carpet",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "machine-trusted-clean-dura-17-floor-scrubber-13-gallon",
    "name": "Trusted Clean Dura 17 Electric Auto Floor Scrubber w/ Pad Driver — 13 Gallons",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-dura-17-floor-scrubber-13-gallon",
    "type": "product",
    "productCategory": "machine",
    "price": 1899.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-dura-17-floor-scrubber-13-gallon.jpg?v=1782204928",
    "searchKeywords": "",
    "sku": "CPL-DURA-17C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-trusted-clean-dura-20-floor-scrubber",
    "name": "Trusted Clean Dura 20 Automatic Floor Scrubber w/ Pad Driver",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-dura-20-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 4199.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-dura-20-floor-scrubber.jpg?v=1782204932",
    "searchKeywords": "",
    "sku": "CPL-DURA-20",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-cleanfreak-easysweep-carpet-floor-vacuum-sweeper",
    "name": "CleanFreak EasySweep Carpet & Floor Vacuum Sweeper",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-easysweep-carpet-floor-vacuum-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 2299.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-easysweep-carpet-floor-vacuum-sweeper.jpg?v=1782204937",
    "searchKeywords": "",
    "sku": "IES-TK464-Y2",
    "bestFor": [
      "daily_vacuuming",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "commercial_vacuum",
      "sweeper"
    ]
  },
  {
    "id": "machine-cleanfreak-17-heavy-duty-floor-buffer",
    "name": "CleanFreak 17\" Heavy Duty Floor Buffer w/ Pad Driver",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-17-heavy-duty-floor-buffer",
    "type": "product",
    "productCategory": "machine",
    "price": 924.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-17-heavy-duty-floor-buffer.jpg?v=1782204942",
    "searchKeywords": "",
    "sku": "CPL-225FP-17-RH-CF",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "floor_buffer",
      "under_1000"
    ]
  },
  {
    "id": "part-cleanfreak-20-high-speed-floor-burnisher-1500-rpm",
    "name": "CleanFreak 20\" High Speed Floor Burnisher w/ 1.5 HP Motor — 1,500 RPM",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-20-high-speed-floor-burnisher-1500-rpm",
    "type": "product",
    "productCategory": "part",
    "price": 974.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-20-high-speed-floor-burnisher-1500-rpm.jpg?v=1782204946",
    "searchKeywords": "",
    "sku": "KOB-00-4430-5",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "parts",
      "burnisher",
      "under_1000"
    ]
  },
  {
    "id": "machine-trusted-clean-quench-18-gallon-wet-vacuum",
    "name": "Trusted Clean Quench Wet Push Vacuum — 18 Gallons",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-quench-18-gallon-wet-vacuum",
    "type": "product",
    "productCategory": "machine",
    "price": 924.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-quench-18-gallon-wet-vacuum.jpg?v=1782204950",
    "searchKeywords": "",
    "sku": "CPL-18VAC-24SQ",
    "bestFor": [
      "daily_vacuuming",
      "commercial_vacuum",
      "wet_dry",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-heated-carpet-spot-cleaner-3-gallon",
    "name": "CleanFreak Heated Carpet Spot Cleaner w/ 4\" Stainless Steel Tool — 3 Gallons",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-heated-carpet-spot-cleaner-3-gallon",
    "type": "product",
    "productCategory": "chemical",
    "price": 899.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-heated-carpet-spot-cleaner-3-gallon.jpg?v=1782204954",
    "searchKeywords": "",
    "sku": "SAN-CF-3-H",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-commercial-carpet-spot-machine-3-gallon",
    "name": "CleanFreak Commercial Carpet Spot Cleaning Machine w/ 4\" Plastic Hand Tool — 3 Gallons",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-commercial-carpet-spot-machine-3-gallon",
    "type": "product",
    "productCategory": "chemical",
    "price": 599.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-commercial-carpet-spot-machine-3-gallon.jpg?v=1782204958",
    "searchKeywords": "",
    "sku": "SAN-CF-3",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "part-cleanfreak-flood-master-portable-flood-pumper",
    "name": "CleanFreak Flood Master Portable Flood Pumper & Extractor",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-flood-master-portable-flood-pumper",
    "type": "product",
    "productCategory": "part",
    "price": 2499.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-flood-master-portable-flood-pumper.jpg?v=1782204962",
    "searchKeywords": "",
    "sku": "CPL-CF-FM",
    "bestFor": [
      "carpet_extraction",
      "parts",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-cleanfreak-oscillating-floor-machine-14x20",
    "name": "CleanFreak Oscillating Floor Machine (14\" x 20\" Head)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-oscillating-floor-machine-14x20",
    "type": "product",
    "productCategory": "machine",
    "price": 1599.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-oscillating-floor-machine-14x20.jpg?v=1782204966",
    "searchKeywords": "",
    "sku": "KOB-00-4503-9",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor"
    ]
  },
  {
    "id": "part-trusted-clean-dura-18hd-floor-scrubber-9-gallon",
    "name": "Trusted Clean Dura 18HD Cord Electric 18\" Automatic Floor Scrubber w/ Brush — 9 Gallons",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-dura-18hd-floor-scrubber-9-gallon",
    "type": "product",
    "productCategory": "part",
    "price": 1999.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-dura-18hd-floor-scrubber-9-gallon.jpg?v=1782204969",
    "searchKeywords": "",
    "sku": "TPL-DURA-18HD",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "part-cleanfreak-17-auto-scrubber-floor-cleaning-package",
    "name": "CleanFreak 17\" Electric Auto Scrubber Floor Cleaning Package w/ Brush, Pads & Chemicals",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-17-auto-scrubber-floor-cleaning-package",
    "type": "product",
    "productCategory": "part",
    "price": 2352.91,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-17-auto-scrubber-floor-cleaning-package.jpg?v=1782204974",
    "searchKeywords": "",
    "sku": "ASP-PACKAGE4",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-sandia-super-scout-6-gallon-portable-extractor",
    "name": "Sandia Super Scout 6 Gallon Portable Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/sandia-super-scout-6-gallon-portable-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 1299,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sandia-super-scout-6-gallon-portable-extractor.jpg?v=1782204978",
    "searchKeywords": "",
    "sku": "SAN-SCOUT-6",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-mytee-lite-ii-5-gallon-portable-extractor",
    "name": "Mytee Lite II 5 Gallon Portable Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/mytee-lite-ii-5-gallon-portable-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 1199,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-lite-ii-5-gallon-portable-extractor.jpg?v=1782204982",
    "searchKeywords": "",
    "sku": "MYT-LITE-II",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-cleanfreak-3000-psi-gas-pressure-washer",
    "name": "CleanFreak 3000 PSI Commercial Pressure Washer — Gas Powered",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-3000-psi-gas-pressure-washer",
    "type": "product",
    "productCategory": "machine",
    "price": 899.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-3000-psi-gas-pressure-washer.jpg?v=1782204986",
    "searchKeywords": "",
    "sku": "CPL-PW-3000",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-cleanfreak-4000-psi-gas-pressure-washer",
    "name": "CleanFreak 4000 PSI Commercial Pressure Washer — Gas Powered",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-4000-psi-gas-pressure-washer",
    "type": "product",
    "productCategory": "machine",
    "price": 1299.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-4000-psi-gas-pressure-washer.jpg?v=1782204990",
    "searchKeywords": "",
    "sku": "CPL-PW-4000",
    "bestFor": []
  },
  {
    "id": "machine-trusted-clean-dura-13-floor-scrubber",
    "name": "Trusted Clean Dura 13 Gallon Electric Auto Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/trusted-clean-dura-13-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 1699.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-dura-13-floor-scrubber.jpg?v=1782204994",
    "searchKeywords": "",
    "sku": "TPL-DURA-13",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-cleanfreak-10-gallon-wet-dry-shop-vacuum",
    "name": "CleanFreak 10 Gallon Wet/Dry Shop Vacuum",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-10-gallon-wet-dry-shop-vacuum",
    "type": "product",
    "productCategory": "machine",
    "price": 449.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-10-gallon-wet-dry-shop-vacuum.svg?v=1782205161",
    "searchKeywords": "",
    "sku": "CPL-10VAC",
    "bestFor": [
      "daily_vacuuming",
      "commercial_vacuum",
      "wet_dry",
      "under_1000"
    ]
  },
  {
    "id": "machine-cleanfreak-17-high-speed-burnisher-1500-rpm",
    "name": "CleanFreak 17\" High Speed Burnisher — 1,500 RPM",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-17-high-speed-burnisher-1500-rpm",
    "type": "product",
    "productCategory": "machine",
    "price": 849.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-17-high-speed-burnisher-1500-rpm.jpg?v=1782204999",
    "searchKeywords": "",
    "sku": "KOB-00-4429-5",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "under_1000"
    ]
  },
  {
    "id": "part-mytee-water-hog-flood-extractor-pump",
    "name": "Mytee Water Hog Flood Extractor & Pump",
    "url": "https://thecleaningbusiness.com/products/mytee-water-hog-flood-extractor-pump",
    "type": "product",
    "productCategory": "part",
    "price": 1899,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-water-hog-flood-extractor-pump.png?v=1782205003",
    "searchKeywords": "",
    "sku": "MYT-WATER-HOG",
    "bestFor": [
      "carpet_extraction",
      "parts",
      "carpet",
      "carpet_extractor",
      "15000_plus"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-34-disc-rider-autoscrubber-clk-56114031",
    "name": "Clarke Focus II 34\" Disc Rider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/clarke-focus-ii-34-disc-rider-autoscrubber-clk-56114031",
    "type": "product",
    "productCategory": "machine",
    "price": 26758,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Clarke-Focus-II-Rider-Autoscrubber-sm.jpg?v=1782184713",
    "searchKeywords": "Clarke, Focus, Disc, Rider, Autoscrubber",
    "sku": "CLK-56114031",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-focus-ii-28-boost-rider-autoscrubber-clk-56114020",
    "name": "Focus II 28\" BOOST Rider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/focus-ii-28-boost-rider-autoscrubber-clk-56114020",
    "type": "product",
    "productCategory": "machine",
    "price": 24922,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Focus-II-Boost-Rider-Auto-Srubber-sm.jpg?v=1782184723",
    "searchKeywords": "Focus, BOOST, Rider, Autoscrubber",
    "sku": "CLK-56114020",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-28-disc-rider-autoscrubber-clk-56114012",
    "name": "Clarke Focus II 28\" Disc Rider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/clarke-focus-ii-28-disc-rider-autoscrubber-clk-56114012",
    "type": "product",
    "productCategory": "machine",
    "price": 24660,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Clarke-Focus-II-Rider-Autoscrubber-sm_6fe0b00b-882a-404d-959c-82e40cad033d.jpg?v=1782184733",
    "searchKeywords": "Clarke, Focus, Disc, Rider, Autoscrubber",
    "sku": "CLK-56114012",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-focus-ii-28-boost-microrider-autoscrubber-clk-56382630",
    "name": "Focus II 28\" BOOST MicroRider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/focus-ii-28-boost-microrider-autoscrubber-clk-56382630",
    "type": "product",
    "productCategory": "machine",
    "price": 20660,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Focus-II-Boost-MicroRider-Auto-Scrubber-sm.jpg?v=1782184743",
    "searchKeywords": "Focus, BOOST, MicroRider, Autoscrubber",
    "sku": "CLK-56382630",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-focus-ii-26-disc-microrider-autoscrubber-clk-56382626",
    "name": "Focus II 26\" Disc MicroRider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/focus-ii-26-disc-microrider-autoscrubber-clk-56382626",
    "type": "product",
    "productCategory": "machine",
    "price": 19020,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Focus-II-Disc-MicroRider-Auto-Scrubber-sm.jpg?v=1782184753",
    "searchKeywords": "Focus, Disc, MicroRider, Autoscrubber",
    "sku": "CLK-56382626",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-viper-as850r-312-rider-auto-scrubber-32-cleaning-path-vp-as850r-312",
    "name": "Viper AS850R-312 Rider Auto Scrubber - 32\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as850r-312-rider-auto-scrubber-32-cleaning-path-vp-as850r-312",
    "type": "product",
    "productCategory": "machine",
    "price": 17239,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AS850R-OBC-242-sm.jpg?v=1782184763",
    "searchKeywords": "Viper, AS850R-312, Rider, Auto, Scrubber, Cleaning, Path",
    "sku": "VP-AS850R-312",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-viper-as850r-242-rider-auto-scrubber-32-cleaning-path-vp-as850r-242",
    "name": "Viper AS850R-242 Rider Auto Scrubber - 32\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as850r-242-rider-auto-scrubber-32-cleaning-path-vp-as850r-242",
    "type": "product",
    "productCategory": "machine",
    "price": 16466,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AS850R-OBC-242-sm_8d38a144-1fae-490a-bf4c-60e26eee475e.jpg?v=1782184773",
    "searchKeywords": "Viper, AS850R-242, Rider, Auto, Scrubber, Cleaning, Path",
    "sku": "VP-AS850R-242",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-viper-as710r-ride-on-auto-floor-scrubber-28-cleaning-path-vp-as710r",
    "name": "Viper AS710R Ride On Auto Floor Scrubber - 28\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as710r-ride-on-auto-floor-scrubber-28-cleaning-path-vp-as710r",
    "type": "product",
    "productCategory": "machine",
    "price": 16227,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AS430C-Electric-Automatic-Floor-Scrubber-sm.jpg?v=1782184783",
    "searchKeywords": "Viper, AS710R, Ride, Auto, Floor, Scrubber, Cleaning, Path",
    "sku": "VP-AS710R",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-3040qh-hot-water-gas-pressure-washer-cs-3040qh",
    "name": "3040QH Hot Water Gas Pressure Washer",
    "url": "https://www.thecleaningbusiness.com/products/3040qh-hot-water-gas-pressure-washer-cs-3040qh",
    "type": "product",
    "productCategory": "machine",
    "price": 10198.38,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Cam-Spray-527100-Pressure-Washer-Sprayer-Foamer-Attachment_sm.jpg?v=1782184793",
    "searchKeywords": "3040QH, Water, Pressure, Washer",
    "sku": "CS-3040QH",
    "bestFor": [
      "degreasing",
      "7500_15000"
    ]
  },
  {
    "id": "machine-viper-as530r-ride-on-auto-floor-scrubber-no-batteries-20-cleaning-path-vp-50000417",
    "name": "Viper AS530R Ride On Auto Floor Scrubber - No Batteries - 20\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as530r-ride-on-auto-floor-scrubber-no-batteries-20-cleaning-path-vp-50000417",
    "type": "product",
    "productCategory": "machine",
    "price": 9512,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Viper-AS710R-Rider-Auto-Scrubber-sm.jpg?v=1782184804",
    "searchKeywords": "Viper, AS530R, Ride, Auto, Floor, Scrubber, Batteries, Cleaning, Path",
    "sku": "VP-50000417",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-large-carpet-area-self-contained-carpet-cleaning-extractor-machine-mm-c8420-115",
    "name": "Large Carpet Area Self-Contained Carpet Cleaning Extractor Machine",
    "url": "https://www.thecleaningbusiness.com/products/large-carpet-area-self-contained-carpet-cleaning-extractor-machine-mm-c8420-115",
    "type": "product",
    "productCategory": "machine",
    "price": 8746.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/X-17-9-Gallon-Carpet-Extractor-sm.jpg?v=1782184814",
    "searchKeywords": "Large, Carpet, Area, Self-Contained, Carpet, Cleaning, Extractor, Machine",
    "sku": "MM-C8420-115",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "7500_15000"
    ]
  },
  {
    "id": "machine-supernova-1200psn-two-way-self-contained-extractor-dual-vac-12-gallon-1200psn",
    "name": "Supernova 1200PSN Two-Way Self Contained Extractor, Dual Vac- 12-Gallon",
    "url": "https://www.thecleaningbusiness.com/products/supernova-1200psn-two-way-self-contained-extractor-dual-vac-12-gallon-1200psn",
    "type": "product",
    "productCategory": "machine",
    "price": 7292,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1204ACH-Powermate-sm.jpg?v=1782184824",
    "searchKeywords": "Supernova, 1200PSN, Two-Way, Self, Contained, Extractor,, Dual, Vac-, 12-Gallon",
    "sku": "1200PSN",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-supernova-800psn-two-way-self-contained-extractor-dual-vac-8-gallon-800psn",
    "name": "Supernova 800PSN Two-Way Self Contained Extractor, Dual Vac - 8-Gallon",
    "url": "https://www.thecleaningbusiness.com/products/supernova-800psn-two-way-self-contained-extractor-dual-vac-8-gallon-800psn",
    "type": "product",
    "productCategory": "machine",
    "price": 7193,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1204ACH-Powermate-sm_dd084e55-d414-49e2-8245-4b82f1ffcef6.jpg?v=1782184834",
    "searchKeywords": "Supernova, 800PSN, Two-Way, Self, Contained, Extractor,, Dual, 8-Gallon",
    "sku": "800PSN",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-1500shde-oil-fired-hot-water-pressure-washer-1500-psi-cs-1500shde",
    "name": "1500SHDE Oil Fired Hot Water Pressure Washer - 1500 PSI",
    "url": "https://www.thecleaningbusiness.com/products/1500shde-oil-fired-hot-water-pressure-washer-1500-psi-cs-1500shde",
    "type": "product",
    "productCategory": "machine",
    "price": 7005.38,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Cam-Spray-527100-Pressure-Washer-Sprayer-Foamer-Attachment_sm_0e4d157a-3f1e-485e-ac24-05d2e0c709ef.jpg?v=1782184844",
    "searchKeywords": "1500SHDE, Fired, Water, Pressure, Washer, 1500",
    "sku": "CS-1500SHDE",
    "bestFor": [
      "degreasing",
      "3000_7500"
    ]
  },
  {
    "id": "machine-portable-diesel-fired-electric-powered-3-gpm-1000-psi-hot-water-pressure-washer-cs-1000shd",
    "name": "Portable Diesel Fired Electric Powered 3 gpm, 1000 psi Hot Water Pressure Washer",
    "url": "https://www.thecleaningbusiness.com/products/portable-diesel-fired-electric-powered-3-gpm-1000-psi-hot-water-pressure-washer-cs-1000shd",
    "type": "product",
    "productCategory": "machine",
    "price": 6589.98,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Cam-Spray-527100-Pressure-Washer-Sprayer-Foamer-Attachment_sm_7a66b1dc-d141-4e0f-8cf2-dbb8222779f3.jpg?v=1782184854",
    "searchKeywords": "Portable, Diesel, Fired, Electric, Powered, gpm,, 1000, Water, Pressure, Washer",
    "sku": "CS-1000SHDE",
    "bestFor": [
      "degreasing",
      "3000_7500"
    ]
  },
  {
    "id": "machine-28-walk-behind-floor-sweeper-kleen-sweep-ks28-mm-ks28bqp",
    "name": "28\" Walk-Behind Floor Sweeper - Kleen Sweep KS28",
    "url": "https://www.thecleaningbusiness.com/products/28-walk-behind-floor-sweeper-kleen-sweep-ks28-mm-ks28bqp",
    "type": "product",
    "productCategory": "machine",
    "price": 6090.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/25W-Kleen-Sweep-Carpet-Sweeper-sm.jpg?v=1782184864",
    "searchKeywords": "Walk-Behind, Floor, Sweeper, Kleen, Sweep, KS28",
    "sku": "MM-KS28BQP",
    "bestFor": [
      "hard_floor_scrubbing",
      "sweeper",
      "3000_7500"
    ]
  },
  {
    "id": "machine-bsw-28-floor-sweeper-28-floor-sweeping-path-clk-9084705010",
    "name": "BSW 28 Floor Sweeper - 28\" Floor Sweeping Path",
    "url": "https://www.thecleaningbusiness.com/products/bsw-28-floor-sweeper-28-floor-sweeping-path-clk-9084705010",
    "type": "product",
    "productCategory": "machine",
    "price": 5902,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1463016000-Wavy-Bristle-Main-Carpet-Broom-sm.jpg?v=1782184874",
    "searchKeywords": "Floor, Sweeper, Floor, Sweeping, Path",
    "sku": "CLK-9084705010",
    "bestFor": [
      "hard_floor_scrubbing",
      "sweeper",
      "3000_7500"
    ]
  },
  {
    "id": "machine-ex40-18lx-walk-behind-carpet-extractor-18-cleaning-path-clk-56265505",
    "name": "EX40 18LX Walk Behind Carpet Extractor - 18\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/ex40-18lx-walk-behind-carpet-extractor-18-cleaning-path-clk-56265505",
    "type": "product",
    "productCategory": "machine",
    "price": 5345.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ST-703-Low-Foam-Water-Extraction-Carpet-Cleaner-sm.jpg?v=1782184885",
    "searchKeywords": "EX40, 18LX, Walk, Behind, Carpet, Extractor, Cleaning, Path",
    "sku": "CLK-56265505",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-vantage-14-battery-powered-floor-scrubber-clk-9087345020",
    "name": "Clarke Vantage 14 Battery Powered Floor Scrubber",
    "url": "https://www.thecleaningbusiness.com/products/clarke-vantage-14-battery-powered-floor-scrubber-clk-9087345020",
    "type": "product",
    "productCategory": "machine",
    "price": 5181,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/14-Inch-White-Polishing-Floor-Pad-sm.jpg?v=1782184895",
    "searchKeywords": "Clarke, Vantage, Battery, Powered, Floor, Scrubber",
    "sku": "CLK-9087345020",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-3000xar-tube-cart-electric-series-pressure-washer-3000-psi-cs-3000xar",
    "name": "3000XAR Tube Cart Electric Series Pressure Washer - 3000 PSI",
    "url": "https://www.thecleaningbusiness.com/products/3000xar-tube-cart-electric-series-pressure-washer-3000-psi-cs-3000xar",
    "type": "product",
    "productCategory": "machine",
    "price": 5163.98,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2003-versamatic-replacement-filter-bags-sm.jpg?v=1782184905",
    "searchKeywords": "3000XAR, Tube, Cart, Electric, Series, Pressure, Washer, 3000",
    "sku": "CS-3000XAR",
    "bestFor": [
      "degreasing",
      "3000_7500"
    ]
  },
  {
    "id": "machine-polaris-1201ps-self-contained-extractor-12-gallon-1201ps",
    "name": "Polaris 1201PS Self Contained Extractor - 12-Gallon",
    "url": "https://www.thecleaningbusiness.com/products/polaris-1201ps-self-contained-extractor-12-gallon-1201ps",
    "type": "product",
    "productCategory": "machine",
    "price": 5110,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1204ACH-Powermate-sm_ab1fbb8c-15e5-4615-b672-0eadadff9911.jpg?v=1782184915",
    "searchKeywords": "Polaris, 1201PS, Self, Contained, Extractor, 12-Gallon",
    "sku": "1201PS",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-3000wm-ss-wall-mount-electric-pressure-washer-3000-psi-cs-3000wm-ss",
    "name": "3000WM/SS Wall Mount Electric Pressure Washer - 3000 PSI",
    "url": "https://www.thecleaningbusiness.com/products/3000wm-ss-wall-mount-electric-pressure-washer-3000-psi-cs-3000wm-ss",
    "type": "product",
    "productCategory": "machine",
    "price": 4977.98,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2000WM-SS-Wall-Mount-Electric-Pressure-Washer-sm.jpg?v=1782184925",
    "searchKeywords": "",
    "sku": "CS-3000WM/SS",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-3000wm-ss3-wall-mount-electric-pressure-washer-3000-psi-3-phase-cs-3000wm-ssm3",
    "name": "3000WM/SS3 Wall Mount Electric Pressure Washer - 3000 PSI, 3 Phase",
    "url": "https://www.thecleaningbusiness.com/products/3000wm-ss3-wall-mount-electric-pressure-washer-3000-psi-3-phase-cs-3000wm-ssm3",
    "type": "product",
    "productCategory": "machine",
    "price": 4897.38,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2000WM-SS-Wall-Mount-Electric-Pressure-Washer-sm_e8120707-79de-4eef-9250-bd500cdd7469.jpg?v=1782184936",
    "searchKeywords": "",
    "sku": "CS-3000WM/SSM3",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-stinger-20-battery-powered-automatic-floor-scrubber-20-uno-20fsb",
    "name": "Stinger 20 Battery Powered Automatic Floor Scrubber - 20\"",
    "url": "https://www.thecleaningbusiness.com/products/stinger-20-battery-powered-automatic-floor-scrubber-20-uno-20fsb",
    "type": "product",
    "productCategory": "machine",
    "price": 4847.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Stinger-Auto-Scrub-Floor-Cleaner-Packets-FC-727-SM.png?v=1782184946",
    "searchKeywords": "",
    "sku": "UNO-20FSB",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-stinger-battery-powered-automatic-floor-scrubber-20-uno-510b",
    "name": "Stinger Battery Powered Automatic Floor Scrubber - 20\"",
    "url": "https://www.thecleaningbusiness.com/products/stinger-battery-powered-automatic-floor-scrubber-20-uno-510b",
    "type": "product",
    "productCategory": "machine",
    "price": 4795,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Stinger-Auto-Scrub-Floor-Cleaner-Packets-FC-727-SM_dd7d8f36-2eef-48ee-986b-9a255167a7d0.png?v=1782184956",
    "searchKeywords": "",
    "sku": "UNO-510B",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-polaris-701ps-self-contained-extractor-7-gallon-701ps",
    "name": "Polaris 701PS Self Contained Extractor - 7-Gallon",
    "url": "https://www.thecleaningbusiness.com/products/polaris-701ps-self-contained-extractor-7-gallon-701ps",
    "type": "product",
    "productCategory": "machine",
    "price": 4348,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1204ACH-Powermate-sm_0335237a-db24-4b27-8c3d-ede9a56d7cac.jpg?v=1782184963",
    "searchKeywords": "",
    "sku": "701PS",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-2000wm-ss-wall-mount-electric-pressure-washer-2000-psi-cs-2000wm-ss",
    "name": "2000WM/SS Wall Mount Electric Pressure Washer - 2000 PSI",
    "url": "https://www.thecleaningbusiness.com/products/2000wm-ss-wall-mount-electric-pressure-washer-2000-psi-cs-2000wm-ss",
    "type": "product",
    "productCategory": "machine",
    "price": 4333.2,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2000WM-SS-Wall-Mount-Electric-Pressure-Washer-sm_564cc249-8782-4814-aa5c-88960d8ad571.jpg?v=1782184970",
    "searchKeywords": "",
    "sku": "CS-2000WM-SS",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-2000wm-ssm3-wall-mount-electric-pressure-washer-2000-psi-3-phase-cs-2000wm-ssm3",
    "name": "2000WM/SSM3 Wall Mount Electric Pressure Washer - 2000 PSI, 3 Phase",
    "url": "https://www.thecleaningbusiness.com/products/2000wm-ssm3-wall-mount-electric-pressure-washer-2000-psi-3-phase-cs-2000wm-ssm3",
    "type": "product",
    "productCategory": "machine",
    "price": 4333.2,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2000WM-SS-Wall-Mount-Electric-Pressure-Washer-sm_7ffd419a-b5f2-4d2e-a8cc-4871e4d3fda5.jpg?v=1782184976",
    "searchKeywords": "",
    "sku": "CS-2000WM/SSM3",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-ma50-15b-battery-powered-automatic-floor-scrubber-clk-clarke380b",
    "name": "Clarke MA50 15B Battery Powered Automatic Floor Scrubber",
    "url": "https://www.thecleaningbusiness.com/products/clarke-ma50-15b-battery-powered-automatic-floor-scrubber-clk-clarke380b",
    "type": "product",
    "productCategory": "machine",
    "price": 4248,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/VF89804-Viper-Fang-Pad-Driver-sm.jpg?v=1782184982",
    "searchKeywords": "",
    "sku": "CLK-CLARKE380B",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-floodbuster-flood-pumper-fb50",
    "name": "FloodBuster Flood Pumper",
    "url": "https://www.thecleaningbusiness.com/products/floodbuster-flood-pumper-fb50",
    "type": "product",
    "productCategory": "part",
    "price": 4132,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/628422-Twist-Tie-Contractor-Cleanup-Bags-sm.jpg?v=1782184989",
    "searchKeywords": "",
    "sku": "FB50",
    "bestFor": [
      "parts",
      "3000_7500"
    ]
  },
  {
    "id": "machine-ex40-16st-self-contained-carpet-extractor-16-cleaning-path-clk-56265504",
    "name": "EX40 16ST Self-Contained Carpet Extractor - 16\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/ex40-16st-self-contained-carpet-extractor-16-cleaning-path-clk-56265504",
    "type": "product",
    "productCategory": "machine",
    "price": 4002,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ST-703-Low-Foam-Water-Extraction-Carpet-Cleaner-sm_c0e83364-6a32-477c-869b-0ef4db957083.jpg?v=1782184996",
    "searchKeywords": "",
    "sku": "CLK-56265504",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-2000xar-tube-cart-electric-series-pressure-washer-2000-psi-cs-2000xar",
    "name": "2000XAR Tube Cart Electric Series Pressure Washer - 2000 PSI",
    "url": "https://www.thecleaningbusiness.com/products/2000xar-tube-cart-electric-series-pressure-washer-2000-psi-cs-2000xar",
    "type": "product",
    "productCategory": "machine",
    "price": 3576.78,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2000XAR-Cam-Spray-2000XAR-Tube-Cart-Electric-Series-Pressure-Washer-2000-PSI_sm.jpg?v=1782185002",
    "searchKeywords": "",
    "sku": "CS-2000XAR",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-kleen-sweep-carpet-sweeper-ks25wqp-mm-ks25wqp",
    "name": "Kleen Sweep Carpet Sweeper KS25WQP",
    "url": "https://www.thecleaningbusiness.com/products/kleen-sweep-carpet-sweeper-ks25wqp-mm-ks25wqp",
    "type": "product",
    "productCategory": "machine",
    "price": 3425.04,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/25W-Kleen-Sweep-Carpet-Sweeper-sm_5b81683b-efa8-4bd6-9c4a-07015bd75db4.jpg?v=1782185009",
    "searchKeywords": "",
    "sku": "MM-KS25WQP",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "sweeper",
      "3000_7500"
    ]
  },
  {
    "id": "machine-mytee-7000lx-flood-hog-flood-extractor-12-gallon-my7000lx",
    "name": "Mytee 7000LX Flood Hog Flood Extractor - 12 Gallon",
    "url": "https://www.thecleaningbusiness.com/products/mytee-7000lx-flood-hog-flood-extractor-12-gallon-my7000lx",
    "type": "product",
    "productCategory": "machine",
    "price": 3260,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/A138-Flood-Hog-Accessory-Kit-sm.jpg?v=1782185016",
    "searchKeywords": "",
    "sku": "MY7000LX",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-ice-18-electric-automatic-floor-scrubber-uno-18fse-ice",
    "name": "ICE 18\" Electric Automatic Floor Scrubber",
    "url": "https://www.thecleaningbusiness.com/products/ice-18-electric-automatic-floor-scrubber-uno-18fse-ice",
    "type": "product",
    "productCategory": "machine",
    "price": 3195,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Americo-Red-Buffing-Floor-Pad-sm.jpg?v=1782185022",
    "searchKeywords": "",
    "sku": "UNO-18FSE-ICE",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-1500wm-ss3-wall-mount-electric-pressure-washer-1500-psi-3-phase-cs-1500wm-ss3",
    "name": "1500WM/SS3 Wall Mount Electric Pressure Washer - 1500 PSI, 3 Phase",
    "url": "https://www.thecleaningbusiness.com/products/1500wm-ss3-wall-mount-electric-pressure-washer-1500-psi-3-phase-cs-1500wm-ss3",
    "type": "product",
    "productCategory": "machine",
    "price": 3161.38,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1000WMSS-Wall-Mount-Electric-Pressure-Washer-sm.jpg?v=1782185029",
    "searchKeywords": "",
    "sku": "CS-1500WM-SS3",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-1500wm-ss-wall-mount-electric-pressure-washer-1500-psi-cs-1500wm-ss",
    "name": "1500WM/SS Wall Mount Electric Pressure Washer - 1500 PSI",
    "url": "https://www.thecleaningbusiness.com/products/1500wm-ss-wall-mount-electric-pressure-washer-1500-psi-cs-1500wm-ss",
    "type": "product",
    "productCategory": "machine",
    "price": 3086.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1000WMSS-Wall-Mount-Electric-Pressure-Washer-sm_30263e25-9fe0-44ab-82c7-f2efef4f2f17.jpg?v=1782185036",
    "searchKeywords": "",
    "sku": "CS-1500WM-SS",
    "bestFor": [
      "3000_7500"
    ]
  },
  {
    "id": "machine-stinger-electric-automatic-floor-scrubber-17-uno-17fse",
    "name": "Stinger Electric Automatic Floor Scrubber - 17\"",
    "url": "https://www.thecleaningbusiness.com/products/stinger-electric-automatic-floor-scrubber-17-uno-17fse",
    "type": "product",
    "productCategory": "machine",
    "price": 3082.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Fang-20-Polypropylene-Scrubbing-Brush-sm.jpg?v=1782185042",
    "searchKeywords": "",
    "sku": "UNO-17FSE",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-clarke-vf91040-polypropylene-brush-clk-vf91040",
    "name": "Clarke VF91040 Polypropylene Brush",
    "url": "https://www.thecleaningbusiness.com/products/clarke-vf91040-polypropylene-brush-clk-vf91040",
    "type": "product",
    "productCategory": "part",
    "price": 195.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Fang-20-Polypropylene-Scrubbing-Brush-sm_c99b91e5-44cd-404e-ba7a-7a6ccecde0c8.jpg?v=1782185092",
    "searchKeywords": "",
    "sku": "CLK-VF91040",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "accessory-cam-spray-526575-swivel-hose-reel-wall-mount-bracket-cs-526575",
    "name": "Cam Spray 526575 Swivel Hose Reel Wall Mount Bracket",
    "url": "https://www.thecleaningbusiness.com/products/cam-spray-526575-swivel-hose-reel-wall-mount-bracket-cs-526575",
    "type": "product",
    "productCategory": "accessory",
    "price": 62.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Swivel-Pressure-Washer-Hose-Reel-Kit-100_sm.jpg?v=1782185099",
    "searchKeywords": "",
    "sku": "CS-526575",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "machine-pressure-washer-sprayer-foamer-attachment-cs-527100m",
    "name": "Pressure Washer Sprayer Foamer Attachment",
    "url": "https://www.thecleaningbusiness.com/products/pressure-washer-sprayer-foamer-attachment-cs-527100m",
    "type": "product",
    "productCategory": "machine",
    "price": 147.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Bio-Enzymatic-Chute-Dumpster-Deodorizing-Cleaner-1-Gallon-sm.jpg?v=1782185106",
    "searchKeywords": "",
    "sku": "CS-527100M",
    "bestFor": [
      "maintenance",
      "under_1000"
    ]
  },
  {
    "id": "part-camspray-gen-d30001kit-50-capacity-pressure-washer-hose-reel-cs-gen-d30001",
    "name": "CamSpray GEN D30001KIT 50' Capacity Pressure Washer Hose Reel",
    "url": "https://www.thecleaningbusiness.com/products/camspray-gen-d30001kit-50-capacity-pressure-washer-hose-reel-cs-gen-d30001",
    "type": "product",
    "productCategory": "part",
    "price": 200.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/HM550-Heavy-Duty-Water-Wand-Floor-Squeegee-22-Inch-sm.jpg?v=1782185112",
    "searchKeywords": "",
    "sku": "CS-GEN-D30001",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-cam-spray-gen-d30002kit-100-capacity-pressure-washer-hose-reel-cs-gen-d30002",
    "name": "Cam Spray GEN D30002KIT 100' Capacity Pressure Washer Hose Reel",
    "url": "https://www.thecleaningbusiness.com/products/cam-spray-gen-d30002kit-100-capacity-pressure-washer-hose-reel-cs-gen-d30002",
    "type": "product",
    "productCategory": "part",
    "price": 211.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/HM550-Heavy-Duty-Water-Wand-Floor-Squeegee-22-Inch-sm_c81a383b-7813-499d-8fc9-e8127ad9acb7.jpg?v=1782185118",
    "searchKeywords": "",
    "sku": "CS-GEN-D30002",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "machine-cam-spray-527660-100-pressure-washer-hose-extension-cs-527660",
    "name": "Cam Spray 527660 100' Pressure Washer Hose Extension",
    "url": "https://www.thecleaningbusiness.com/products/cam-spray-527660-100-pressure-washer-hose-extension-cs-527660",
    "type": "product",
    "productCategory": "machine",
    "price": 230.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/HM550-Heavy-Duty-Water-Wand-Floor-Squeegee-22-Inch-sm_03cd1856-5507-4c42-b854-4f8a586cb705.jpg?v=1782185146",
    "searchKeywords": "",
    "sku": "CS-527660",
    "bestFor": [
      "maintenance",
      "under_1000"
    ]
  },
  {
    "id": "machine-100-capacity-swivel-pressure-washer-hose-reel-cs-526496-1kit",
    "name": "100' Capacity Swivel Pressure Washer Hose Reel",
    "url": "https://www.thecleaningbusiness.com/products/100-capacity-swivel-pressure-washer-hose-reel-cs-526496-1kit",
    "type": "product",
    "productCategory": "machine",
    "price": 653.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Swivel-Pressure-Washer-Hose-Reel-Kit-200_sm.jpg?v=1782185173",
    "searchKeywords": "",
    "sku": "CS-526496-1KIT",
    "bestFor": [
      "maintenance",
      "under_1000"
    ]
  },
  {
    "id": "part-cam-spray-526496-kit-200-capacity-swivel-pressure-washer-hose-reel-cs-526496-kit",
    "name": "Cam Spray 526496.KIT 200' Capacity Swivel Pressure Washer Hose Reel",
    "url": "https://www.thecleaningbusiness.com/products/cam-spray-526496-kit-200-capacity-swivel-pressure-washer-hose-reel-cs-526496-kit",
    "type": "product",
    "productCategory": "part",
    "price": 730.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Swivel-Pressure-Washer-Hose-Reel-Kit-100_sm_eca91743-c741-4e18-988f-79f8c7c28cfd.jpg?v=1782185190",
    "searchKeywords": "",
    "sku": "CS-526496.KIT",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "machine-341ac-8-vacuum-hose-solution-hose-assembly-341ac",
    "name": "341AC 8' Vacuum Hose & Solution Hose Assembly",
    "url": "https://www.thecleaningbusiness.com/products/341ac-8-vacuum-hose-solution-hose-assembly-341ac",
    "type": "product",
    "productCategory": "machine",
    "price": 93,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/401TR-Fivestar-Self-Contained-Carpet-Box-Extractor-sm.jpg?v=1782185217",
    "searchKeywords": "",
    "sku": "341AC",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "accessory-19-pad-driver-w-molded-in-clutch-plate-1903br",
    "name": "19\" Pad Driver w/ Molded-in Clutch Plate",
    "url": "https://www.thecleaningbusiness.com/products/19-pad-driver-w-molded-in-clutch-plate-1903br",
    "type": "product",
    "productCategory": "accessory",
    "price": 97,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/20HS2000-BK-High-Speed-Burnisher-sm.jpg?v=1782185223",
    "searchKeywords": "",
    "sku": "1903BR",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-1039ac-stainless-steel-auto-detailer-tool-1-5-diameter-1039-9502fb",
    "name": "1039AC Stainless Steel Auto Detailer Tool - 1.5\" Diameter",
    "url": "https://www.thecleaningbusiness.com/products/1039ac-stainless-steel-auto-detailer-tool-1-5-diameter-1039-9502fb",
    "type": "product",
    "productCategory": "accessory",
    "price": 125,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2540AC-Hose-Assembly-sm.jpg?v=1782185229",
    "searchKeywords": "",
    "sku": "1039-9502FB",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-edic-1037ac-clear-plastic-detailer-tool-edic-1037ac",
    "name": "EDIC 1037AC Clear Plastic Detailer Tool",
    "url": "https://www.thecleaningbusiness.com/products/edic-1037ac-clear-plastic-detailer-tool-edic-1037ac",
    "type": "product",
    "productCategory": "accessory",
    "price": 133,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/500BX-EH-Auto-Detailer-sm.jpg?v=1782185242",
    "searchKeywords": "",
    "sku": "EDIC-1037AC",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-988cs-circuit-locator-988cs",
    "name": "988CS Circuit Locator",
    "url": "https://www.thecleaningbusiness.com/products/988cs-circuit-locator-988cs",
    "type": "product",
    "productCategory": "accessory",
    "price": 145,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/9000I-HS-Box-Extractor-sm.jpg?v=1782185248",
    "searchKeywords": "",
    "sku": "988CS",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-circuit-locator-w-2-wall-outlets-989cs",
    "name": "Circuit Locator w/ 2 Wall Outlets",
    "url": "https://www.thecleaningbusiness.com/products/circuit-locator-w-2-wall-outlets-989cs",
    "type": "product",
    "productCategory": "accessory",
    "price": 145,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/988CS-Circuit-Locator-sm.jpg?v=1782185254",
    "searchKeywords": "",
    "sku": "989CS",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-9000ac-high-pressure-spray-gun-9000ac",
    "name": "9000AC High Pressure Spray Gun",
    "url": "https://www.thecleaningbusiness.com/products/9000ac-high-pressure-spray-gun-9000ac",
    "type": "product",
    "productCategory": "accessory",
    "price": 156,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/9000I-HS-Box-Extractor-sm_8d3a440e-24b3-4cd7-8c4e-8ed53a8d53c9.jpg?v=1782185260",
    "searchKeywords": "",
    "sku": "9000AC",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "part-839ack-upholstery-tool-hose-assembly-kit-839ack",
    "name": "839ACK Upholstery Tool & Hose Assembly Kit",
    "url": "https://www.thecleaningbusiness.com/products/839ack-upholstery-tool-hose-assembly-kit-839ack",
    "type": "product",
    "productCategory": "part",
    "price": 224,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Bravo-Carpet-Spotting-Kit-sm.jpg?v=1782185267",
    "searchKeywords": "",
    "sku": "839ACK",
    "bestFor": [
      "maintenance",
      "carpet",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-357ac-fivestar-extractor-upholstery-tool-kit-357ac",
    "name": "357AC Fivestar Extractor Upholstery Tool Kit",
    "url": "https://www.thecleaningbusiness.com/products/357ac-fivestar-extractor-upholstery-tool-kit-357ac",
    "type": "product",
    "productCategory": "part",
    "price": 307,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/401TR-Fivestar-Self-Contained-Carpet-Box-Extractor-sm_c6e0c5ba-381d-4c39-aabc-fa16829d9966.jpg?v=1782185273",
    "searchKeywords": "",
    "sku": "357AC",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "parts",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-edic-358ac-polaris-extractor-upholstery-tool-hose-hose-bag-358ac",
    "name": "EDIC 358AC Polaris Extractor Upholstery Tool, Hose & Hose Bag",
    "url": "https://www.thecleaningbusiness.com/products/edic-358ac-polaris-extractor-upholstery-tool-hose-hose-bag-358ac",
    "type": "product",
    "productCategory": "machine",
    "price": 367,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/701PS-Polaris-Self-Contained-Extractor-sm.jpg?v=1782185278",
    "searchKeywords": "",
    "sku": "358AC",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "part-single-jet-tool-kit-12-wand-15-hose-assembly-1533ack",
    "name": "Single Jet Tool Kit - 12\" Wand & 15' Hose Assembly",
    "url": "https://www.thecleaningbusiness.com/products/single-jet-tool-kit-12-wand-15-hose-assembly-1533ack",
    "type": "product",
    "productCategory": "part",
    "price": 406,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Single-Jet-Wand-sm.jpg?v=1782185284",
    "searchKeywords": "",
    "sku": "1533ACK",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "accessory-334ach-aluminum-squeegee-wand-1-5-dia-334ach",
    "name": "334ACH Aluminum Squeegee Wand - 1.5\" Dia.",
    "url": "https://www.thecleaningbusiness.com/products/334ach-aluminum-squeegee-wand-1-5-dia-334ach",
    "type": "product",
    "productCategory": "accessory",
    "price": 422,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Single-Jet-Wand-sm_8164dd99-1f5b-4acb-a6ce-ec49a6752a87.jpg?v=1782185290",
    "searchKeywords": "",
    "sku": "334ACH",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "part-dual-jet-tool-kit-12-s-bend-wand-25-hose-assembly-2534ack",
    "name": "Dual Jet Tool Kit - 12\" S-Bend Wand & 25' Hose Assembly",
    "url": "https://www.thecleaningbusiness.com/products/dual-jet-tool-kit-12-s-bend-wand-25-hose-assembly-2534ack",
    "type": "product",
    "productCategory": "part",
    "price": 482,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2540AC-Hose-Assembly-sm_b9cddefc-13dd-473d-aa88-c83a7c503055.jpg?v=1782185296",
    "searchKeywords": "",
    "sku": "2534ACK",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-dual-jet-tool-kit-12-s-bend-wand-25-hose-assy-for-500-psi-units-2534ack-500",
    "name": "Dual Jet Tool Kit - 12\" S-Bend Wand & 25' Hose Assy. For 500 PSI Units",
    "url": "https://www.thecleaningbusiness.com/products/dual-jet-tool-kit-12-s-bend-wand-25-hose-assy-for-500-psi-units-2534ack-500",
    "type": "product",
    "productCategory": "part",
    "price": 482,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/705HR-External-In-Heater-System-sm.jpg?v=1782185302",
    "searchKeywords": "",
    "sku": "2534ACK-500",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "accessory-external-in-line-heater-w-50-ft-extension-cord-2000-watt-705hr",
    "name": "External In-Line Heater w/ 50 ft. Extension Cord - 2000 Watt",
    "url": "https://www.thecleaningbusiness.com/products/external-in-line-heater-w-50-ft-extension-cord-2000-watt-705hr",
    "type": "product",
    "productCategory": "accessory",
    "price": 778,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/500BX-HR-Extractor-sm.jpg?v=1782185308",
    "searchKeywords": "",
    "sku": "705HR",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-7-revolution-hand-held-tile-cleaning-tool-700rev",
    "name": "7\" Revolution Hand-Held Tile Cleaning Tool",
    "url": "https://www.thecleaningbusiness.com/products/7-revolution-hand-held-tile-cleaning-tool-700rev",
    "type": "product",
    "productCategory": "accessory",
    "price": 965,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/9000I-HS-Box-Extractor-sm_618fe3d4-b4a3-4685-89ea-7f67eab3eb27.jpg?v=1782185314",
    "searchKeywords": "",
    "sku": "700REV",
    "bestFor": [
      "maintenance",
      "tile",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-12-revolution-tile-cleaning-tool-1200rev",
    "name": "12\" Revolution Tile Cleaning Tool",
    "url": "https://www.thecleaningbusiness.com/products/12-revolution-tile-cleaning-tool-1200rev",
    "type": "product",
    "productCategory": "accessory",
    "price": 1281,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/9000I-HS-Box-Extractor-sm_888d14b8-226d-4595-be5e-2405fc984fe1.jpg?v=1782185320",
    "searchKeywords": "",
    "sku": "1200REV",
    "bestFor": [
      "maintenance",
      "tile",
      "accessories"
    ]
  },
  {
    "id": "accessory-mastercraft-connector-1-5-in-steel-mc-305022",
    "name": "Mastercraft Connector 1.5 in. Steel",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-connector-1-5-in-steel-mc-305022",
    "type": "product",
    "productCategory": "accessory",
    "price": 16.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/NoImageAvailable.gif?v=1782185326",
    "searchKeywords": "",
    "sku": "MC-305022",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-352845-secondary-cord-hook-mc-352845",
    "name": "352845 Secondary Cord Hook",
    "url": "https://www.thecleaningbusiness.com/products/352845-secondary-cord-hook-mc-352845",
    "type": "product",
    "productCategory": "accessory",
    "price": 20,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Tuff-Block-Velcro-Diamond-Pad-Driver-17-Inch-sm.jpg?v=1782185332",
    "searchKeywords": "",
    "sku": "MC-352845",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-mastercraft-349445-1-1-2-swivel-hose-connector-mc-349445",
    "name": "Mastercraft [349445]1 1/2\" SWIVEL HOSE CONNECTOR",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-349445-1-1-2-swivel-hose-connector-mc-349445",
    "type": "product",
    "productCategory": "accessory",
    "price": 24.56,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/NoImageAvailable_de3d2306-a990-4fbc-ad89-0b208f3e778c.gif?v=1782185338",
    "searchKeywords": "",
    "sku": "MC-349445",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-mastercraft-1-25-in-steel-straight-wand-slotted-19-in-long-per-piece-mc-310433",
    "name": "Mastercraft 1.25 in. Steel Straight Wand Slotted 19 in. Long Per Piece",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-1-25-in-steel-straight-wand-slotted-19-in-long-per-piece-mc-310433",
    "type": "product",
    "productCategory": "accessory",
    "price": 42.7,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mc-310433-mastercraft-steel-straight-wand_sm.jpg?v=1782185344",
    "searchKeywords": "",
    "sku": "MC-310433",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "machine-mastercraft-14-in-hose-cage-for-sootmaster-vacuums-mc-313408",
    "name": "Mastercraft 14 in. Hose Cage for Sootmaster Vacuums",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-14-in-hose-cage-for-sootmaster-vacuums-mc-313408",
    "type": "product",
    "productCategory": "machine",
    "price": 52.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mc-304158-filter-frame-for-sootmaster-vacuums_sm.jpg?v=1782185350",
    "searchKeywords": "",
    "sku": "MC-313408",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "part-458155-ct9-enviromaster-9-compact-hepa-dry-vacuum-filter-cassette-mc-458155",
    "name": "458155 CT9 Enviromaster 9 Compact HEPA Dry Vacuum Filter Cassette",
    "url": "https://www.thecleaningbusiness.com/products/458155-ct9-enviromaster-9-compact-hepa-dry-vacuum-filter-cassette-mc-458155",
    "type": "product",
    "productCategory": "part",
    "price": 58,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Compact-HEPA-Dry-Vacuum-Cartridge-sm.jpg?v=1782185356",
    "searchKeywords": "",
    "sku": "MC-458155",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "part-457981-ct9-enviromaster-9-compact-hepa-dry-vacuum-bags-10-pack-mc-457981",
    "name": "457981 CT9 Enviromaster 9 Compact HEPA Dry Vacuum Bags - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/457981-ct9-enviromaster-9-compact-hepa-dry-vacuum-bags-10-pack-mc-457981",
    "type": "product",
    "productCategory": "part",
    "price": 63,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Compact-HEPA-Dry-Vacuum-Cartridge-sm_7418ff51-0db7-4867-89b8-dfb5922adb93.jpg?v=1782185362",
    "searchKeywords": "",
    "sku": "MC-457981",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "part-mastercraft-1-25-in-plastic-dry-toolkit-mc-362727",
    "name": "Mastercraft 1.25 in. Plastic Dry Toolkit",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-1-25-in-plastic-dry-toolkit-mc-362727",
    "type": "product",
    "productCategory": "part",
    "price": 64.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mc-459305-mastercraft-toolkit-with-squeegee_sm.jpg?v=1782185368",
    "searchKeywords": "",
    "sku": "MC-362727",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-compact-hepa-dry-canister-vacuum-cartridge-filter-mc-458295",
    "name": "Compact HEPA Dry Canister Vacuum Cartridge Filter",
    "url": "https://www.thecleaningbusiness.com/products/compact-hepa-dry-canister-vacuum-cartridge-filter-mc-458295",
    "type": "product",
    "productCategory": "part",
    "price": 68.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Cassette-Exhaust-Filter-Front-sm.jpg?v=1782185374",
    "searchKeywords": "",
    "sku": "MC-458295",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "accessory-floor-machine-stripping-pad-6-5-dia-brown-10-pack-mc-354368",
    "name": "Floor Machine Stripping Pad - 6.5\" Dia. - Brown - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/floor-machine-stripping-pad-6-5-dia-brown-10-pack-mc-354368",
    "type": "product",
    "productCategory": "accessory",
    "price": 72.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Red-Buffing-Floor-Pad-sm.jpg?v=1782185380",
    "searchKeywords": "",
    "sku": "MC-354368",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-floor-machine-buffing-polishing-pad-6-5-dia-white-10-pack-mc-418595",
    "name": "Floor Machine Buffing & Polishing Pad - 6.5\" Dia. - White - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/floor-machine-buffing-polishing-pad-6-5-dia-white-10-pack-mc-418595",
    "type": "product",
    "productCategory": "accessory",
    "price": 78.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Red-Buffing-Floor-Pad-sm_0e5a0994-eff0-4892-9718-1cd0296f8d8b.jpg?v=1782185385",
    "searchKeywords": "",
    "sku": "MC-418595",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-floor-machine-buffing-cleaning-pad-6-5-dia-red-10-pack-mc-417742",
    "name": "Floor Machine Buffing & Cleaning Pad - 6.5\" Dia. - Red - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/floor-machine-buffing-cleaning-pad-6-5-dia-red-10-pack-mc-417742",
    "type": "product",
    "productCategory": "accessory",
    "price": 81.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/White-Polishing-Floor-Pad-sm.jpg?v=1782185391",
    "searchKeywords": "",
    "sku": "MC-417742",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-floor-machine-cleaning-scrubbing-pad-6-5-blue-10-pack-mc-257907",
    "name": "Floor Machine Cleaning & Scrubbing Pad - 6.5\" - Blue - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/floor-machine-cleaning-scrubbing-pad-6-5-blue-10-pack-mc-257907",
    "type": "product",
    "productCategory": "accessory",
    "price": 81.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Red-Buffing-Floor-Pad-sm_4528390d-1e93-4dd4-9dc8-ed46c05066e3.jpg?v=1782185398",
    "searchKeywords": "",
    "sku": "MC-257907",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-floor-machine-scrubbing-light-stripping-pad-6-5-dia-green-10-pack-mc-420050",
    "name": "Floor Machine Scrubbing & Light Stripping Pad - 6.5\" Dia. - Green - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/floor-machine-scrubbing-light-stripping-pad-6-5-dia-green-10-pack-mc-420050",
    "type": "product",
    "productCategory": "accessory",
    "price": 81.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Red-Buffing-Floor-Pad-sm_e1c1880b-819d-4336-b98f-c3beca1c79e6.jpg?v=1782185403",
    "searchKeywords": "",
    "sku": "MC-420050",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-floor-machine-stripping-heavy-cleaning-pad-6-5-dia-black-10-pack-mc-417734",
    "name": "Floor Machine Stripping & Heavy Cleaning Pad - 6.5\" Dia. - Black - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/floor-machine-stripping-heavy-cleaning-pad-6-5-dia-black-10-pack-mc-417734",
    "type": "product",
    "productCategory": "accessory",
    "price": 85.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Red-Buffing-Floor-Pad-sm_7c01e67e-8958-4ea1-81a4-b0f63fe5b16f.jpg?v=1782185410",
    "searchKeywords": "",
    "sku": "MC-417734",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "part-413224-msr-15e-ra-300-replacement-scrub-brush-2-mc-413224",
    "name": "413224 MSR-15E/RA 300 Replacement Scrub Brush (2)",
    "url": "https://www.thecleaningbusiness.com/products/413224-msr-15e-ra-300-replacement-scrub-brush-2-mc-413224",
    "type": "product",
    "productCategory": "part",
    "price": 91.54,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Black-Stripping-Round-Floor-Pad-sm.jpg?v=1782185418",
    "searchKeywords": "",
    "sku": "MC-413224",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-253626-cleanfix-scrubby-2-in-1-scrubber-nylon-scrub-brush-6-mc-253626",
    "name": "253626 Cleanfix Scrubby 2-in-1 Scrubber Nylon Scrub Brush - 6\"",
    "url": "https://www.thecleaningbusiness.com/products/253626-cleanfix-scrubby-2-in-1-scrubber-nylon-scrub-brush-6-mc-253626",
    "type": "product",
    "productCategory": "part",
    "price": 136,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/White-Polishing-Floor-Pad-sm_1b85daa6-c39c-4775-8576-42207a34d1ae.jpg?v=1782185425",
    "searchKeywords": "",
    "sku": "MC-253626",
    "bestFor": [
      "hard_floor_scrubbing",
      "maintenance",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "under_1000"
    ]
  },
  {
    "id": "part-mastercraft-1-5-in-toolkit-with-squeegee-mc-459305",
    "name": "Mastercraft 1.5 in. Toolkit with Squeegee",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-1-5-in-toolkit-with-squeegee-mc-459305",
    "type": "product",
    "productCategory": "part",
    "price": 199.64,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mc-362727-mastercraft-plastic-dry-toolkit_sm.jpg?v=1782185431",
    "searchKeywords": "",
    "sku": "MC-459305",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "accessory-mastercraft-dry-pick-up-55-gallon-drum-adapter-112-cfm-106-in-waterlift-mc-320064",
    "name": "Mastercraft Dry Pick Up, 55 Gallon Drum Adapter 112 CFM 106 in. Waterlift",
    "url": "https://www.thecleaningbusiness.com/products/mastercraft-dry-pick-up-55-gallon-drum-adapter-112-cfm-106-in-waterlift-mc-320064",
    "type": "product",
    "productCategory": "accessory",
    "price": 1198.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mc-320064-mastercraft-dry-pick-up-drum-adapter_sm.jpg?v=1782185437",
    "searchKeywords": "",
    "sku": "MC-320064",
    "bestFor": [
      "maintenance",
      "accessories"
    ]
  },
  {
    "id": "accessory-mytee-p533-injection-sprayer-holder-myp533",
    "name": "Mytee P533 Injection Sprayer Holder",
    "url": "https://www.thecleaningbusiness.com/products/mytee-p533-injection-sprayer-holder-myp533",
    "type": "product",
    "productCategory": "accessory",
    "price": 36.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/E516-3-Position-Switch-Replacement-sm.jpg?v=1782185444",
    "searchKeywords": "",
    "sku": "MYP533",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "part-mytee-a109-nylon-glide-w-removable-brush-mya109",
    "name": "Mytee A109 Nylon Glide w/Removable Brush",
    "url": "https://www.thecleaningbusiness.com/products/mytee-a109-nylon-glide-w-removable-brush-mya109",
    "type": "product",
    "productCategory": "part",
    "price": 69.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my8903-spinner-tile-grout-cleaning-tool_sml.jpg?v=1782185451",
    "searchKeywords": "",
    "sku": "MYA109",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-3-prong-electrical-circuit-230v-115v-converter-kit-dual-outlet-my5003",
    "name": "3-Prong Electrical Circuit 230V/115V Converter Kit - Dual Outlet",
    "url": "https://www.thecleaningbusiness.com/products/3-prong-electrical-circuit-230v-115v-converter-kit-dual-outlet-my5003",
    "type": "product",
    "productCategory": "part",
    "price": 77.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my5004-converter-kit-dual-outlet_sm.jpg?v=1782185457",
    "searchKeywords": "",
    "sku": "MY5003",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-4-prong-electrical-circuit-230v-115v-converter-kit-dual-outlet-my5004",
    "name": "4-Prong Electrical Circuit 230V/115V Converter Kit - Dual Outlet",
    "url": "https://www.thecleaningbusiness.com/products/4-prong-electrical-circuit-230v-115v-converter-kit-dual-outlet-my5004",
    "type": "product",
    "productCategory": "part",
    "price": 77.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my5003-converter-kit-dual-outlet_sm.jpg?v=1782185463",
    "searchKeywords": "",
    "sku": "MY5004",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "machine-box-extractor-system-maintainer-12-1-qt-bottles-my3601",
    "name": "Box Extractor System Maintainer - (12) 1 qt. Bottles",
    "url": "https://www.thecleaningbusiness.com/products/box-extractor-system-maintainer-12-1-qt-bottles-my3601",
    "type": "product",
    "productCategory": "machine",
    "price": 101.67,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/NoImageAvailable_9baed4a3-fc2f-4ce7-a76a-7ab5f3c3d724.gif?v=1782185469",
    "searchKeywords": "",
    "sku": "MY3601",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-8501v-1-25-x-15-vacuum-solution-hose-combo-my8501v",
    "name": "8501V 1.25\" x 15' Vacuum/Solution Hose Combo",
    "url": "https://www.thecleaningbusiness.com/products/8501v-1-25-x-15-vacuum-solution-hose-combo-my8501v",
    "type": "product",
    "productCategory": "machine",
    "price": 148.33,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my8100-vacuum-solution-hose-combo_sm.jpg?v=1782185476",
    "searchKeywords": "",
    "sku": "MY8501V",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "accessory-stainless-steel-crevice-upholstery-tool-external-spray-my8700",
    "name": "Stainless Steel Crevice Upholstery Tool, External Spray",
    "url": "https://www.thecleaningbusiness.com/products/stainless-steel-crevice-upholstery-tool-external-spray-my8700",
    "type": "product",
    "productCategory": "accessory",
    "price": 152,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my8400-stainless-steel-upholstery-tool_sml.jpg?v=1782185483",
    "searchKeywords": "",
    "sku": "MY8700",
    "bestFor": [
      "maintenance",
      "carpet",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-mytee-8400-stainless-steel-upholstery-tool-external-spray-my8400",
    "name": "Mytee 8400 Stainless Steel Upholstery Tool, External Spray",
    "url": "https://www.thecleaningbusiness.com/products/mytee-8400-stainless-steel-upholstery-tool-external-spray-my8400",
    "type": "product",
    "productCategory": "accessory",
    "price": 169,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my8700-stainless-steel-crevice-upholstery-tool_sml.jpg?v=1782185489",
    "searchKeywords": "",
    "sku": "MY8400",
    "bestFor": [
      "maintenance",
      "carpet",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-8100-1-5-x-25-vacuum-solution-hose-combo-my8100",
    "name": "Mytee 8100 1.5\" x 25' Vacuum/Solution Hose Combo",
    "url": "https://www.thecleaningbusiness.com/products/mytee-8100-1-5-x-25-vacuum-solution-hose-combo-my8100",
    "type": "product",
    "productCategory": "machine",
    "price": 251.67,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my8501v-vacuum-solution-hose-combo_sm.jpg?v=1782185495",
    "searchKeywords": "",
    "sku": "MY8100",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-8101-2-x-25-vacuum-solution-hose-combo-my8101",
    "name": "Mytee 8101 2\" X 25' Vacuum/Solution Hose Combo",
    "url": "https://www.thecleaningbusiness.com/products/mytee-8101-2-x-25-vacuum-solution-hose-combo-my8101",
    "type": "product",
    "productCategory": "machine",
    "price": 313.33,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my1003dx-speedster-deluxe-heated-box-extractor_sml.jpg?v=1782185501",
    "searchKeywords": "",
    "sku": "MY8101",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "part-a138-flood-hog-accessory-kit-mya138",
    "name": "A138 Flood Hog Accessory Kit",
    "url": "https://www.thecleaningbusiness.com/products/a138-flood-hog-accessory-kit-mya138",
    "type": "product",
    "productCategory": "part",
    "price": 330,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my7000lx-flood-hog-flood-extractor_sml.jpg?v=1782185507",
    "searchKeywords": "",
    "sku": "MYA138",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "accessory-mytee-8300-ez-12-dual-jet-wand-my8300-ez",
    "name": "Mytee 8300-EZ 12\" Dual Jet Wand",
    "url": "https://www.thecleaningbusiness.com/products/mytee-8300-ez-12-dual-jet-wand-my8300-ez",
    "type": "product",
    "productCategory": "accessory",
    "price": 358,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/my8400-stainless-steel-upholstery-tool_sml_57f46f35-0dfe-4acd-994f-0df0a528eeec.jpg?v=1782185513",
    "searchKeywords": "",
    "sku": "MY8300-EZ",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-counter-style-spinner-tile-grout-cleaning-tool-my8908",
    "name": "Counter Style Spinner Tile & Grout Cleaning Tool",
    "url": "https://www.thecleaningbusiness.com/products/counter-style-spinner-tile-grout-cleaning-tool-my8908",
    "type": "product",
    "productCategory": "accessory",
    "price": 581,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/MYM-12-Mytee-M-12-M-Series-Dual-Mode-Portable-Box-Extractor-Heat-15-Gallon_sm.jpg?v=1782185519",
    "searchKeywords": "",
    "sku": "MY8908",
    "bestFor": [
      "maintenance",
      "tile",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-spinner-tile-grout-cleaning-tool-1-5-wand-style-my8903",
    "name": "Spinner Tile & Grout Cleaning Tool - 1.5\" Wand Style",
    "url": "https://www.thecleaningbusiness.com/products/spinner-tile-grout-cleaning-tool-1-5-wand-style-my8903",
    "type": "product",
    "productCategory": "accessory",
    "price": 951,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/myltd12-speedster-carpet-extractor_sml.jpg?v=1782185525",
    "searchKeywords": "",
    "sku": "MY8903",
    "bestFor": [
      "maintenance",
      "tile",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-spinner-tile-grout-cleaning-tool-1-5-t-handle-style-my8904",
    "name": "Spinner Tile & Grout Cleaning Tool - 1.5\" T-Handle Style",
    "url": "https://www.thecleaningbusiness.com/products/spinner-tile-grout-cleaning-tool-1-5-t-handle-style-my8904",
    "type": "product",
    "productCategory": "accessory",
    "price": 951,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/myltd12-speedster-carpet-extractor_sml_711274d5-b8bd-41f9-bd53-991f69f40072.jpg?v=1782185531",
    "searchKeywords": "",
    "sku": "MY8904",
    "bestFor": [
      "maintenance",
      "tile",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-hot-turbo-in-line-portable-water-heater-2400-watt-my240-120",
    "name": "Hot Turbo In-Line Portable Water Heater - 2400 Watt",
    "url": "https://www.thecleaningbusiness.com/products/hot-turbo-in-line-portable-water-heater-2400-watt-my240-120",
    "type": "product",
    "productCategory": "accessory",
    "price": 951,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/NoImageAvailable_ce9d9425-013b-4ee0-9924-51dd191eb6a6.gif?v=1782185538",
    "searchKeywords": "",
    "sku": "MY240-120",
    "bestFor": [
      "maintenance",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "machine-mytee-air-hog-vacuum-booster-my7303lx",
    "name": "Mytee Air Hog Vacuum Booster",
    "url": "https://www.thecleaningbusiness.com/products/mytee-air-hog-vacuum-booster-my7303lx",
    "type": "product",
    "productCategory": "machine",
    "price": 1955,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/NoImageAvailable_1e09ee17-73a7-4fcc-b6db-b607b75597c0.gif?v=1782185544",
    "searchKeywords": "",
    "sku": "MY7303LX",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "commercial_vacuum"
    ]
  },
  {
    "id": "part-viper-fang-18c-replacement-front-squeegee-blade-vp-vf82117",
    "name": "Viper Fang 18C Replacement Front Squeegee Blade",
    "url": "https://www.thecleaningbusiness.com/products/viper-fang-18c-replacement-front-squeegee-blade-vp-vf82117",
    "type": "product",
    "productCategory": "part",
    "price": 21.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/VF82119-Black-Rear-Squeegee-Blade-sm.jpg?v=1782185551",
    "searchKeywords": "",
    "sku": "VP-VF82117",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-cuda2600-replacement-paper-bags-10-pack-vp-va51025p-p10",
    "name": "Viper CUDA2600 Replacement Paper Bags - 10 Pack",
    "url": "https://www.thecleaningbusiness.com/products/viper-cuda2600-replacement-paper-bags-10-pack-vp-va51025p-p10",
    "type": "product",
    "productCategory": "part",
    "price": 23.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/107313-ProTeam-Intercept-Micro-Filter-sm.jpg?v=1782185558",
    "searchKeywords": "",
    "sku": "VP-VA51025P-P10",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-fang-18c-replacement-rear-squeegee-blade-vp-vf82119",
    "name": "Viper Fang 18C Replacement Rear Squeegee Blade",
    "url": "https://www.thecleaningbusiness.com/products/viper-fang-18c-replacement-rear-squeegee-blade-vp-vf82119",
    "type": "product",
    "productCategory": "part",
    "price": 24.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/VF82117-Black-Front-Autoscrubber-Squeegee-Blade-sm.jpg?v=1782185564",
    "searchKeywords": "",
    "sku": "VP-VF82119",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-fang-18c-replacement-rear-squeegee-blade-vp-vf82063",
    "name": "Viper Fang 18C Replacement Rear Squeegee Blade",
    "url": "https://www.thecleaningbusiness.com/products/viper-fang-18c-replacement-rear-squeegee-blade-vp-vf82063",
    "type": "product",
    "productCategory": "part",
    "price": 48.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/VF82062-Blue-Front-Squeegee-Blade-sm.jpg?v=1782185572",
    "searchKeywords": "",
    "sku": "VP-VF82063",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-fang-18c-replacement-front-squeegee-blade-vp-vf82062",
    "name": "Viper Fang 18C Replacement Front Squeegee Blade",
    "url": "https://www.thecleaningbusiness.com/products/viper-fang-18c-replacement-front-squeegee-blade-vp-vf82062",
    "type": "product",
    "productCategory": "part",
    "price": 49.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/VF82063-Blue-Rear-Autoscrubber-Squeegee-Blade-sm.jpg?v=1782185579",
    "searchKeywords": "",
    "sku": "VP-VF82062",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-vv78406-air-mover-trolley-kit-vp-vv78406",
    "name": "Viper VV78406 Air Mover Trolley Kit",
    "url": "https://www.thecleaningbusiness.com/products/viper-vv78406-air-mover-trolley-kit-vp-vv78406",
    "type": "product",
    "productCategory": "part",
    "price": 51.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AM2400D-3-Speed-Air-Mover-sm.jpg?v=1782185585",
    "searchKeywords": "",
    "sku": "VP-VV78406",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-vf90411-16-polypropylene-brush-vp-vf90411",
    "name": "Viper VF90411 16\" Polypropylene Brush",
    "url": "https://www.thecleaningbusiness.com/products/viper-vf90411-16-polypropylene-brush-vp-vf90411",
    "type": "product",
    "productCategory": "part",
    "price": 108.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Stinger17-Small-Area-Automatic-Floor-Scrubber-Machine-sm.jpg?v=1782185592",
    "searchKeywords": "",
    "sku": "VP-VF90411",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-fang-18c-poly-scrubbing-brush-plastic-block-17-dia-vp-vf80211b",
    "name": "Fang 18C Poly Scrubbing Brush - Plastic Block - 17\" Dia.",
    "url": "https://www.thecleaningbusiness.com/products/fang-18c-poly-scrubbing-brush-plastic-block-17-dia-vp-vf80211b",
    "type": "product",
    "productCategory": "part",
    "price": 115.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Viper-Fang18C-Electric-Auto-Floor-Scrubber-sm.jpg?v=1782185600",
    "searchKeywords": "",
    "sku": "VP-VF80211B",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-fang-20-polypropylene-scrubbing-brush-plastic-block-19-dia-vp-vf82056",
    "name": "Viper Fang 20 Polypropylene Scrubbing Brush - Plastic Block - 19\" Dia.",
    "url": "https://www.thecleaningbusiness.com/products/viper-fang-20-polypropylene-scrubbing-brush-plastic-block-19-dia-vp-vf82056",
    "type": "product",
    "productCategory": "part",
    "price": 140.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Fang-20-Battery-Powered-Auto-Floor-Scrubber-sm.jpg?v=1782185608",
    "searchKeywords": "",
    "sku": "VP-VF82056",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-viper-single-nozzle-hand-sprayer-kit-for-wolf130-spotter-vp-vv78350",
    "name": "Viper Single Nozzle Hand Sprayer Kit for WOLF130 Spotter",
    "url": "https://www.thecleaningbusiness.com/products/viper-single-nozzle-hand-sprayer-kit-for-wolf130-spotter-vp-vv78350",
    "type": "product",
    "productCategory": "part",
    "price": 178.95,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Single-Nozzle-Hand-Sprayer-Kit-sm.jpg?v=1782185616",
    "searchKeywords": "",
    "sku": "VP-VV78350",
    "bestFor": [
      "maintenance",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "machine-tennant-t20-industrial-ride-on-floor-scrubber-80-gallon",
    "name": "Tennant® T20 Industrial Ride-On Floor Scrubber w/ ES® Extended Scrub & ec-H2O™ Technology Options – ",
    "url": "https://thecleaningbusiness.com/products/tennant-t20-industrial-ride-on-floor-scrubber-80-gallon",
    "type": "product",
    "productCategory": "machine",
    "price": 81884,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t20-front.jpg?v=1782337993",
    "searchKeywords": "Tennant┬«, Industrial, Ride-On, Floor, Scrubber, ES┬«, Extended, Scrub, ec-H2OΓäó, Technology, Options, Gallons",
    "sku": "TEN-T20",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-tennant-t16-automatic-floor-scrubber",
    "name": "Tennant® T16 36\" Ride-On Automatic Floor Scrubber w/ ec-H2O™ Technology (Disk Scrub Deck) – 50 Gallo",
    "url": "https://thecleaningbusiness.com/products/tennant-t16-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 45921,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t16-front.jpg?v=1782338023",
    "searchKeywords": "Tennant┬«, Ride-On, Automatic, Floor, Scrubber, ec-H2OΓäó, Technology, (Disk, Scrub, Deck), Gallons",
    "sku": "TEN-T16",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-outdoor-gas-powered-ride-on-sweeper",
    "name": "IPC Eagle Genius 58\" Outdoor Gas Powered Ride On Sweeper",
    "url": "https://thecleaningbusiness.com/products/outdoor-gas-powered-ride-on-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 40225,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-genius-1404-ride-on-sweeper.jpg?v=1782338054",
    "searchKeywords": "Eagle, Genius, Outdoor, Powered, Ride, Sweeper",
    "sku": "EAG-TK1404-215CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper"
    ]
  },
  {
    "id": "machine-battery-operated-ride-on-airport-sweeper",
    "name": "IPC Eagle 1404 Battery Operated Ride On Vacuum Sweeper - 58\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/battery-operated-ride-on-airport-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 38015,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-genius-1404-ride-on-sweeper_1.jpg?v=1782338080",
    "searchKeywords": "Eagle, 1404, Battery, Operated, Ride, Vacuum, Sweeper, Sweeping, Path",
    "sku": "EAG-TK1404E350CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "commercial_vacuum",
      "sweeper"
    ]
  },
  {
    "id": "machine-advancer-sw4000tm-rider-sweeper",
    "name": "Advance® SW4000™ Rider Sweeper - 49\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/advancer-sw4000tm-rider-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 36532,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advancer-sw4000tm-rider-sweeper-49.jpg?v=1782338114",
    "searchKeywords": "Advance┬«, SW4000Γäó, Rider, Sweeper, Sweeping, Path",
    "sku": "NFA-56383325",
    "bestFor": [
      "hard_floor_scrubbing",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper"
    ]
  },
  {
    "id": "machine-tennant-r14-rider-self-contained-carpet-cleaning-extractor",
    "name": "Tennant® R14 Rider Self-Contained Carpet Cleaning Extractor (32 Gallons) - 28\" Head",
    "url": "https://thecleaningbusiness.com/products/tennant-r14-rider-self-contained-carpet-cleaning-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 28871,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-r14-ride-on-carpet-cleaning-extractor.jpg?v=1782338145",
    "searchKeywords": "Tennant┬«, Rider, Self-Contained, Carpet, Cleaning, Extractor, Gallons), Head",
    "sku": "TEN-R14",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "machine-tennant-t7-ride-on-automatic-floor-scrubber",
    "name": "Tennant® T7 Ride-On Automatic Floor Scrubber w/ Conventional & ec-H2O NanoClean® Options – 29 Gallon",
    "url": "https://thecleaningbusiness.com/products/tennant-t7-ride-on-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 27678,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t7-front.jpg?v=1782338174",
    "searchKeywords": "Tennant┬«, Ride-On, Automatic, Floor, Scrubber, Conventional, ec-H2O, NanoClean┬«, Options, Gallons",
    "sku": "TEN-T7-1001D",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-sc4000-ride-on-floor-scrubber",
    "name": "Advance® SC4000® Ride-On Floor Scrubber w/ REV Technology (Battery, EcoFlex™ & High Performance Opti",
    "url": "https://thecleaningbusiness.com/products/advance-sc4000-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 26659,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sc4000-advance-floor-scrubber-lg.jpg?v=1782338202",
    "searchKeywords": "Advance┬«, SC4000┬«, Ride-On, Floor, Scrubber, Technology, (Battery,, EcoFlexΓäó, High, Performance, Options, Available)",
    "sku": "NFA-56120035",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-advenger-ride-on-floor-scrubber-with-rev-technology",
    "name": "28\" Advance® Advenger® Ride-On Floor Scrubber w/ REV Technology",
    "url": "https://thecleaningbusiness.com/products/advance-advenger-ride-on-floor-scrubber-with-rev-technology",
    "type": "product",
    "productCategory": "machine",
    "price": 25290,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-advenger-with-ecoflex.jpg?v=1782338225",
    "searchKeywords": "Advance┬«, Advenger┬«, Ride-On, Floor, Scrubber, Technology",
    "sku": "NFA-56601895",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-ipc-eagle-1280-battery-power-rider-sweeper",
    "name": "IPC Eagle 1280 Battery Powered Rider Vacuum Sweeper - 48\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-1280-battery-power-rider-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 24894,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1280-battery-powered-rider-sweeper.jpg?v=1782338249",
    "searchKeywords": "Eagle, 1280, Battery, Powered, Rider, Vacuum, Sweeper, Sweeping, Path",
    "sku": "EAG-TK1280E240-E/CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "commercial_vacuum",
      "sweeper"
    ]
  },
  {
    "id": "machine-36-inch-automatic-ride-on-scrubber",
    "name": "IPC Eagle CT160 Industrial Automatic Ride On Floor Scrubber (36\" Scrub Deck) - 39 Gallons",
    "url": "https://thecleaningbusiness.com/products/36-inch-automatic-ride-on-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 24701,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct160-automatic-ride-on-scrubber_1_1.jpg?v=1782338278",
    "searchKeywords": "Eagle, CT160, Industrial, Automatic, Ride, Floor, Scrubber, (36\", Scrub, Deck), Gallons",
    "sku": "EAG-CT160BT95-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-boost-automatic-ride-on-floor-scrubber",
    "name": "Clarke® Focus® II BOOST® Automatic Ride on Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-ii-boost-automatic-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 24660,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-focus-ii-boost-automatic-ride-on-floor-scrubber_2.jpg?v=1782338303",
    "searchKeywords": "Clarke┬«, Focus┬«, BOOST┬«, Automatic, Ride, Floor, Scrubber",
    "sku": "CRK-56114012",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-pacific-floorcare-rs28-rider-scrubber-with-deck-option",
    "name": "Pacific Floorcare® RS28 Ride On Automatic Floor Scrubber (28\" Disc or 14\" x 28\" Orbital) - 30 Gallon",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-rs28-rider-scrubber-with-deck-option",
    "type": "product",
    "productCategory": "machine",
    "price": 22865.97,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-rs28-rider-scrubber.jpg?v=1782338333",
    "searchKeywords": "Pacific, Floorcare┬«, RS28, Ride, Automatic, Floor, Scrubber, (28\", Disc, Orbital), Gallons",
    "sku": "PAC-895405",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-terra-4300b-compact-rider-sweeper",
    "name": "Advance Terra® 4300B Compact Rider Sweeper - 46\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/advance-terra-4300b-compact-rider-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 22626,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-terra-4300b-compact-rider-sweeper-46-inch.jpg?v=1782338358",
    "searchKeywords": "Advance, Terra┬«, 4300B, Compact, Rider, Sweeper, Sweeping, Path",
    "sku": "NFA-56100785",
    "bestFor": [
      "hard_floor_scrubbing",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper"
    ]
  },
  {
    "id": "machine-green-cleaning-rider-scrubber",
    "name": "IPC Eagle CT110 ECS Low Moisture Rider Floor Scrubber (32\" Scrub Deck) - 29 Gallons",
    "url": "https://thecleaningbusiness.com/products/green-cleaning-rider-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 21256,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct110ecs-low-moisture-rider-scrubber.jpg?v=1782338388",
    "searchKeywords": "Eagle, CT110, Moisture, Rider, Floor, Scrubber, (32\", Scrub, Deck), Gallons",
    "sku": "EAG-CT110ECS-240-KTRI01711",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-28-inch-350bu-battery-floor-burnisher",
    "name": "Pioneer Eclipse 28\" 350BU High Speed Battery Floor Burnisher - 2,000 RPM",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-28-inch-350bu-battery-floor-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 19969.24,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-350BU-28inch-battery-burnisher.jpg?v=1782338418",
    "searchKeywords": "Pioneer, Eclipse, 350BU, High, Speed, Battery, Floor, Burnisher, 2,000",
    "sku": "PIO-350BU28LI",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-microrider-auto-scrubber",
    "name": "Clarke® Focus® II MicroRider™ Auto Floor Scrubber (26\" or 14\" x 28\" Deck Options) - 21 Gallons",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-ii-microrider-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 19020,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-focus-2-microrider-auto-scrubber-with-disk-deck.jpg?v=1782338449",
    "searchKeywords": "Clarke┬«, Focus┬«, MicroRiderΓäó, Auto, Floor, Scrubber, (26\", Deck, Options), Gallons",
    "sku": "CRK-56382626",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-adgressor-3220d-industrial-32-inch-ride-on-floor-scrubber",
    "name": "Advance® Adgressor® 3220D Industrial 32\" Ride on Floor Scrubber - 42 Gallon",
    "url": "https://thecleaningbusiness.com/products/advance-adgressor-3220d-industrial-32-inch-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 18818,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-adgressor-rider-floor-scrubber-56384766.jpg?v=1782338477",
    "searchKeywords": "Advance┬«, Adgressor┬«, 3220D, Industrial, Ride, Floor, Scrubber, Gallon",
    "sku": "NFA-56384766",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-nilfisk-sw3000-li-ion-ride-on-industrial-floor-sweeper",
    "name": "Nilfisk® SW3000™ Ride-On Industrial Floor Sweeper w/ Li-Ion Batteries - 53\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/nilfisk-sw3000-li-ion-ride-on-industrial-floor-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 18563,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/nilfisk-sw3000-li-ion-industrial-sweeper.webp?v=1782338506",
    "searchKeywords": "Nilfisk┬«, SW3000Γäó, Ride-On, Industrial, Floor, Sweeper, Li-Ion, Batteries, Sweeping, Path",
    "sku": "NFA-50000758",
    "bestFor": [
      "hard_floor_scrubbing",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper"
    ]
  },
  {
    "id": "machine-clarke-clean-track-l24-battery-powered-self-contained-carpet-extractor",
    "name": "Clarke® Clean Track® L24 Battery Powered Self-Contained Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/clarke-clean-track-l24-battery-powered-self-contained-carpet-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 18363,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-clean-track-l24-carpet-extractor-rt.jpg?v=1782338534",
    "searchKeywords": "Clarke┬«, Clean, Track┬«, Battery, Powered, Self-Contained, Carpet, Extractor",
    "sku": "CRK-56317013",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-large-ride-on-automatic-floor-scrubber",
    "name": "IPC Eagle CT110 Compact Ride-On Automatic Floor Scrubber (32\" Scrub Deck) - 29 Gallons",
    "url": "https://thecleaningbusiness.com/products/large-ride-on-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 18330,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct110bt85-32-inch-rider-floor-scrubber.jpg?v=1782338561",
    "searchKeywords": "Eagle, CT110, Compact, Ride-On, Automatic, Floor, Scrubber, (32\", Scrub, Deck), Gallons",
    "sku": "EAG-CT110BT85-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-battery-powered-rider-warehouse-sweeper",
    "name": "IPC Eagle 1050 Battery Powered Rider Warehouse Vacuum Sweeper - 42\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/battery-powered-rider-warehouse-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 17767,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-1050-battery-powered-rider-sweeper.jpg?v=1782338580",
    "searchKeywords": "Eagle, 1050, Battery, Powered, Rider, Warehouse, Vacuum, Sweeper, Sweeping, Path",
    "sku": "EAG-TK1050E-215CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "warehouse",
      "concrete",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "commercial_vacuum",
      "sweeper"
    ]
  },
  {
    "id": "machine-aquaplus-axp-battery-powered-self-contained-carpet-extractor-by-advance",
    "name": "Advance® AquaPLUS™ AXP™ Battery Powered Self-Contained Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/aquaplus-axp-battery-powered-self-contained-carpet-extractor-by-advance",
    "type": "product",
    "productCategory": "machine",
    "price": 17706,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/aquaplus-axp-advance-extractor.jpg?v=1782338609",
    "searchKeywords": "Advance┬«, AquaPLUSΓäó, AXPΓäó, Battery, Powered, Self-Contained, Carpet, Extractor",
    "sku": "NFA-56317005",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-viper-as850r-32-inch-rider-automatic-floor-scrubber",
    "name": "Viper AS850R 32\" Rider Automatic Floor Scrubber - 32 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as850r-32-inch-rider-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 16466,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as850r-32-inch-rider-scrubber-main.jpg?v=1782338627",
    "searchKeywords": "Viper, AS850R, Rider, Automatic, Floor, Scrubber, Gallons",
    "sku": "VIP-AS850R-242",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-viper-ros1300-ride-on-sweeper",
    "name": "Viper ROS1300 Rider Floor Sweeper w/ Dust Control - 53\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/viper-ros1300-ride-on-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 16007,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ros1300-viper-ride-on-sweeper.jpg?v=1782338653",
    "searchKeywords": "Viper, ROS1300, Rider, Floor, Sweeper, Dust, Control, Sweeping, Path",
    "sku": "VIP-ROS1300-242",
    "bestFor": [
      "hard_floor_scrubbing",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper"
    ]
  },
  {
    "id": "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber",
    "name": "Clarke® Focus® II Boost® 14\" x 28\" Orbital Auto Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-boost-28-inch-orbital-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 15548,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-focus-2-boost-14-x-28-inch-orbital-auto-floor-scrubber.jpg?v=1782338675",
    "searchKeywords": "Clarke┬«, Focus┬«, Boost┬«, Orbital, Auto, Floor, Scrubber",
    "sku": "CRK-05371A",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-pacific-floorcare-s-28-orbital-floor-scrubber-14x28",
    "name": "Pacific Floorcare® S-28 Orbital Automatic Floor Scrubber (22 Gallons) - 14\" x 28\" Head",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s-28-orbital-floor-scrubber-14x28",
    "type": "product",
    "productCategory": "machine",
    "price": 15252.89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific--s-28-orbital-floor-scrubber-875425.jpg?v=1782338702",
    "searchKeywords": "Pacific, Floorcare┬«, S-28, Orbital, Automatic, Floor, Scrubber, Gallons), Head",
    "sku": "PAC-875425",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-ipc-eagle-24-in-ride-on-automatic-floor-scrubber-ct80-series",
    "name": "IPC Eagle CT80 Compact Ride on Automatic Floor Scrubber (24\" Scrub Deck) - 21 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-24-in-ride-on-automatic-floor-scrubber-ct80-series",
    "type": "product",
    "productCategory": "machine",
    "price": 14692,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct80-scrubber-v2.jpg?v=1782338722",
    "searchKeywords": "Eagle, CT80, Compact, Ride, Automatic, Floor, Scrubber, (24\", Scrub, Deck), Gallons",
    "sku": "EAG-CT80BT60-B-240OBC",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-viper-as7190to-walk-behind-orbital-automatic-floor-scrubber-w-traction-drive",
    "name": "Viper AS7190TO Walk Behind Orbital Automatic Floor Scrubber (14\" x 28\" Head) w/ Traction Drive - 22 ",
    "url": "https://thecleaningbusiness.com/products/viper-as7190to-walk-behind-orbital-automatic-floor-scrubber-w-traction-drive",
    "type": "product",
    "productCategory": "machine",
    "price": 13216,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as7190to-walk-behind-orbital-scrubber.jpg?v=1782338750",
    "searchKeywords": "Viper, AS7190TO, Walk, Behind, Orbital, Automatic, Floor, Scrubber, (14\", Head), Traction, Drive, Gallons",
    "sku": "VIP-AS7190TO-242",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-nilfisk-sc550-cylindrical-floor-scrubber-li-ion-battery",
    "name": "Nilfisk® SC550 Cylindrical 20\" Floor Scrubber w/ Li-ion Battery - 13 Gallons",
    "url": "https://thecleaningbusiness.com/products/nilfisk-sc550-cylindrical-floor-scrubber-li-ion-battery",
    "type": "product",
    "productCategory": "machine",
    "price": 12516,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/nilfisk-sc550-cylindrical-floor-scrubber-with-li-ion-battery-50000673.webp?v=1782338776",
    "searchKeywords": "Nilfisk┬«, SC550, Cylindrical, Floor, Scrubber, Li-ion, Battery, Gallons",
    "sku": "NFA-50000673",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-40-inch-dust-control-propane-burnisher",
    "name": "Pioneer Eclipse High Speed 40\" Propane Floor Burnisher w/ 18 HP Kawasaki Enigine & Dust Control - 1,",
    "url": "https://thecleaningbusiness.com/products/40-inch-dust-control-propane-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 12226.92,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/large-area-40-inch-dust-control-burnisher.jpg?v=1782338799",
    "searchKeywords": "Pioneer, Eclipse, High, Speed, Propane, Floor, Burnisher, Kawasaki, Enigine, Dust, Control, 1,850",
    "sku": "PIO-420BU40BCSVX",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "7500_15000"
    ]
  },
  {
    "id": "machine-advance-adfinity-x20c-cylindrical-battery-floor-scrubber-with-ecoflex",
    "name": "Advance® Adfinity™ X20C Cylindrical 20\" Battery Floor Scrubber w/ EcoFlex™ - 14.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/advance-adfinity-x20c-cylindrical-battery-floor-scrubber-with-ecoflex",
    "type": "product",
    "productCategory": "machine",
    "price": 12067,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-adfinity-x20c-scrubber.jpg?v=1782338817",
    "searchKeywords": "Advance┬«, AdfinityΓäó, X20C, Cylindrical, Battery, Floor, Scrubber, EcoFlexΓäó, 14.5, Gallons",
    "sku": "NFA-56317331",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-minuteman-max-ride-26-automatic-floor-scrubber",
    "name": "Minuteman® Max Ride 26 Automatic Floor Scrubber (Battery Upgrade Option Available) - 21 Gallons",
    "url": "https://thecleaningbusiness.com/products/minuteman-max-ride-26-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 11780.1,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman-max-ride-26-automatic-floor-scrubber.jpg?v=1782338839",
    "searchKeywords": "Minuteman┬«, Ride, Automatic, Floor, Scrubber, (Battery, Upgrade, Option, Available), Gallons",
    "sku": "MIN-A-MR26DQP",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-advance-sc1500-commercial-20-inch-stand-up-floor-scrubber",
    "name": "Advance® SC1500™ Commercial 20\" Stand-On Floor Scrubber w/ EcoFlex™ & Optional REV Technology",
    "url": "https://thecleaningbusiness.com/products/advance-sc1500-commercial-20-inch-stand-up-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 11543,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc1500-stand-on-rider-floor-scrubber.jpg?v=1782338862",
    "searchKeywords": "Advance┬«, SC1500Γäó, Commercial, Stand-On, Floor, Scrubber, EcoFlexΓäó, Optional, Technology",
    "sku": "NFA-56104010",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-cleanfreak-4-gpm-trailer-mount-pressure-washer-with-tank-and-100-foot-hose",
    "name": "CleanFreak® 4.0 GPM Hot Water Pressure Washing Skid w/ Tank, Reels & Spray Gun (Gas Engine) – 3,500 ",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-4-gpm-trailer-mount-pressure-washer-with-tank-and-100-foot-hose",
    "type": "product",
    "productCategory": "machine",
    "price": 11178.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2-reels-on-the-cleanfreak-4-gpm-mountable-pressure-washing-system.jpg?v=1782338887",
    "searchKeywords": "CleanFreak┬«, Water, Pressure, Washing, Skid, Tank,, Reels, Spray, (Gas, Engine), 3,500",
    "sku": "WET-APODCF4-0001",
    "bestFor": [
      "degreasing",
      "7500_15000"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-315asr-30-inch-ride-on-floor-scrubber",
    "name": "Pioneer Eclipse 315ASR 30\" Ride On Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-315asr-30-inch-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 10949.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-315asr-auto-scrubber.jpg?v=1782338918",
    "searchKeywords": "Pioneer, Eclipse, 315ASR, Ride, Floor, Scrubber",
    "sku": "PIO-315ASR30SL",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-viper-32-inch-auto-scrubber",
    "name": "Viper Fang 32 inch Automatic Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/viper-32-inch-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 10657,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-fang-32-inch-auto-scrubber.jpg?v=1782338942",
    "searchKeywords": "Viper, Fang, inch, Automatic, Floor, Scrubber",
    "sku": "VIP-FANG32T-250",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber-demo",
    "name": "Clarke® Focus® II Boost® 28 inch Orbital Auto Scrubber (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-boost-28-inch-orbital-auto-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 10500,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/image2.ashx_1.jpg?v=1782338971",
    "searchKeywords": "Clarke┬«, Focus┬«, Boost┬«, inch, Orbital, Auto, Scrubber, (Refurbished)",
    "sku": "CRK-05371A-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-as7690t-walk-behind-30-inch-automatic-floor-scrubber",
    "name": "Viper AS7690T Walk Behind 30\" Automatic Floor Scrubber - 22 Gallon",
    "url": "https://thecleaningbusiness.com/products/viper-as7690t-walk-behind-30-inch-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 10391,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-30-walk-behind-battery-auto-scrubber-as7690-t.jpg?v=1782338996",
    "searchKeywords": "Viper, AS7690T, Walk, Behind, Automatic, Floor, Scrubber, Gallon",
    "sku": "VIP-AS7690T-215",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-ca60-24b-boost-automatic-floor-scrubber-14x24-inch-head",
    "name": "Clarke® CA60 24B Boost® Orbital Automatic Floor Scrubber - 14\" x 24\" Head",
    "url": "https://thecleaningbusiness.com/products/clarke-ca60-24b-boost-automatic-floor-scrubber-14x24-inch-head",
    "type": "product",
    "productCategory": "machine",
    "price": 9682,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ca60-24b-boost-front-left.jpg?v=1782339022",
    "searchKeywords": "Clarke┬«, CA60, Boost┬«, Orbital, Automatic, Floor, Scrubber, Head",
    "sku": "CRK-56385418",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-top-stripping-orbital-auto-scrubber",
    "name": "Pacific Floorcare® S-20 Orbital Auto Scrubber - 14\" x 20\"",
    "url": "https://thecleaningbusiness.com/products/top-stripping-orbital-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 9646.26,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-s20-orbital-auto-scrubber.jpg?v=1782339052",
    "searchKeywords": "Pacific, Floorcare┬«, S-20, Orbital, Auto, Scrubber",
    "sku": "PAC-855405",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-as6690t-walk-behind-26-inch-automatic-floor-scrubber",
    "name": "Viper AS6690T Walk Behind 26\" Automatic Floor Scrubber - 22 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as6690t-walk-behind-26-inch-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 9295,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as6690t-26-inch-walk-behind-automatic-floor-scrubber.jpg?v=1782339073",
    "searchKeywords": "Viper, AS6690T, Walk, Behind, Automatic, Floor, Scrubber, Gallons",
    "sku": "VIP-AS6690T-215",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-pacific-floorcare-s-20-automatic-floor-scrubber",
    "name": "Pacific Floorcare® 20\" Automatic Floor Scrubber (#S-20) - Traction Drive w/ Battery Options",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s-20-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 9065.73,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-20-inch-automatic-floor-scrubber.jpg?v=1782339094",
    "searchKeywords": "Pacific, Floorcare┬«, Automatic, Floor, Scrubber, (#S-20), Traction, Drive, Battery, Options",
    "sku": "PAC-855404",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-battery-powered-gas-station-sweeper",
    "name": "IPC Eagle 712ET Battery Powered 36\" Vacuum Sweeper",
    "url": "https://thecleaningbusiness.com/products/battery-powered-gas-station-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 9049,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-712-36-inch-walk-behind-battery-sweeper.jpg?v=1782339117",
    "searchKeywords": "Eagle, 712ET, Battery, Powered, Vacuum, Sweeper",
    "sku": "EAG-712ET135",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "commercial_vacuum",
      "sweeper",
      "7500_15000"
    ]
  },
  {
    "id": "machine-26-inch-tornado-floor-scrubbing-machine",
    "name": "Tornado® 28\" BD 28/20 Automatic Floor Scrubber - 20 Gallon",
    "url": "https://thecleaningbusiness.com/products/26-inch-tornado-floor-scrubbing-machine",
    "type": "product",
    "productCategory": "machine",
    "price": 9039,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-28-inch-bd-28-20-automatic-floor-scrubber.jpg?v=1782339133",
    "searchKeywords": "Tornado┬«, 28/20, Automatic, Floor, Scrubber, Gallon",
    "sku": "TOR-99728C6",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-20-inch-300bu-battery-floor-burnisher",
    "name": "Pioneer Eclipse 20\" 300BU Ultra-High Speed (UHS) Battery Floor Burnisher - 2,000 RPM",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-20-inch-300bu-battery-floor-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 8889.69,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-20-inch-battery-floor-burnisher-300bu20cl.jpg?v=1782339155",
    "searchKeywords": "Pioneer, Eclipse, 300BU, Ultra-High, Speed, (UHS), Battery, Floor, Burnisher, 2,000",
    "sku": "PIO-300BU20CL",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "7500_15000"
    ]
  },
  {
    "id": "machine-microfiber-bonnet-auto-floor-scrubber",
    "name": "IPC Eagle CT70 ECS 28\" Auto Floor Scrubber w/ Microfiber Bonnet Drivers - 19 Gallons",
    "url": "https://thecleaningbusiness.com/products/microfiber-bonnet-auto-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 8726,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct70-w-dual-brushes_1.jpg?v=1782339176",
    "searchKeywords": "Eagle, CT70, Auto, Floor, Scrubber, Microfiber, Bonnet, Drivers, Gallons",
    "sku": "EAG-CT70ECS-145-KTRI01763",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-eco-stripping-orbital-auto-scrubber-package",
    "name": "Clarke® Boost® 14\" x 20\" Oscillating Auto Scrubber Floor Stripping Package",
    "url": "https://thecleaningbusiness.com/products/eco-stripping-orbital-auto-scrubber-package",
    "type": "product",
    "productCategory": "machine",
    "price": 8600.96,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/asp-package5-clarke-boost-v3.jpg?v=1782339198",
    "searchKeywords": "Clarke┬«, Boost┬«, Oscillating, Auto, Scrubber, Floor, Stripping, Package",
    "sku": "ASP-PACKAGE5",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-24-inch-propane-burnisher",
    "name": "Pioneer Eclipse 24\" Propane Floor Burnisher w/ Dust Control & Emissions Monitoring - 1,800 RPM",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-24-inch-propane-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 8537.69,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-24-inch-propane-floor-burnisher-with-dust-control-440bu24.jpg?v=1782339217",
    "searchKeywords": "Pioneer, Eclipse, Propane, Floor, Burnisher, Dust, Control, Emissions, Monitoring, 1,800",
    "sku": "PIO-440BU24",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "7500_15000"
    ]
  },
  {
    "id": "machine-compact-rider-sweeper-ipc-eagle-512r",
    "name": "IPC Eagle 512R Compact Industrial Rider Floor & Carpet Vacuum Sweeper - 28\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/compact-rider-sweeper-ipc-eagle-512r",
    "type": "product",
    "productCategory": "machine",
    "price": 8494,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-512r-compact-rider-floor-sweeper.jpg?v=1782339241",
    "searchKeywords": "Eagle, 512R, Compact, Industrial, Rider, Floor, Carpet, Vacuum, Sweeper, Sweeping, Path",
    "sku": "EAG-512R-145",
    "bestFor": [
      "carpet_extraction",
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "carpet",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "carpet_extractor",
      "commercial_vacuum",
      "sweeper",
      "7500_15000"
    ]
  },
  {
    "id": "machine-clarke-ca60-20b-boost-orbital-auto-scrubber-14x20",
    "name": "Clarke® CA60 20B Boost 14\" x 20\" Orbital Auto Floor Scrubber - 16 Gallons",
    "url": "https://thecleaningbusiness.com/products/clarke-ca60-20b-boost-orbital-auto-scrubber-14x20",
    "type": "product",
    "productCategory": "machine",
    "price": 8335,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ca60-20b-boost-right.jpg?v=1782339261",
    "searchKeywords": "Clarke┬«, CA60, Boost, Orbital, Auto, Floor, Scrubber, Gallons",
    "sku": "CRK-56385416",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-propane-floor-buffer",
    "name": "IPC Eagle 27\" Propane Floor Burnisher - 1,700 RPM",
    "url": "https://thecleaningbusiness.com/products/propane-floor-buffer",
    "type": "product",
    "productCategory": "machine",
    "price": 8084,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/27-inch-eagle-propane-buffing-burnisher.jpg?v=1782339290",
    "searchKeywords": "Eagle, Propane, Floor, Burnisher, 1,700",
    "sku": "EAG-A680191",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "7500_15000"
    ]
  },
  {
    "id": "machine-ipc-eagle-bb2000-battery-floor-burnisher",
    "name": "IPC Eagle BB2000 20\" Battery Powered Floor Burnisher - 2000 RPM",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-bb2000-battery-floor-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 8049,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-bb20n-battery-powered-floor-burnisher.jpg?v=1782339321",
    "searchKeywords": "Eagle, BB2000, Battery, Powered, Floor, Burnisher, 2000",
    "sku": "EAG-BB20N-210",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "7500_15000"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct71-28-inch-automatic-floor-scrubber-demo",
    "name": "IPC Eagle CT71 Traction Drive 28\" Automatic Floor Scrubber - 19 Gallons (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct71-28-inch-automatic-floor-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 7875,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/eag-ct71bt70-obc-p-145_1.jpg?v=1782339344",
    "searchKeywords": "Eagle, CT71, Traction, Drive, Automatic, Floor, Scrubber, Gallons, (Refurbished)",
    "sku": "EAG-CT71BT70-OBC-P-145-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-hotsy-cwc-53-stationary-pressure-washer",
    "name": "Hotsy® CWC-53 Stationary 4.0 GPM Pressure Washer (Electric) - 3,000 PSI",
    "url": "https://thecleaningbusiness.com/products/hotsy-cwc-53-stationary-pressure-washer",
    "type": "product",
    "productCategory": "machine",
    "price": 7815,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/hotsy-cwc-stationary-pressure-washer-11065720.jpg?v=1782339367",
    "searchKeywords": "Hotsy┬«, CWC-53, Stationary, Pressure, Washer, (Electric), 3,000",
    "sku": "WET-11065720",
    "bestFor": [
      "degreasing",
      "7500_15000"
    ]
  },
  {
    "id": "machine-viper-fang-26t-automatic-floor-scrubber",
    "name": "Viper Fang 26T Automatic Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/viper-fang-26t-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 7807,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper_24t_195_lg_2.jpg?v=1782339388",
    "searchKeywords": "Viper, Fang, Automatic, Floor, Scrubber",
    "sku": "VIP-FANG26T-215",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-as5160to-walk-behind-orbital-auto-scrubber",
    "name": "Viper AS5160TO™ Walk Behind Orbital Auto Floor Scrubber (14\" x 20\" Head) w/ Traction Drive",
    "url": "https://thecleaningbusiness.com/products/viper-as5160to-walk-behind-orbital-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 7781,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as5160-aut-scrubber-56394138-front.jpg?v=1782339418",
    "searchKeywords": "Viper, AS5160TOΓäó, Walk, Behind, Orbital, Auto, Floor, Scrubber, (14\", Head), Traction, Drive",
    "sku": "VIP-56394138",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-large-capacity-self-contained-extractor",
    "name": "Tornado® Marathon 2000 Self Contained Extractor (20 Gallons) - 19\" Head",
    "url": "https://thecleaningbusiness.com/products/large-capacity-self-contained-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 7699,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-marathon-2000-self-contained-carpet-extractor-98190.webp?v=1782339447",
    "searchKeywords": "Tornado┬«, Marathon, 2000, Self, Contained, Extractor, Gallons), Head",
    "sku": "TOR-98190",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "7500_15000"
    ]
  },
  {
    "id": "machine-kawasaki-high-speed-propane-buffer",
    "name": "Pioneer Eclipse High Speed 28\" Propane Burnisher w/ 18 HP Kawasaki Engine - 1,500 RPM",
    "url": "https://thecleaningbusiness.com/products/kawasaki-high-speed-propane-buffer",
    "type": "product",
    "productCategory": "machine",
    "price": 7582.38,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-420bu28bcsx-propane-burnisher.jpg?v=1782339471",
    "searchKeywords": "Pioneer, Eclipse, High, Speed, Propane, Burnisher, Kawasaki, Engine, 1,500",
    "sku": "PIO-420BU28BCSX",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "7500_15000"
    ]
  },
  {
    "id": "machine-viper-fang-26t-automatic-floor-scrubber-demo",
    "name": "Viper Fang 26T Automatic Floor Scrubber (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/viper-fang-26t-automatic-floor-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 7350,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper_24t_195_lg_2_2.jpg?v=1782339497",
    "searchKeywords": "Viper, Fang, Automatic, Floor, Scrubber, (Refurbished)",
    "sku": "VIP-FANG26T-215-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-edic-1200psn-supernova-2-way-self-contained-carpet-extractor",
    "name": "EDIC 1200PSN Supernova™ 2-Way Self-Contained Carpet Extractor (12 Gallons) - 19\" Head",
    "url": "https://thecleaningbusiness.com/products/edic-1200psn-supernova-2-way-self-contained-carpet-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 7292,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/edic-1200psn-extractor.jpg?v=1782339530",
    "searchKeywords": "EDIC, 1200PSN, SupernovaΓäó, 2-Way, Self-Contained, Carpet, Extractor, Gallons), Head",
    "sku": "EDI-1200PSN",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-24-inch-420bu-propane-floor-burnisher",
    "name": "Pioneer Eclipse High Speed 24\" Propane Floor Burnisher w/ 18 HP Kawasaki Engine - 1,800 RPM",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-24-inch-420bu-propane-floor-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 7276.92,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/fuel-efficient-propane-burnisher.jpg?v=1782339553",
    "searchKeywords": "Pioneer, Eclipse, High, Speed, Propane, Floor, Burnisher, Kawasaki, Engine, 1,800",
    "sku": "PIO-420BU24BCSVX",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "3000_7500"
    ]
  },
  {
    "id": "machine-cleanfreak-cfh-4035g-b-hot-water-pressure-washer-gas-engine",
    "name": "CleanFreak® Hot Water 4.0 GPM Pressure Washer (Gas Engine) – 3,500 PSI",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-cfh-4035g-b-hot-water-pressure-washer-gas-engine",
    "type": "product",
    "productCategory": "machine",
    "price": 6999.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-cfh-4035g-b-pressure-washer_c7a0094f-1482-4dc0-8543-f13e2aa07da8.jpg?v=1782339578",
    "searchKeywords": "CleanFreak┬«, Water, Pressure, Washer, (Gas, Engine), 3,500",
    "sku": "WET-CFH-4035G-B",
    "bestFor": [
      "degreasing",
      "3000_7500"
    ]
  },
  {
    "id": "machine-2-way-carpet-scrubbing-machine",
    "name": "EDIC 800PSN Supernova™ 2-Way Carpet Scrubbing Machine (8 Gallons) - 19\" Head",
    "url": "https://thecleaningbusiness.com/products/2-way-carpet-scrubbing-machine",
    "type": "product",
    "productCategory": "machine",
    "price": 6984,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/edic-supernova-800psn-2-way-carpet-scrubbing-machine.jpg?v=1782339601",
    "searchKeywords": "EDIC, 800PSN, SupernovaΓäó, 2-Way, Carpet, Scrubbing, Machine, Gallons), Head",
    "sku": "EDI-800PSN",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-green-eco-friendly-auto-scrubber",
    "name": "IPC Eagle CT40 ECS Green Eco-Friendly 20\" Automatic Floor Scrubber w/ Bonnet Driver - 10 Gallons",
    "url": "https://thecleaningbusiness.com/products/green-eco-friendly-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6980,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/eagle_ecofriendly_scrubberl.jpg?v=1782339625",
    "searchKeywords": "Eagle, CT40, Green, Eco-Friendly, Automatic, Floor, Scrubber, Bonnet, Driver, Gallons",
    "sku": "EAG-CT40ECS-115-KTRI01763",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-tile-cleaning-extractor",
    "name": "EDIC Endeavor™ Tile Cleaning Extractor (Heated & Non-Heated Options)",
    "url": "https://thecleaningbusiness.com/products/tile-cleaning-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 6899.25,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/edic-endeavor-tile-and-grout-cleaning-machine.jpg?v=1782339655",
    "searchKeywords": "EDIC, EndeavorΓäó, Tile, Cleaning, Extractor, (Heated, Non-Heated, Options)",
    "sku": "EDI-9000I-HS",
    "bestFor": [
      "carpet_extraction",
      "tile",
      "hard_floor",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-cleanfreak-5-gpm-3500-psi-hot-water-pressure-washer-skid",
    "name": "CleanFreak® Hot Water 5.0 GPM Pressure Washer Skid & Cage (Gas Engine) – 3,500 PSI",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-5-gpm-3500-psi-hot-water-pressure-washer-skid",
    "type": "product",
    "productCategory": "machine",
    "price": 6850,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-3500-psi-5-gpm-heated-self-contained-gas-pressure-washer.jpg?v=1782339685",
    "searchKeywords": "CleanFreak┬«, Water, Pressure, Washer, Skid, Cage, (Gas, Engine), 3,500",
    "sku": "WET-A04-2058-10B",
    "bestFor": [
      "degreasing",
      "3000_7500"
    ]
  },
  {
    "id": "machine-ipc-eagle-21-inch-propane-burnisher",
    "name": "IPC Eagle 21\" Propane Floor Burnisher - 2,100 RPM",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-21-inch-propane-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 6795,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/21-inch-high-speed-floor-polisher-machine.jpg?v=1782339708",
    "searchKeywords": "Eagle, Propane, Floor, Burnisher, 2,100",
    "sku": "EAG-A680189",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-14x24-inch-automatic-floor-scrubber-demo",
    "name": "Clarke® CA60 24B Boost® Automatic Floor Scrubber - 14\" x 24\" Head (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/clarke-14x24-inch-automatic-floor-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 6675,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ca60-24b-boost-front-left_1.jpg?v=1782339734",
    "searchKeywords": "Clarke┬«, CA60, Boost┬«, Automatic, Floor, Scrubber, Head, (Refurbished)",
    "sku": "CRK-56385418-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-gas-powered-hard-floor-vacuum-sweeper",
    "name": "IPC Eagle 36\" Gas Powered Hard Floor Vacuum Sweeper",
    "url": "https://thecleaningbusiness.com/products/gas-powered-hard-floor-vacuum-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 6675,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-712-36-inch-walk-behind-gas-sweeper.jpg?v=1782339762",
    "searchKeywords": "Eagle, Powered, Hard, Floor, Vacuum, Sweeper",
    "sku": "EAG-TKS712GT",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "hard_floor",
      "commercial_vacuum",
      "sweeper",
      "3000_7500"
    ]
  },
  {
    "id": "machine-viper-as5160t-walk-behind-20-inch-floor-scrubber-with-traction-drive",
    "name": "Viper AS5160T™ Walk Behind 20\" Floor Scrubber w/ Traction Drive - 16 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as5160t-walk-behind-20-inch-floor-scrubber-with-traction-drive",
    "type": "product",
    "productCategory": "machine",
    "price": 6591,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as5160-auto-scrubber-w-brush-and-skirt_3.jpg?v=1782339795",
    "searchKeywords": "Viper, AS5160TΓäó, Walk, Behind, Floor, Scrubber, Traction, Drive, Gallons",
    "sku": "VIP-56384814",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-28-inch-walk-behind-battery-sweeper",
    "name": "IPC Eagle 512ET Battery Powered 28\" Walk Behind Vacuum Sweeper",
    "url": "https://thecleaningbusiness.com/products/28-inch-walk-behind-battery-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 6578,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-512-28-inch-walk-behind-battery-sweeper.jpg?v=1782339825",
    "searchKeywords": "Eagle, 512ET, Battery, Powered, Walk, Behind, Vacuum, Sweeper",
    "sku": "EAG-512ET135",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "commercial_vacuum",
      "sweeper",
      "3000_7500"
    ]
  },
  {
    "id": "machine-advance-es400-xlp-self-contained-carpet-extractor",
    "name": "Advance® ES400™ XLP Self Contained Carpet Extractor (12 Gallons) - 18\" Head",
    "url": "https://thecleaningbusiness.com/products/advance-es400-xlp-self-contained-carpet-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 6494,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-es400-xlp-extractor-56265501.jpg?v=1782339855",
    "searchKeywords": "Advance┬«, ES400Γäó, Self, Contained, Carpet, Extractor, Gallons), Head",
    "sku": "NFA-56265501",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-20-in-ipc-eagle-ecs-auto-scrubber-demo",
    "name": "20 inch IPC Eagle ECS Auto Scrubber (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/20-in-ipc-eagle-ecs-auto-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 6475,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct40-ecs-auto-scrubber.jpg?v=1782339886",
    "searchKeywords": "inch, Eagle, Auto, Scrubber, (Refurbished)",
    "sku": "EAG-CT40ECSBT-115-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-ca30-20b-battery-powered-automatic-floor-scrubber",
    "name": "Clarke® CA30™ 20B Battery Powered Automatic Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-ca30-20b-battery-powered-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6268,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ca30-20b-battery-powered-auto-scrubber-w-pad-driver.jpg?v=1782339910",
    "searchKeywords": "Clarke┬«, CA30Γäó, Battery, Powered, Automatic, Floor, Scrubber",
    "sku": "CRK-CLARKE510B",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-focusr-ii-l20-boost-auto-scrubber",
    "name": "Clarke® Focus® II L20 Boost Auto Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-focusr-ii-l20-boost-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6227,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-l20-boost-right-quarter.jpg?v=1782339936",
    "searchKeywords": "Clarke┬«, Focus┬«, Boost, Auto, Scrubber",
    "sku": "CRK-05361A",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-edic-endeavor-heated-tile-cleaning-extractor-demo",
    "name": "EDIC Endeavor™ Heated Carpet & Tile Cleaning Extractor (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/edic-endeavor-heated-tile-cleaning-extractor-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 6225,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/edic-endeavor-tile-and-grout-machine-demo.jpg?v=1782339959",
    "searchKeywords": "EDIC, EndeavorΓäó, Heated, Carpet, Tile, Cleaning, Extractor, (Refurbished)",
    "sku": "EDI-9000I-HSH-DEMO",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "tile",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-20-inch-minuteman-12-gallon-commercial-auto-scrubber",
    "name": "Minuteman® 20\" Commercial E20 Automatic Floor Scrubber (#E20BDQP) - 12 Gallon",
    "url": "https://thecleaningbusiness.com/products/20-inch-minuteman-12-gallon-commercial-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6112.43,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_e20_lg.jpg?v=1782339990",
    "searchKeywords": "Minuteman┬«, Commercial, Automatic, Floor, Scrubber, (#E20BDQP), Gallon",
    "sku": "MIN-E20BDQP",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-ca60-20d-walk-behind-auto-scrubber",
    "name": "Clarke® CA60 20D Walk Behind Auto Scrubber - 20\" Disc Head",
    "url": "https://thecleaningbusiness.com/products/clarke-ca60-20d-walk-behind-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6073,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ca60-20d-auto-scrubber-front-right.jpg?v=1782340013",
    "searchKeywords": "Clarke┬«, CA60, Walk, Behind, Auto, Scrubber, Disc, Head",
    "sku": "CRK-56385411",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "chemical-contractors-carpet-cleaning-package",
    "name": "Trusted Clean 'Maximum' Contractor Carpet Cleaning Package w/ Extractor, Floor Buffer & Spotter",
    "url": "https://thecleaningbusiness.com/products/contractors-carpet-cleaning-package",
    "type": "product",
    "productCategory": "chemical",
    "price": 6030.86,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cpt-package3-v12.jpg?v=1782340044",
    "searchKeywords": "Trusted, Clean, 'Maximum', Contractor, Carpet, Cleaning, Package, Extractor,, Floor, Buffer, Spotter",
    "sku": "CPT-PACKAGE3",
    "bestFor": [
      "carpet_extraction",
      "hard_floor_scrubbing",
      "contractor",
      "carpet",
      "hard_floor",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "floor_buffer",
      "3000_7500"
    ]
  },
  {
    "id": "machine-direct-drive-auto-scrubber",
    "name": "Viper Fang 20\" Direct Drive Auto Scrubber",
    "url": "https://thecleaningbusiness.com/products/direct-drive-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5971,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper_direct_drive_scrubber_lg.jpg?v=1782340074",
    "searchKeywords": "Viper, Fang, Direct, Drive, Auto, Scrubber",
    "sku": "VIP-FANG20HD-215",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-28-inch-vacuum-floor-sweeper",
    "name": "Clarke® BSW 28\" Battery Powered Floor Sweeper",
    "url": "https://thecleaningbusiness.com/products/clarke-28-inch-vacuum-floor-sweeper",
    "type": "product",
    "productCategory": "machine",
    "price": 5902,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-bsw-28-vacuum-sweeper.jpg?v=1782340100",
    "searchKeywords": "Clarke┬«, Battery, Powered, Floor, Sweeper",
    "sku": "CRK-9084705010",
    "bestFor": [
      "hard_floor_scrubbing",
      "sweeper",
      "3000_7500"
    ]
  },
  {
    "id": "machine-hard-surface-floor-scrubber-package",
    "name": "CleanFreak® 'Performer 20' Automatic Floor Scrubber Package",
    "url": "https://thecleaningbusiness.com/products/hard-surface-floor-scrubber-package",
    "type": "product",
    "productCategory": "machine",
    "price": 5808.88,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/asp-package1-v5.jpg?v=1782340127",
    "searchKeywords": "CleanFreak┬«, 'Performer, Automatic, Floor, Scrubber, Package",
    "sku": "ASP-PACKAGE1",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-mytee-escape-adjustable-500-psi-portable-truckmount-carpet-extractor",
    "name": "Mytee® Escape™ Adjustable 500 PSI Portable Truckmount Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/mytee-escape-adjustable-500-psi-portable-truckmount-carpet-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 5700,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-excape-etm-lx_1.jpg?v=1782340158",
    "searchKeywords": "Mytee┬«, EscapeΓäó, Adjustable, Portable, Truckmount, Carpet, Extractor",
    "sku": "MYT-ETM-LX-115",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-large-area-carpet-cleaning-scrubber",
    "name": "IPC Eagle SC12 Fastracts Large Area Self-Contained Carpet Cleaning Scrubber (12 Gallons) - 19\" Head",
    "url": "https://thecleaningbusiness.com/products/large-area-carpet-cleaning-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5647,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-sc12-fastracts-large-area-carpet-cleaning-scrubber.jpg?v=1782340188",
    "searchKeywords": "Eagle, SC12, Fastracts, Large, Area, Self-Contained, Carpet, Cleaning, Scrubber, Gallons), Head",
    "sku": "EAG-FXSC12",
    "bestFor": [
      "carpet_extraction",
      "hard_floor_scrubbing",
      "carpet",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-task-pro-20-inch-16-gallon-automatic-floor-scrubber-demo",
    "name": "Task-Pro™ 20\" Battery Powered TP5160 Automatic Floor Scrubber - 16 Gallon (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/task-pro-20-inch-16-gallon-automatic-floor-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 5640,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tp5160-floor-scrubber-demo.jpg?v=1782340212",
    "searchKeywords": "Task-ProΓäó, Battery, Powered, TP5160, Automatic, Floor, Scrubber, Gallon, (Refurbished)",
    "sku": "TAS-56385018-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-task-pro-tp5160-20-inch-battery-powered-automatic-floor-scrubber-16-gallon",
    "name": "Task-Pro™ 20\" Battery Powered TP5160 Automatic Floor Scrubber - 16 Gallon",
    "url": "https://thecleaningbusiness.com/products/task-pro-tp5160-20-inch-battery-powered-automatic-floor-scrubber-16-gallon",
    "type": "product",
    "productCategory": "machine",
    "price": 5640,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tp5160-with-pad-wht-rt.jpg?v=1782340235",
    "searchKeywords": "Task-ProΓäó, Battery, Powered, TP5160, Automatic, Floor, Scrubber, Gallon",
    "sku": "TAS-56385018",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-pacific-floorcare-s20-automatic-floor-scrubber-demo",
    "name": "Pacific Floorcare® S-20 Automatic Push Floor Scrubber (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s20-automatic-floor-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 5625,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-s20-battery-scrubber-lg_2.jpg?v=1782340259",
    "searchKeywords": "Pacific, Floorcare┬«, S-20, Automatic, Push, Floor, Scrubber, (Refurbished)",
    "sku": "PAC-855401-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-400-series-28-inch-propane-floor-burnisher",
    "name": "Pioneer Eclipse 400 Series 28\" High Speed Propane Floor Burnisher - 1,500 RPM",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-400-series-28-inch-propane-floor-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 5612.71,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-400-series-28-inch-propane-floor-burnisher-400bu28bsm.jpg?v=1782340288",
    "searchKeywords": "Pioneer, Eclipse, Series, High, Speed, Propane, Floor, Burnisher, 1,500",
    "sku": "PIO-400BU28BSM",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "3000_7500"
    ]
  },
  {
    "id": "machine-viper-battery-floor-scrubber",
    "name": "Viper Battery Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/viper-battery-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5560,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-fang20.jpg?v=1782340313",
    "searchKeywords": "Viper, Battery, Floor, Scrubber",
    "sku": "VIP-FANG20-105",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-21-inch-economy-propane-burnisher",
    "name": "Pioneer Eclipse High Speed 21\" Economy Propane Floor Burnisher w/ 18 HP Kawasaki Engine - 2,000 RPM",
    "url": "https://thecleaningbusiness.com/products/21-inch-economy-propane-burnisher",
    "type": "product",
    "productCategory": "machine",
    "price": 5438.4,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/21-inch-high-speed-propane-floor-buffer.jpg?v=1782340336",
    "searchKeywords": "Pioneer, Eclipse, High, Speed, Economy, Propane, Floor, Burnisher, Kawasaki, Engine, 2,000",
    "sku": "PIO-400BU21BSM",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "burnisher",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-fm40-orbital-floor-buffer",
    "name": "Clarke® FM40™ Orbital Floor Buffer",
    "url": "https://thecleaningbusiness.com/products/clarke-fm40-orbital-floor-buffer",
    "type": "product",
    "productCategory": "machine",
    "price": 5378,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-fm-st-orbital-floor-buffer.jpg?v=1782340361",
    "searchKeywords": "Clarke┬«, FM40Γäó, Orbital, Floor, Buffer",
    "sku": "CRK-56105618",
    "bestFor": [
      "hard_floor_scrubbing",
      "hard_floor",
      "floor_buffer",
      "3000_7500"
    ]
  },
  {
    "id": "part-cleanfreak-3500-psi-skid-mount-gas-pressure-washer",
    "name": "CleanFreak® Skid Mount Honda GX690 Engine w/ 8.0 GPM General Pump Pressure Washer (Gas) - 3,500 PSI",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-3500-psi-skid-mount-gas-pressure-washer",
    "type": "product",
    "productCategory": "part",
    "price": 5314.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-acf4-1000-skid-mounted-gas-powered-pressure-washer.jpg?v=1782340388",
    "searchKeywords": "CleanFreak┬«, Skid, Mount, Honda, GX690, Engine, General, Pump, Pressure, Washer, (Gas), 3,500",
    "sku": "WET-ACF4-1000",
    "bestFor": [
      "degreasing",
      "parts",
      "3000_7500"
    ]
  },
  {
    "id": "machine-tennant-ex-sc-1020-self-contained-carpet-extractor",
    "name": "Tennant® EX-SC-1020 Self-Contained Carpet Extractor (10 Gallons) - 17\" Head",
    "url": "https://thecleaningbusiness.com/products/tennant-ex-sc-1020-self-contained-carpet-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 5242,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-ex-sc-1020-self-contained-carpet-cleaning-extractor.jpg?v=1782340414",
    "searchKeywords": "Tennant┬«, EX-SC-1020, Self-Contained, Carpet, Extractor, Gallons), Head",
    "sku": "TEN-9007486",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-wide-area-industrial-floor-scrubber-demo",
    "name": "CleanFreak® 'Performer 24' Wide Area Floor Scrubber (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/wide-area-industrial-floor-scrubber-demo",
    "type": "product",
    "productCategory": "machine",
    "price": 5225,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-performer-24-auto-scrubber_1.jpg?v=1782340445",
    "searchKeywords": "CleanFreak┬«, 'Performer, Wide, Area, Floor, Scrubber, (Refurbished)",
    "sku": "IES-24-SLND-DEMO",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-vantage-14-auto-scrubber",
    "name": "Clarke® Vantage 14 Auto Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-vantage-14-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5181,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-vantage-14.jpg?v=1782340470",
    "searchKeywords": "Clarke┬«, Vantage, Auto, Scrubber",
    "sku": "CRK-9087345020",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-clarke-ex40-18lx-self-contained-2-way-carpet-shampooer",
    "name": "Clarke® EX40™ 18LX Self Contained 2-Way Carpet Scrubber (12 Gallons) - 18\" Head",
    "url": "https://thecleaningbusiness.com/products/clarke-ex40-18lx-self-contained-2-way-carpet-shampooer",
    "type": "product",
    "productCategory": "machine",
    "price": 5181,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clark-self-contained-carpet-extractor-56265505.jpg?v=1782340500",
    "searchKeywords": "Clarke┬«, EX40Γäó, 18LX, Self, Contained, 2-Way, Carpet, Scrubber, Gallons), Head",
    "sku": "CRK-56265505",
    "bestFor": [
      "carpet_extraction",
      "hard_floor_scrubbing",
      "carpet",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-concrete-grinder-recovery-vacuum",
    "name": "Concrete Grinder Recovery Vacuum",
    "url": "https://thecleaningbusiness.com/products/concrete-grinder-recovery-vacuum",
    "type": "product",
    "productCategory": "machine",
    "price": 5142,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/substrate-grinder-vacuum.jpg?v=1782340527",
    "searchKeywords": "Concrete, Grinder, Recovery, Vacuum",
    "sku": "EAG-S9PLANET200TOPT",
    "bestFor": [
      "daily_vacuuming",
      "concrete",
      "commercial_vacuum",
      "3000_7500"
    ]
  },
  {
    "id": "machine-pacific-floorcare-sce-20-self-contained-extractor",
    "name": "Pacific Floorcare® SCE-20 Self-Contained Extractor (9 Gallons) - 20\" Head",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-sce-20-self-contained-extractor",
    "type": "product",
    "productCategory": "machine",
    "price": 5115.01,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-sce-20-self-contained-carpet-extractor.jpg?v=1782340550",
    "searchKeywords": "Pacific, Floorcare┬«, SCE-20, Self-Contained, Extractor, Gallons), Head",
    "sku": "PAC-265401",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-tennant-i-mop-walk-behind-floor-scrubber",
    "name": "Tennant® i-mop® Walk Behind Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/tennant-i-mop-walk-behind-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5099,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/i-mop-all-versions.jpg?v=1782340570",
    "searchKeywords": "Tennant┬«, i-mop┬«, Walk, Behind, Floor, Scrubber",
    "sku": "TEN-8004533",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-ipc-eagle-ct231-automatic-ride-on-floor-scrubber",
    "name": "IPC Eagle CT231 Automatic Ride-On Floor Scrubber w/ Brushes (42\" Scrub Deck) - 54 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct231-automatic-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 39361,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct231-ride-on-floor-scrubber-v2.jpg?v=1782357838",
    "searchKeywords": "Eagle, CT231, Automatic, Ride-On, Floor, Scrubber, Brushes, (42\", Scrub, Deck), Gallons",
    "sku": "EAG-CT231BT105-B-350",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-viper-as1050r-ride-on-floor-scrubber",
    "name": "Viper AS1050R 39\" Ride-On Floor Scrubber w/ Pad Drivers & Brushes - 53 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as1050r-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 24030,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/024ebef012a159c65ef1c9aa98063ee915814454.jpg?v=1782357848",
    "searchKeywords": "Viper, AS1050R, Ride-On, Floor, Scrubber, Drivers, Brushes, Gallons",
    "sku": "VIP-AS1050R-420",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-tennant-t600-self-propelled-walk-behind-floor-scrubber",
    "name": "Tennant® T600 Self-Propelled Walk Behind Automatic Floor Scrubber w/ Pad Drivers (28\", 32\" & 36\" Dec",
    "url": "https://thecleaningbusiness.com/products/tennant-t600-self-propelled-walk-behind-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 23423,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t600-walk-behind-floor-scrubber-2.jpg?v=1782357854",
    "searchKeywords": "Tennant┬«, T600, Self-Propelled, Walk, Behind, Automatic, Floor, Scrubber, Drivers, (28\",, Deck, Options), Gallons",
    "sku": "TEN-T600-700D-2000095",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-ipc-eagle-32-inch-auto-rider-scrubber",
    "name": "IPC Eagle CT160 Automatic Rider Floor Scrubber w/ Brushes (32\" Scrub Deck) - 39 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-32-inch-auto-rider-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 22818,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct160-automatic-ride-on-scrubber_1.jpg?v=1782357863",
    "searchKeywords": "Eagle, CT160, Automatic, Rider, Floor, Scrubber, Brushes, (32\", Scrub, Deck), Gallons",
    "sku": "EAG-CT160BT85-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-28-inch-automatic-ride-on-scrubber",
    "name": "IPC Eagle CT160 Industrial Automatic Ride On Floor Scrubber w/ Brushes (28\" Scrub Deck) - 39 Gallons",
    "url": "https://thecleaningbusiness.com/products/28-inch-automatic-ride-on-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 21492,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct160-automatic-ride-on-scrubber.jpg?v=1782357871",
    "searchKeywords": "Eagle, CT160, Industrial, Automatic, Ride, Floor, Scrubber, Brushes, (28\", Scrub, Deck), Gallons",
    "sku": "EAG-CT160BT70-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-tornado-br-33-30-rider-auto-scrubber-w-cylindrical-brushes",
    "name": "Tornado® BR 33/30 Rider Auto Scrubber w/ Cylindrical Brushes",
    "url": "https://thecleaningbusiness.com/products/tornado-br-33-30-rider-auto-scrubber-w-cylindrical-brushes",
    "type": "product",
    "productCategory": "part",
    "price": 21450,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-99785c-33-inch-cylindrical-rider-scrubber.jpg?v=1782357878",
    "searchKeywords": "Tornado┬«, 33/30, Rider, Auto, Scrubber, Cylindrical, Brushes",
    "sku": "TOR-99785C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-torando-bd-33-30-rider-auto-scrubber-w-pad-drivers",
    "name": "Torando® BD 33/30 Rider Auto Scrubber w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/torando-bd-33-30-rider-auto-scrubber-w-pad-drivers",
    "type": "product",
    "productCategory": "machine",
    "price": 20841,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-bd-33-30-disc-rider-scrubber-99780c.jpg?v=1782357884",
    "searchKeywords": "Torando┬«, 33/30, Rider, Auto, Scrubber, Drivers",
    "sku": "TOR-99780C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-tornado-br-28-27-rider-auto-scrubber-w-cylindrical-brushes-27-gallons",
    "name": "Tornado® BR 28/27 Rider Auto Scrubber w/ Cylindrical Brushes - 27 Gallons",
    "url": "https://thecleaningbusiness.com/products/tornado-br-28-27-rider-auto-scrubber-w-cylindrical-brushes-27-gallons",
    "type": "product",
    "productCategory": "part",
    "price": 18499,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-28-inch-ride-on-scrubber.jpg?v=1782357890",
    "searchKeywords": "Tornado┬«, 28/27, Rider, Auto, Scrubber, Cylindrical, Brushes, Gallons",
    "sku": "TOR-99775C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-compact-floor-scrubbing-rider-machine",
    "name": "IPC Eagle CT110 Compact Rider Floor Scrubber w/ Brushes (28\" Scrub Deck) - 29 Gallons",
    "url": "https://thecleaningbusiness.com/products/compact-floor-scrubbing-rider-machine",
    "type": "product",
    "productCategory": "part",
    "price": 17299,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct110bt70-28-inch-rider-floor-scrubber.jpg?v=1782357899",
    "searchKeywords": "Eagle, CT110, Compact, Rider, Floor, Scrubber, Brushes, (28\", Scrub, Deck), Gallons",
    "sku": "EAG-CT110BT70-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-sc800-st-34-inch-battery-floor-scrubber",
    "name": "Advance® SC800™ ST 34\" Battery Powered Floor Scrubber w/ Pad Holders",
    "url": "https://thecleaningbusiness.com/products/advance-sc800-st-34-inch-battery-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 16988,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc750-st-scrubber_1.jpg?v=1782357905",
    "searchKeywords": "Advance┬«, SC800Γäó, Battery, Powered, Floor, Scrubber, Holders",
    "sku": "NFA-56112456",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-viper-as710r-28-rider-scrubber",
    "name": "Viper AS710R™ Rider Floor Scrubber w/ Brushes (28\" Scrub Deck) - 32 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as710r-28-rider-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 16227,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as710r-28-rider-scrubber.jpg?v=1782357912",
    "searchKeywords": "Viper, AS710RΓäó, Rider, Floor, Scrubber, Brushes, (28\", Scrub, Deck), Gallons",
    "sku": "VIP-50000318",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-tennant-t500e-26-inch-walk-behind-floor-scrubber",
    "name": "Tennant® T500e Self-Propelled 26\" Walk Behind Automatic Floor Scrubber w/ Pad Drivers - 22.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/tennant-t500e-26-inch-walk-behind-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 15992,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t500e-26-inch-walk-behind-floor-scrubber.jpg?v=1782357920",
    "searchKeywords": "Tennant┬«, T500e, Self-Propelled, Walk, Behind, Automatic, Floor, Scrubber, Drivers, 22.5, Gallons",
    "sku": "TEN-T500E-1001D",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-sc750-28-inch-battery-floor-scrubber-w-pad-holders",
    "name": "Advance® SC750™ 28\" Battery Floor Scrubber w/ Pad Holders",
    "url": "https://thecleaningbusiness.com/products/advance-sc750-28-inch-battery-floor-scrubber-w-pad-holders",
    "type": "product",
    "productCategory": "machine",
    "price": 15836,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc750-28-inch-scrubber.jpg?v=1782357928",
    "searchKeywords": "Advance┬«, SC750Γäó, Battery, Floor, Scrubber, Holders",
    "sku": "NFA-56112361",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-advance-sc901-28-inch-commercial-battery-floor-scrubber-w-pad-driver",
    "name": "Advance® SC901™ 28\" Commercial Battery Floor Scrubber w/ Pad Driver",
    "url": "https://thecleaningbusiness.com/products/advance-sc901-28-inch-commercial-battery-floor-scrubber-w-pad-driver",
    "type": "product",
    "productCategory": "machine",
    "price": 15721,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sc900-advance-floor-scrubber.jpg?v=1782357934",
    "searchKeywords": "Advance┬«, SC901Γäó, Commercial, Battery, Floor, Scrubber, Driver",
    "sku": "NFA-56115535",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-ipc-eagle-28-in-rider-automatic-scrubber-ct80-series",
    "name": "IPC Eagle CT80 Compact Rider Automatic Floor Scrubber w/ Brushes (28\" Scrub Deck) - 21 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-28-in-rider-automatic-scrubber-ct80-series",
    "type": "product",
    "productCategory": "part",
    "price": 15309,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct80-scrubber_1-v2.jpg?v=1782357941",
    "searchKeywords": "Eagle, CT80, Compact, Rider, Automatic, Floor, Scrubber, Brushes, (28\", Scrub, Deck), Gallons",
    "sku": "EAG-CT80BT70-B-240OBC",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber",
    "name": "Pacific Floorcare® 32\" Battery Powered S-32 Auto Scrubber (22 Gallon) w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 15151.36,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber.jpg?v=1782357949",
    "searchKeywords": "Pacific, Floorcare┬«, Battery, Powered, S-32, Auto, Scrubber, Gallon), Drivers",
    "sku": "PAC-875417",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-ipc-eagle-ct105-battery-powered-floor-scrubber",
    "name": "IPC Eagle CT105 Battery Powered Walk Behind Floor Scrubber w/ Brushes (28\" & 32\" Deck Options) - 26 ",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct105-battery-powered-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 15015,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct105-walk-behind-floor-scrubber.jpg?v=1782357956",
    "searchKeywords": "Eagle, CT105, Battery, Powered, Walk, Behind, Floor, Scrubber, Brushes, (28\", Deck, Options), Gallons",
    "sku": "EAG-CT105BT70-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-tornado-bd-26-27-rider-auto-scrubber-w-pad-drivers-27-gallons",
    "name": "Tornado® BD 26/27 Rider Auto Scrubber w/ Pad Drivers - 27 Gallons",
    "url": "https://thecleaningbusiness.com/products/tornado-bd-26-27-rider-auto-scrubber-w-pad-drivers-27-gallons",
    "type": "product",
    "productCategory": "machine",
    "price": 14795,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-26-27-ride-on-scrubber.jpg?v=1782359175",
    "searchKeywords": "Tornado┬«, 26/27, Rider, Auto, Scrubber, Drivers, Gallons",
    "sku": "TOR-99772C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-advance-sc750-st-26-inch-battery-floor-scrubber",
    "name": "Advance® SC750™ ST 26\" Battery Floor Scrubber w/ Pad Holders",
    "url": "https://thecleaningbusiness.com/products/advance-sc750-st-26-inch-battery-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 14396,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc750-st-scrubber.jpg?v=1782359183",
    "searchKeywords": "Advance┬«, SC750Γäó, Battery, Floor, Scrubber, Holders",
    "sku": "NFA-56112379",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-pacific-floorcare-28-inch-battery-powered-s-28-floor-scrubber",
    "name": "Pacific Floorcare® 28\" Battery Powered S-28 Floor Scrubber (22 Gallon) w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-28-inch-battery-powered-s-28-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 14071.74,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-875409-s-28-floor-scrubber.jpg?v=1782359190",
    "searchKeywords": "Pacific, Floorcare┬«, Battery, Powered, S-28, Floor, Scrubber, Gallon), Drivers",
    "sku": "PAC-875409",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-4",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-4",
    "type": "product",
    "productCategory": "machine",
    "price": 30556.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_f12b8dff-8248-4131-90fc-24efe9b23277.jpg?v=1782495472",
    "searchKeywords": "850/T, Compact, Ride-On, Adjustable, Auto, Scrubber, Lithium, Phosphate, 850/300T",
    "sku": "28467",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-3",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-3",
    "type": "product",
    "productCategory": "machine",
    "price": 29016.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_889309c8-0e32-4215-a01c-b9e7851a0bca.jpg?v=1782495488",
    "searchKeywords": "850/T, Compact, Ride-On, Adjustable, Auto, Scrubber, Lithium, Phosphate, 850/250T",
    "sku": "28466",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-2",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-2",
    "type": "product",
    "productCategory": "machine",
    "price": 27916.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_f061d4f3-4452-4b76-b1cc-a800b875878c.jpg?v=1782495558",
    "searchKeywords": "850/T, Compact, Ride-On, Adjustable, Auto, Scrubber, Lithium, Phosphate, 850/200T",
    "sku": "28465",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-br-33-30-ride-on-automatic-scrubber-33-30-gal-cylindrical-brush-includes-batteri-2",
    "name": "BR 33/30 Ride-On Automatic Scrubber - 33\" - 30 GAL - Cylindrical Brush - Includes Batteries and Stan",
    "url": "https://www.thecleaningbusiness.com/products/br-33-30-ride-on-automatic-scrubber-33-30-gal-cylindrical-brush-includes-batteri-2",
    "type": "product",
    "productCategory": "part",
    "price": 26663,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/br-33-30-ride-on-automatic-scrubber-w-wet-acid-batteries-33-30-gal-cylindrical-brush-includes-3-99812-12v-225ah-lead-acid-batteries-and-1-99515-36v-20-amp-standard-charger-2-pad-drive.png?v=1782495519",
    "searchKeywords": "33/30, Ride-On, Automatic, Scrubber, Cylindrical, Brush, Includes, Batteries, Standard, Charger;, Drivers, Brushes, Required, 99785CG, Batteries",
    "sku": "28529",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-gal-tvl-85",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-gal-tvl-85",
    "type": "product",
    "productCategory": "machine",
    "price": 26376.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_36c4a730-c4b5-4206-a728-8473d6659065.jpg?v=1782495538",
    "searchKeywords": "850/T, Compact, Ride-On, Adjustable, Auto, Scrubber, Lithium, Phosphate, 850/150T",
    "sku": "28464",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-33-cylindrical-sm3332cqp-284",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 33\" Cylindrical (SM3332CQP)",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-33-cylindrical-sm3332cqp-284",
    "type": "product",
    "productCategory": "machine",
    "price": 22368.6,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled.jpg?v=1782495617",
    "searchKeywords": "Scrubmaster, B120, Ride, Floor, Scrubber, Financing, Available, Cylindrical, (SM3332CQP)",
    "sku": "28408",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-28-cylindrical-sm2832cqp-284",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 28\" Cylindrical (SM2832CQP)",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-28-cylindrical-sm2832cqp-284",
    "type": "product",
    "productCategory": "machine",
    "price": 22107.48,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled_41933db3-a927-4648-9279-ac6955870b5d.jpg?v=1782495586",
    "searchKeywords": "Scrubmaster, B120, Ride, Floor, Scrubber, Financing, Available, Cylindrical, (SM2832CQP)",
    "sku": "28407",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "part-br-33-30-ride-on-automatic-scrubber-33-30-gal-cylindrical-brush-includes-batteries-and-s",
    "name": "BR 33/30 Ride-On Automatic Scrubber - 33\" - 30 GAL - Cylindrical Brush - Includes Batteries and Stan",
    "url": "https://www.thecleaningbusiness.com/products/br-33-30-ride-on-automatic-scrubber-33-30-gal-cylindrical-brush-includes-batteries-and-s",
    "type": "product",
    "productCategory": "part",
    "price": 21450,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/br-33-30-ride-on-automatic-scrubber-w-wet-acid-batteries-33-30-gal-cylindrical-brush-includes-3-99812-12v-225ah-lead-acid-batteries-and-1-99515-36v-20-amp-standard-charger-2-pad-drive_badc6680-35dd-480d-8c6c-7225cec0c2a3.png?v=1782495667",
    "searchKeywords": "33/30, Ride-On, Automatic, Scrubber, Cylindrical, Brush, Includes, Batteries, Standard, Charger;, Drivers, Brushes, Required, 99785C, Wet-Acid, Batteries",
    "sku": "28528",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-35-disc-sm3532dqp-28406",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 35\" Disc (SM3532DQP)",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-35-disc-sm3532dqp-28406",
    "type": "product",
    "productCategory": "machine",
    "price": 20843.7,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled_69e9daf5-c7c6-4846-a90d-240b03364905.jpg?v=1782495690",
    "searchKeywords": "Scrubmaster, B120, Ride, Floor, Scrubber, Financing, Available, Disc, (SM3532DQP)",
    "sku": "28406",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "machine-kleen-sweep-47r-ride-on-floor-sweeper-large-area-vacuum-financing-available-base-unit-wi",
    "name": "Kleen Sweep 47R Ride On Floor Sweeper - Large Area Vacuum | Financing Available - Base Unit with Cha",
    "url": "https://www.thecleaningbusiness.com/products/kleen-sweep-47r-ride-on-floor-sweeper-large-area-vacuum-financing-available-base-unit-wi",
    "type": "product",
    "productCategory": "machine",
    "price": 20793.89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/KleenSweep47R1.png?v=1782495712",
    "searchKeywords": "Kleen, Sweep, Ride, Floor, Sweeper, Large, Area, Vacuum, Financing, Available, Base, Unit, with, Charger, Batteries, INCLUDED",
    "sku": "10149",
    "bestFor": [
      "hard_floor_scrubbing",
      "daily_vacuuming",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "commercial_vacuum",
      "sweeper"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-30-disc-sm3032dqp-28405",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 30\" Disc (SM3032DQP)",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-30-disc-sm3032dqp-28405",
    "type": "product",
    "productCategory": "machine",
    "price": 20615.22,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled_6cff5ad0-2516-41d6-92f8-aa09b2cf0833.jpg?v=1782495741",
    "searchKeywords": "Scrubmaster, B120, Ride, Floor, Scrubber, Financing, Available, Disc, (SM3032DQP)",
    "sku": "28405",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional"
    ]
  },
  {
    "id": "accessory-commercial-microfiber-cleaning-cloths-12-pack",
    "name": "Commercial Microfiber Cleaning Cloths (12-Pack)",
    "url": "https://thecleaningbusiness.com/products/commercial-microfiber-cleaning-cloths-12-pack",
    "type": "product",
    "productCategory": "accessory",
    "price": 29.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-1820579.jpg?v=1782538458",
    "searchKeywords": "",
    "sku": "TCB-MF-12",
    "bestFor": [
      "accessories",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "under_1000"
    ]
  },
  {
    "id": "accessory-caution-wet-floor-sign-26-inch",
    "name": "Caution Wet Floor Sign — 26\" A-Frame",
    "url": "https://thecleaningbusiness.com/products/caution-wet-floor-sign-26-inch",
    "type": "product",
    "productCategory": "accessory",
    "price": 49,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid_wet_floor_sign_lg.jpg?v=1782538459",
    "searchKeywords": "",
    "sku": "TCB-WFS-26",
    "bestFor": [
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "accessory-rubbermaid-high-capacity-janitorial-cart",
    "name": "Rubbermaid High-Capacity Janitorial Cleaning Cart",
    "url": "https://thecleaningbusiness.com/products/rubbermaid-high-capacity-janitorial-cart",
    "type": "product",
    "productCategory": "accessory",
    "price": 599,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/impact-janitor-cart-6850.jpg?v=1782538461",
    "searchKeywords": "",
    "sku": "TCB-JC-HC",
    "bestFor": [
      "rubber",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "chemical-neutral-all-purpose-floor-cleaner-1-gal",
    "name": "Neutral All-Purpose Floor Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/neutral-all-purpose-floor-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-neutral-clean-floor-cleaning-solution-pouch-mpl-5855-125p.jpg?v=1782538463",
    "searchKeywords": "",
    "sku": "TCB-NAP-1G",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "part-auto-scrubber-maintenance-parts-kit",
    "name": "Auto Scrubber Maintenance Parts Kit — Pads & Squeegee",
    "url": "https://thecleaningbusiness.com/products/auto-scrubber-maintenance-parts-kit",
    "type": "product",
    "productCategory": "part",
    "price": 89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-dura-17-autoscrubber-floor-cleaning-kit-v3.jpg?v=1782538465",
    "searchKeywords": "",
    "sku": "TCB-SCR-KIT",
    "bestFor": [
      "hard_floor_scrubbing",
      "maintenance",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "under_1000"
    ]
  },
  {
    "id": "accessory-commercial-restroom-cleaning-cart-mop-system",
    "name": "Commercial Restroom Cleaning Cart with Mop System",
    "url": "https://thecleaningbusiness.com/products/commercial-restroom-cleaning-cart-mop-system",
    "type": "product",
    "productCategory": "accessory",
    "price": 449,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/flr-package5-v4.jpg?v=1782538467",
    "searchKeywords": "",
    "sku": "TCB-RC-CART",
    "bestFor": [
      "restroom_cleaning",
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-commercial-kitchen-degreaser-1-gal",
    "name": "CleanFreak Commercial Kitchen Degreaser (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-commercial-kitchen-degreaser-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 94,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/cleanfreak-eliminator-heavy-duty-degreaser-bag-mpl-5974-125p.jpg?v=1782587453",
    "searchKeywords": "",
    "sku": "TCB-DGR-1G",
    "bestFor": [
      "degreasing",
      "restaurant",
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "chemical-cleanfreak-restroom-bowl-cleaner-1-gal",
    "name": "CleanFreak Restroom Bowl Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-restroom-bowl-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 79,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/bright-solutions-reflection-neutral-floor-cleaner-case-of-4-gallons.jpg?v=1782587457",
    "searchKeywords": "",
    "sku": "TCB-RBC-1G",
    "bestFor": [
      "restroom_cleaning",
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-wet-mop-head-large-looped-end",
    "name": "Commercial Wet Mop Head — Large Looped End",
    "url": "https://thecleaningbusiness.com/products/commercial-wet-mop-head-large-looped-end",
    "type": "product",
    "productCategory": "machine",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-fgc15306bl00.jpg?v=1782587461",
    "searchKeywords": "",
    "sku": "TCB-WM-LG",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-dust-mop-head-24-inch",
    "name": "Commercial Dust Mop Head — 24 Inch",
    "url": "https://thecleaningbusiness.com/products/commercial-dust-mop-head-24-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 34.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/kelsan-5x24-blue-cut-end-dust-mop.webp?v=1782587465",
    "searchKeywords": "",
    "sku": "TCB-DM-24",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-janitor-mop-handle-60-inch-aluminum",
    "name": "Janitor Mop Handle — 60 Inch Aluminum",
    "url": "https://thecleaningbusiness.com/products/janitor-mop-handle-60-inch-aluminum",
    "type": "product",
    "productCategory": "machine",
    "price": 39.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-fgm146000000.jpg?v=1782587468",
    "searchKeywords": "",
    "sku": "TCB-MH-60",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-dual-compartment-mop-bucket-wringer-35-quart",
    "name": "Dual Compartment Mop Bucket & Wringer — 35 Quart",
    "url": "https://thecleaningbusiness.com/products/dual-compartment-mop-bucket-wringer-35-quart",
    "type": "product",
    "productCategory": "machine",
    "price": 189,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-wavebrake-26-quart-side-press-mop-bucket-wringer-fg748000yel.webp?v=1782587473",
    "searchKeywords": "",
    "sku": "TCB-MB-35",
    "bestFor": [
      "maintenance",
      "under_1000"
    ]
  },
  {
    "id": "machine-nitrile-disposable-gloves-box-100-count",
    "name": "Nitrile Disposable Gloves — Box of 100",
    "url": "https://thecleaningbusiness.com/products/nitrile-disposable-gloves-box-100-count",
    "type": "product",
    "productCategory": "machine",
    "price": 19.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tradex-ambitex-nitrile-powder-free-gloves-n5201-grp.jpg?v=1782587477",
    "searchKeywords": "",
    "sku": "TCB-NGL-100",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-trash-can-liner-33-gallon-100-pack",
    "name": "Commercial Trash Can Liners — 33 Gallon (100-Pack)",
    "url": "https://thecleaningbusiness.com/products/commercial-trash-can-liner-33-gallon-100-pack",
    "type": "product",
    "productCategory": "machine",
    "price": 49.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/heritage-23-gallon-blue-recyclingbags-case-of-100.jpg?v=1782587481",
    "searchKeywords": "",
    "sku": "TCB-LNR-33",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-spray-bottle-32oz-3-pack",
    "name": "Commercial Spray Bottle — 32 oz (3-Pack)",
    "url": "https://thecleaningbusiness.com/products/commercial-spray-bottle-32oz-3-pack",
    "type": "product",
    "productCategory": "machine",
    "price": 14.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tolco-blue-white-trigger-sprayer-with-9-inch-dip-tube-110502.webp?v=1782587485",
    "searchKeywords": "",
    "sku": "TCB-SPB-3",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "accessory-caution-wet-floor-cone-sign-36-inch",
    "name": "Caution Wet Floor Cone Sign — 36 Inch Bilingual",
    "url": "https://thecleaningbusiness.com/products/caution-wet-floor-cone-sign-36-inch",
    "type": "product",
    "productCategory": "accessory",
    "price": 59,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-fg611477yel.jpg?v=1782587489",
    "searchKeywords": "",
    "sku": "TCB-WFC-36",
    "bestFor": [
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "machine-rubbermaid-brute-trash-can-32-gallon",
    "name": "Rubbermaid BRUTE Trash Can — 32 Gallon",
    "url": "https://thecleaningbusiness.com/products/rubbermaid-brute-trash-can-32-gallon",
    "type": "product",
    "productCategory": "machine",
    "price": 49.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-fg263200gray.jpg?v=1782587492",
    "searchKeywords": "",
    "sku": "TCB-BRT-32",
    "bestFor": [
      "rubber",
      "under_1000"
    ]
  },
  {
    "id": "accessory-color-coded-microfiber-mop-pad-18-inch",
    "name": "Color-Coded Microfiber Mop Pad — 18 Inch",
    "url": "https://thecleaningbusiness.com/products/color-coded-microfiber-mop-pad-18-inch",
    "type": "product",
    "productCategory": "accessory",
    "price": 18.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-fgq41000bl00.jpg?v=1782587496",
    "searchKeywords": "",
    "sku": "TCB-MMP-18",
    "bestFor": [
      "accessories",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-floor-squeegee-24-inch",
    "name": "Commercial Floor Squeegee — 24 Inch",
    "url": "https://thecleaningbusiness.com/products/commercial-floor-squeegee-24-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 29.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/curved_squeegee.jpg?v=1782587499",
    "searchKeywords": "",
    "sku": "TCB-SQ-24",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "accessory-housekeeping-laundry-bag-commercial",
    "name": "Housekeeping Laundry Bag — Commercial Heavy-Duty",
    "url": "https://thecleaningbusiness.com/products/housekeeping-laundry-bag-commercial",
    "type": "product",
    "productCategory": "accessory",
    "price": 89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/waste-wagon.jpg?v=1782587502",
    "searchKeywords": "",
    "sku": "TCB-LB-HD",
    "bestFor": [
      "accessories",
      "under_1000"
    ]
  },
  {
    "id": "chemical-commercial-glass-mirror-cleaner-1-gal",
    "name": "Commercial Glass & Mirror Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/commercial-glass-mirror-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 69,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/elogical-gs007-ultra-concentrated-voc-free-glass-cleaner-case-of-2-gallons.jpg?v=1782637781",
    "searchKeywords": "",
    "sku": "TCB-GLS-1G",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "chemical-multipurpose-disinfectant-cleaner-1-gal",
    "name": "Multipurpose Disinfectant Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/multipurpose-disinfectant-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/facility-plus-one-step-disinfectant-grp.jpg?v=1782637783",
    "searchKeywords": "",
    "sku": "TCB-DIS-1G",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "machine-safety-glasses-clear-lens-12-pack",
    "name": "Safety Glasses — Clear Lens (12-Pack)",
    "url": "https://thecleaningbusiness.com/products/safety-glasses-clear-lens-12-pack",
    "type": "product",
    "productCategory": "machine",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mcr-safety-checklite-cl1-clear-safety-glasses.webp?v=1782637784",
    "searchKeywords": "",
    "sku": "TCB-SG-12",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "chemical-chemical-splash-goggles-adjustable",
    "name": "Chemical Splash Goggles — Adjustable",
    "url": "https://thecleaningbusiness.com/products/chemical-splash-goggles-adjustable",
    "type": "product",
    "productCategory": "chemical",
    "price": 14.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/safety-glasses-esgc-large.jpg?v=1782637786",
    "searchKeywords": "",
    "sku": "TCB-GOG-1",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "part-commercial-toilet-bowl-brush-caddy-set",
    "name": "Commercial Toilet Bowl Brush & Caddy Set",
    "url": "https://thecleaningbusiness.com/products/commercial-toilet-bowl-brush-caddy-set",
    "type": "product",
    "productCategory": "part",
    "price": 34.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid-bowl-brush-caddy-fg631100wht.jpg?v=1782637787",
    "searchKeywords": "",
    "sku": "TCB-TBB-SET",
    "bestFor": [
      "restroom_cleaning",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "chemical-urinal-screen-deodorizer-10-pack",
    "name": "Urinal Screen Deodorizer (10-Pack)",
    "url": "https://thecleaningbusiness.com/products/urinal-screen-deodorizer-10-pack",
    "type": "product",
    "productCategory": "chemical",
    "price": 29.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/bright-solutions-wave-3d-cotton-blossom-urinal-screen-2wds60cb_d9dd69b3-4ac1-4a03-9247-fa5f337c50a1.jpg?v=1782637789",
    "searchKeywords": "",
    "sku": "TCB-US-10",
    "bestFor": [
      "restroom_cleaning",
      "odor_control",
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "part-handheld-carpet-grooming-brush",
    "name": "Handheld Carpet Grooming Brush",
    "url": "https://thecleaningbusiness.com/products/handheld-carpet-grooming-brush",
    "type": "product",
    "productCategory": "part",
    "price": 19.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/carpet_2.jpg?v=1782637791",
    "searchKeywords": "",
    "sku": "TCB-CGB-1",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "parts",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "part-heavy-duty-deck-scrub-brush",
    "name": "Heavy-Duty Deck Scrub Brush",
    "url": "https://thecleaningbusiness.com/products/heavy-duty-deck-scrub-brush",
    "type": "product",
    "productCategory": "part",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/96073-deck-scrub-brush.jpg?v=1782637792",
    "searchKeywords": "",
    "sku": "TCB-DSB-1",
    "bestFor": [
      "degreasing",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "part-commercial-grout-cleaning-brush",
    "name": "Commercial Grout Cleaning Brush",
    "url": "https://thecleaningbusiness.com/products/commercial-grout-cleaning-brush",
    "type": "product",
    "productCategory": "part",
    "price": 12.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-orange-hi-low-grout-scrub-brush-k47622510-for-br-16-3-cylindrical-floor-scrubber.jpg?v=1782637794",
    "searchKeywords": "",
    "sku": "TCB-GCB-1",
    "bestFor": [
      "degreasing",
      "parts",
      "under_1000"
    ]
  },
  {
    "id": "chemical-chemical-measuring-cup-32oz",
    "name": "Chemical Measuring Cup — 32 oz",
    "url": "https://thecleaningbusiness.com/products/chemical-measuring-cup-32oz",
    "type": "product",
    "productCategory": "chemical",
    "price": 8.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tolco-32-oz-spray-bottle-with-embossed-measuring-scale-120125.webp?v=1782637796",
    "searchKeywords": "",
    "sku": "TCB-CMC-32",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "part-inline-vacuum-filter-replacement-3-pack",
    "name": "Inline Vacuum Filter Replacement (3-Pack)",
    "url": "https://thecleaningbusiness.com/products/inline-vacuum-filter-replacement-3-pack",
    "type": "product",
    "productCategory": "part",
    "price": 29.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/3-4-inch-can-type-inline-filter-87099910.jpg?v=1782637797",
    "searchKeywords": "",
    "sku": "TCB-IVF-3",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "chemical-commercial-multi-surface-cleaner-1-gal",
    "name": "Commercial Multi-Surface Cleaner (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/commercial-multi-surface-cleaner-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 79,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/nilodor-certified-restoration-multi-surface-cleaner-5-gallon-pail.jpg?v=1782637799",
    "searchKeywords": "",
    "sku": "TCB-MSC-1G",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "chemical-commercial-restroom-descaler-1-gal",
    "name": "Commercial Restroom Descaler (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/commercial-restroom-descaler-1-gal",
    "type": "product",
    "productCategory": "chemical",
    "price": 89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/bright-solutions-bath-and-bowl-cleaner-descaler-902100-case-of-4-bottles.webp?v=1782637800",
    "searchKeywords": "",
    "sku": "TCB-RSD-1G",
    "bestFor": [
      "restroom_cleaning",
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "machine-foodservice-safe-sanitizer-1-gal",
    "name": "Foodservice-Safe Sanitizer (1 Gallon)",
    "url": "https://thecleaningbusiness.com/products/foodservice-safe-sanitizer-1-gal",
    "type": "product",
    "productCategory": "machine",
    "price": 94,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/elogical-neutral-q128-cleaner-disinfectant-sanitizer-deodrizer-case-of-4-gallons.jpg?v=1782637802",
    "searchKeywords": "",
    "sku": "TCB-FSN-1G",
    "bestFor": [
      "degreasing",
      "under_1000"
    ]
  },
  {
    "id": "machine-floor-scrubber-pad-set-red-blue-17-inch",
    "name": "Floor Scrubber Pad Set — Red/Blue (17\", 5-Pack)",
    "url": "https://thecleaningbusiness.com/products/floor-scrubber-pad-set-red-blue-17-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 49.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/case-of-17-inch-red-pads.jpg?v=1782637804",
    "searchKeywords": "",
    "sku": "TCB-PAD-RB5",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "under_1000"
    ]
  },
  {
    "id": "machine-floor-strip-pad-black-17-inch-3-pack",
    "name": "Floor Strip Pad — Black (17\", 3-Pack)",
    "url": "https://thecleaningbusiness.com/products/floor-strip-pad-black-17-inch-3-pack",
    "type": "product",
    "productCategory": "machine",
    "price": 39.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/case-of-17-inch-maroon-x-stripping-pad-case.jpg?v=1782637805",
    "searchKeywords": "",
    "sku": "TCB-PAD-BK3",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "part-auto-scrubber-squeegee-blade-set",
    "name": "Auto Scrubber Squeegee Blade Set",
    "url": "https://thecleaningbusiness.com/products/auto-scrubber-squeegee-blade-set",
    "type": "product",
    "productCategory": "part",
    "price": 34.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/gum-rubber-front-squeegee-for-tennant-t16-rider-floor-scrubber.jpg?v=1782637807",
    "searchKeywords": "",
    "sku": "TCB-SQBL-SET",
    "bestFor": [
      "hard_floor_scrubbing",
      "maintenance",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "under_1000"
    ]
  },
  {
    "id": "part-auto-scrubber-recovery-tank-gasket-kit",
    "name": "Auto Scrubber Recovery Tank Gasket Kit",
    "url": "https://thecleaningbusiness.com/products/auto-scrubber-recovery-tank-gasket-kit",
    "type": "product",
    "productCategory": "part",
    "price": 29.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/natural-rubber-rear-squeegee-end-gasket-for-tennant-t20-rider-floor-scrubber.jpg?v=1782637808",
    "searchKeywords": "",
    "sku": "TCB-GSK-KIT",
    "bestFor": [
      "hard_floor_scrubbing",
      "maintenance",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "under_1000"
    ]
  },
  {
    "id": "part-commercial-vacuum-hepa-filter-bags-10-pack",
    "name": "Commercial Vacuum HEPA Filter Bags (10-Pack)",
    "url": "https://thecleaningbusiness.com/products/commercial-vacuum-hepa-filter-bags-10-pack",
    "type": "product",
    "productCategory": "part",
    "price": 39.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-k69043350.jpg?v=1782637811",
    "searchKeywords": "",
    "sku": "TCB-HEPA-10",
    "bestFor": [
      "daily_vacuuming",
      "maintenance",
      "parts",
      "commercial_vacuum",
      "under_1000"
    ]
  },
  {
    "id": "machine-carpet-extractor-vac-hose-cuff-set",
    "name": "Carpet Extractor Vac Hose Cuff Set (2-Pack)",
    "url": "https://thecleaningbusiness.com/products/carpet-extractor-vac-hose-cuff-set",
    "type": "product",
    "productCategory": "machine",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-2-inch-cuff-lynx-vac-hose-adaptor-h110v.jpg?v=1782638071",
    "searchKeywords": "",
    "sku": "TCB-VHC-2",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-carpet-extractor-wand-spray-jet-set",
    "name": "Carpet Extractor Wand Spray Jet Set",
    "url": "https://thecleaningbusiness.com/products/carpet-extractor-wand-spray-jet-set",
    "type": "product",
    "productCategory": "machine",
    "price": 19.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/edic-non-heated-jet-tip.jpg?v=1782637814",
    "searchKeywords": "",
    "sku": "TCB-JET-SET",
    "bestFor": [
      "carpet_extraction",
      "maintenance",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "machine-carpet-extractor-solution-hose-50ft",
    "name": "Carpet Extractor Solution/Vac Hose — 50 ft",
    "url": "https://thecleaningbusiness.com/products/carpet-extractor-solution-hose-50ft",
    "type": "product",
    "productCategory": "machine",
    "price": 149,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/trusted-clean-blue-solution-hose.jpg?v=1782637816",
    "searchKeywords": "",
    "sku": "TCB-HOS-50",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "under_1000"
    ]
  },
  {
    "id": "chemical-chemical-resistant-nitrile-gloves-long-cuff",
    "name": "Chemical-Resistant Nitrile Gloves — Long Cuff (50 Count)",
    "url": "https://thecleaningbusiness.com/products/chemical-resistant-nitrile-gloves-long-cuff",
    "type": "product",
    "productCategory": "chemical",
    "price": 34.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/showa-best-glove-13-inch-green-nitri-solve-717-chemical-resistant-gloves.webp?v=1782637819",
    "searchKeywords": "",
    "sku": "TCB-CRG-50",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "machine-grease-resistant-nitrile-gloves-50-count",
    "name": "Grease-Resistant Nitrile Gloves (50 Count)",
    "url": "https://thecleaningbusiness.com/products/grease-resistant-nitrile-gloves-50-count",
    "type": "product",
    "productCategory": "machine",
    "price": 29.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tradex-ambitex-nitrile-powder-free-gloves-n5201-grp_9e9bb4b6-6d9b-4cd7-860e-02fb17887186.jpg?v=1782637820",
    "searchKeywords": "",
    "sku": "TCB-GRG-50",
    "bestFor": [
      "degreasing",
      "under_1000"
    ]
  },
  {
    "id": "chemical-chemical-splash-apron-commercial",
    "name": "Chemical Splash Apron — Commercial",
    "url": "https://thecleaningbusiness.com/products/chemical-splash-apron-commercial",
    "type": "product",
    "productCategory": "chemical",
    "price": 24.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/safety-zone-white-disposable-meat-cutting-aprons.jpg?v=1782637822",
    "searchKeywords": "",
    "sku": "TCB-APR-1",
    "bestFor": [
      "chemicals",
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-tilt-truck-waste-1-cubic-yard",
    "name": "Commercial Tilt Truck — 1 Cubic Yard",
    "url": "https://thecleaningbusiness.com/products/commercial-tilt-truck-waste-1-cubic-yard",
    "type": "product",
    "productCategory": "machine",
    "price": 349,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/rubbermaid_black_tilt_truck_lg.jpg?v=1782637824",
    "searchKeywords": "",
    "sku": "TCB-TT-1CY",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-floor-scraper-tool",
    "name": "Commercial Floor Scraper Tool",
    "url": "https://thecleaningbusiness.com/products/commercial-floor-scraper-tool",
    "type": "product",
    "productCategory": "machine",
    "price": 18.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ettore-handheld-scraper-2005-case.jpg?v=1782637826",
    "searchKeywords": "",
    "sku": "TCB-FSC-1",
    "bestFor": [
      "degreasing",
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-dust-control-wipes-150-count",
    "name": "Dust-Control Wipes Canister (150 Count)",
    "url": "https://thecleaningbusiness.com/products/commercial-dust-control-wipes-150-count",
    "type": "product",
    "productCategory": "machine",
    "price": 34.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clorox-disinfecting-wipes-6-pack.jpg?v=1782637827",
    "searchKeywords": "",
    "sku": "TCB-DCW-150",
    "bestFor": [
      "under_1000"
    ]
  },
  {
    "id": "machine-commercial-trigger-sprayer-heads-3-pack",
    "name": "Commercial Trigger Sprayer Heads (3-Pack)",
    "url": "https://thecleaningbusiness.com/products/commercial-trigger-sprayer-heads-3-pack",
    "type": "product",
    "productCategory": "machine",
    "price": 12.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tolco-blue-white-trigger-sprayer-with-9-inch-dip-tube-110502_d8936136-b393-47da-b836-b5d35f00f50a.webp?v=1782637829",
    "searchKeywords": "",
    "sku": "TCB-TRG-3",
    "bestFor": [
      "restroom_cleaning",
      "under_1000"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct71xp-600-rpm-high-speed-28-automatic-floor-polisher-and-scrubber-19-gallons",
    "name": "IPC Eagle CT71XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ Pad Drivers - 19 Gall",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct71xp-600-rpm-high-speed-28-automatic-floor-polisher-and-scrubber-19-gallons",
    "type": "product",
    "productCategory": "machine",
    "price": 13603,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ct71xp70-traction-drive-28-inch-floor-scrubber.jpg?v=1782639565",
    "searchKeywords": "Eagle, CT71XP, High, Speed, Automatic, Floor, Polisher, Scrubber, Drivers, Gallons",
    "sku": "EAG-CT71XP70HS-145",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc2000-20-inch-compact-ride-on-floor-scrubber",
    "name": "Advance® SC2000™ 20\" Compact Ride-on Floor Scrubber w/ Pad Drivers - 18.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/advance-sc2000-20-inch-compact-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 12198,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc2000-rider-scrubber-right.jpg?v=1782639575",
    "searchKeywords": "Advance├é┬«, SC2000├óΓÇ₧┬ó, Compact, Ride-on, Floor, Scrubber, Drivers, 18.5, Gallons",
    "sku": "NFA-56384071",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-tennant-t581-micro-20-inch-ride-on-floor-scrubber",
    "name": "Tennant® T581 Micro 20\" Ride-On Floor Scrubber w/ Pad Driver - 20 Gallons",
    "url": "https://thecleaningbusiness.com/products/tennant-t581-micro-20-inch-ride-on-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 12007,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t581-micro-20-inch-ride-on-floor-scrubber.jpg?v=1782639585",
    "searchKeywords": "Tennant├é┬«, T581, Micro, Ride-On, Floor, Scrubber, Driver, Gallons",
    "sku": "TEN-9022008",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "part-large-area-walk-behind-floor-scrubber",
    "name": "IPC Eagle CT90 Large Area 28\" Walk Behind Floor Scrubber w/ Brushes - 24 Gallons",
    "url": "https://thecleaningbusiness.com/products/large-area-walk-behind-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 11472,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct90-w-dual-brushes.jpg?v=1782639597",
    "searchKeywords": "Eagle, CT90, Large, Area, Walk, Behind, Floor, Scrubber, Brushes, Gallons",
    "sku": "EAG-CT90BT70-B-240CH",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-ra40-20d-micro-rider-scrubber",
    "name": "Clarke® RA40™ 20D Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 18.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/clarke-ra40-20d-micro-rider-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 11413,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ra40-20d-micro-rider-scrubber_1.jpg?v=1782639606",
    "searchKeywords": "Clarke├é┬«, RA40├óΓÇ₧┬ó, Rider, Floor, Scrubber, Driver, (20\", Scrub, Deck), 18.5, Gallons",
    "sku": "CRK-56384073",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct71-traction-drive-automatic-floor-scrubber-24-or-28-inch",
    "name": "IPC Eagle CT71 Traction Drive Automatic Floor Scrubber w/ Pad Drivers (24\" & 28\" Deck Options) - 19 ",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct71-traction-drive-automatic-floor-scrubber-24-or-28-inch",
    "type": "product",
    "productCategory": "machine",
    "price": 11325,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ct71-bt60-obc-p-145-conf.jpg?v=1782639618",
    "searchKeywords": "Eagle, CT71, Traction, Drive, Automatic, Floor, Scrubber, Drivers, (24\", Deck, Options), Gallons",
    "sku": "EAG-CT71BT60-OBC-P-130",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-minuteman-h26-hospital-floor-scrubber",
    "name": "Minuteman® H26 Compact Automatic Floor Scrubber for Hospitals w/ Pad Drivers - 19 Gallons",
    "url": "https://thecleaningbusiness.com/products/minuteman-h26-hospital-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 11301.78,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_h26_lg.jpg?v=1782639629",
    "searchKeywords": "Minuteman├é┬«, Compact, Automatic, Floor, Scrubber, Hospitals, Drivers, Gallons",
    "sku": "MIN-H26QP",
    "bestFor": [
      "hard_floor_scrubbing",
      "healthcare",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct51xp-600-rpm-high-speed-28-inch-automatic-floor-polisher-and-scrubber-13-gallo",
    "name": "IPC Eagle CT51XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ Pad Drivers - 13 Gall",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct51xp-600-rpm-high-speed-28-inch-automatic-floor-polisher-and-scrubber-13-gallo",
    "type": "product",
    "productCategory": "machine",
    "price": 10795,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct51-ct71-floor-scrubber-v2.jpg?v=1782639638",
    "searchKeywords": "Eagle, CT51XP, High, Speed, Automatic, Floor, Polisher, Scrubber, Drivers, Gallons",
    "sku": "EAG-CT51XP70HS-130",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-minuteman-26-inch-self-propelled-battery-floor-scrubber",
    "name": "Minuteman® 26\" Self Propelled Battery Floor Scrubber w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/minuteman-26-inch-self-propelled-battery-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 10729.33,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_e26_auto_floor_scrubber_lg.jpg?v=1782639649",
    "searchKeywords": "Minuteman├é┬«, Self, Propelled, Battery, Floor, Scrubber, Drivers",
    "sku": "MIN-E26QP",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-powr-flite-crossover-26-inch-rider-automatic-floor-scrubber-pas26r",
    "name": "Powr-Flite® Crossover 26\" Rider Automatic Floor Scrubber w/ Pad Drivers (#PAS26R)",
    "url": "https://thecleaningbusiness.com/products/powr-flite-crossover-26-inch-rider-automatic-floor-scrubber-pas26r",
    "type": "product",
    "productCategory": "machine",
    "price": 10501,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/powr-flite-crossover-26-inch-rider-floor-scrubber-pas26r.jpg?v=1782639656",
    "searchKeywords": "Powr-Flite├é┬«, Crossover, Rider, Automatic, Floor, Scrubber, Drivers, (#PAS26R)",
    "sku": "POW-PAS26R",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "part-28-inch-traction-drive-auto-scrubber",
    "name": "IPC Eagle CT70 Traction Drive 28\" Automatic Floor Scrubber w/ Pad Drivers or Brushes - 19 Gallons",
    "url": "https://thecleaningbusiness.com/products/28-inch-traction-drive-auto-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 10336,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct70-w-dual-brushes_grp.jpg?v=1782639664",
    "searchKeywords": "Eagle, CT70, Traction, Drive, Automatic, Floor, Scrubber, Drivers, Brushes, Gallons",
    "sku": "EAG-CT70BT70-OBC-B-130",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-pacific-floorcare-s-24xm-24-inch-battery-powered-floor-scrubber-11-gallon",
    "name": "Pacific Floorcare® S-24XM 24\" Battery Powered Floor Scrubber (11 Gallon) w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s-24xm-24-inch-battery-powered-floor-scrubber-11-gallon",
    "type": "product",
    "productCategory": "machine",
    "price": 10304.6,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-s-24-xm-floor-scrubber-24-inch_22e54272-bd23-4e70-9af4-8429ab0601cb.jpg?v=1782639674",
    "searchKeywords": "Pacific, Floorcare├é┬«, S-24XM, Battery, Powered, Floor, Scrubber, Gallon), Drivers",
    "sku": "PAC-855420",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-t390-self-propelled-28-inch-floor-scrubber",
    "name": "Tennant® T390 Self-Propelled 28\" Walk Behind Automatic Floor Scrubber w/ Pad Drivers - 17 Gallons",
    "url": "https://thecleaningbusiness.com/products/tennant-t390-self-propelled-28-inch-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 10292,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t390-28-in-scrubber-left.jpg?v=1782639682",
    "searchKeywords": "Tennant├é┬«, T390, Self-Propelled, Walk, Behind, Automatic, Floor, Scrubber, Drivers, Gallons",
    "sku": "TEN-9022006",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-as530r-micro-rider-floor-scrubber",
    "name": "Viper AS530R™ Micro Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 19 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as530r-micro-rider-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 10251,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/as530r-ol-rt.jpg?v=1782639692",
    "searchKeywords": "Viper, AS530R├óΓÇ₧┬ó, Micro, Rider, Floor, Scrubber, Driver, (20\", Scrub, Deck), Gallons",
    "sku": "VIP-56385072",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000"
    ]
  },
  {
    "id": "part-tornado-br-22-14t-automatic-cylindrical-floor-scrubber",
    "name": "Tornado® 'BR 22/14T' Traction Drive Automatic Cylindrical Floor Scrubber w/ Brushes - 14 Gallons",
    "url": "https://thecleaningbusiness.com/products/tornado-br-22-14t-automatic-cylindrical-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 8999,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-99695tc-cylindrical-auto-scrubber_21ba92b7-0321-4e6e-9dc6-6984942ce2df.jpg?v=1782639701",
    "searchKeywords": "Tornado├é┬«, 22/14T', Traction, Drive, Automatic, Cylindrical, Floor, Scrubber, Brushes, Gallons",
    "sku": "TOR-99695T-C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tornado-floorkeeper-24-inch-99124dp-automatic-floor-scrubber",
    "name": "Tornado® 'Floorkeeper 24' Walk Behind 24\" Automatic Floor Scrubber w/ 2 Pad Drivers & Traction Drive",
    "url": "https://thecleaningbusiness.com/products/tornado-floorkeeper-24-inch-99124dp-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 8839,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-floorkeeper-24-floorscrubber-99124dp-2.jpg?v=1782639710",
    "searchKeywords": "Tornado├é┬«, 'Floorkeeper, Walk, Behind, 24├óΓé¼┬¥, Automatic, Floor, Scrubber, Drivers, Traction, Drive, Gallons",
    "sku": "TOR-99124DP",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc500-20d-commercial-20-inch-battery-floor-scrubber",
    "name": "Advance® SC500™ 20D Commercial 20\" Auto Floor Scrubber w/ Pad Driver - 12 Gallons",
    "url": "https://thecleaningbusiness.com/products/advance-sc500-20d-commercial-20-inch-battery-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 8668,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sc500-20d-auto-scrubber_8496e489-5637-499f-bff2-6e03fde588a5.jpg?v=1782639716",
    "searchKeywords": "Advance├é┬«, SC500├óΓÇ₧┬ó, Commercial, Auto, Floor, Scrubber, Driver, Gallons",
    "sku": "NFA-56384686",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-20-inch-t300e-automatic-floor-scrubber",
    "name": "Tennant® T300e 20\" Walk Behind Automatic Floor Scrubber w/ Pad Driver (Pad Assist & Traction Drive O",
    "url": "https://thecleaningbusiness.com/products/tennant-20-inch-t300e-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 8163,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t300e-20-inch-walk-behind-floor-scrubber.jpg?v=1782639724",
    "searchKeywords": "Tennant├é┬«, T300e, Walk, Behind, Automatic, Floor, Scrubber, Driver, (Pad, Assist, Traction, Drive, Options), Gallons",
    "sku": "TEN-T300E-1001D",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-28-inch-walk-behind-automatic-scrubber",
    "name": "Viper Fang 28T Walk Behind Automatic Floor Scrubber w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/28-inch-walk-behind-automatic-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 8105,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-fang-28t-auto-floor-scrubber_d65fe85c-fb34-4aef-bb98-3d41fa1a69a9.jpg?v=1782639735",
    "searchKeywords": "Viper, Fang, Walk, Behind, Automatic, Floor, Scrubber, Drivers",
    "sku": "VIP-FANG28T-215",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "part-ipc-eagle-cleantime-24-auto-scrubber",
    "name": "IPC Eagle CT70 Walk Behind 24\" Auto Scrubber w/ Brushes - 19 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-cleantime-24-auto-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 7586.72,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct70-w-dual-brushes.jpg?v=1782639745",
    "searchKeywords": "Eagle, CT70, Walk, Behind, Auto, Scrubber, Brushes, Gallons",
    "sku": "EAG-CT70BT60-OBC-B-145",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tornado-floorkeeper-20-walk-behind-20-inch-floor-scrubber",
    "name": "Tornado® 'Floorkeeper 20' Walk Behind 20\" Automatic Floor Scrubber w/ Pad Driver - 11 Gallons",
    "url": "https://thecleaningbusiness.com/products/tornado-floorkeeper-20-walk-behind-20-inch-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 7558,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-floorkeeper-20-floorscrubber-99120bp.jpg?v=1782639756",
    "searchKeywords": "Tornado├é┬«, 'Floorkeeper, 20├óΓé¼Γäó, Walk, Behind, 20├óΓé¼┬¥, Automatic, Floor, Scrubber, Driver, Gallons",
    "sku": "TOR-99120BC",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc450-20-inch-battery-automatic-floor-scrubber-w-pad-holder",
    "name": "Advance® SC450™ 20\" Battery Powered Automatic Floor Scrubber w/ Pad Holder - 10.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/advance-sc450-20-inch-battery-automatic-floor-scrubber-w-pad-holder",
    "type": "product",
    "productCategory": "machine",
    "price": 7214,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc450-floor-scrubber_2.jpg?v=1782639764",
    "searchKeywords": "Advance├é┬«, SC450├óΓÇ₧┬ó, Battery, Powered, Automatic, Floor, Scrubber, Holder, 10.5, Gallons",
    "sku": "NFA-56383956",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-advance-sc450-20-inch-battery-automatic-floor-scrubber-w-brush",
    "name": "Advance® SC450™ 20\" Battery Powered Automatic Floor Scrubber w/ Brush - 10.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/advance-sc450-20-inch-battery-automatic-floor-scrubber-w-brush",
    "type": "product",
    "productCategory": "part",
    "price": 7214,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc450-floor-scrubber.jpg?v=1782639772",
    "searchKeywords": "Advance├é┬«, SC450├óΓÇ₧┬ó, Battery, Powered, Automatic, Floor, Scrubber, Brush, 10.5, Gallons",
    "sku": "NFA-56383128",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-powr-flite-phantom-24-inch-traction-drive-automatic-floor-scrubber",
    "name": "Powr-Flite® Phantom 24\" Traction Drive Automatic Floor Scrubber w/ Pad Drivers - 16 Gallons",
    "url": "https://thecleaningbusiness.com/products/powr-flite-phantom-24-inch-traction-drive-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6837.3,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pfs24-phantom-24-in-floor-scrubber.jpg?v=1782639780",
    "searchKeywords": "Powr-Flite├é┬«, Phantom, Traction, Drive, Automatic, Floor, Scrubber, Drivers, Gallons",
    "sku": "POW-PFS24",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-ipc-eagle-ct51-walk-behind-20-inch-floor-scrubber",
    "name": "IPC Eagle CT51 Battery Powered 20\" Walk Behind Floor Scrubber (Pad Driver / Brush & Battery Options)",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct51-walk-behind-20-inch-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 6811,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct51-20-inch-walk-behind-battery-floor-scrubber_a501338f-d65f-42e7-beb0-338790a5e9cc.jpg?v=1782639791",
    "searchKeywords": "Eagle, CT51, Battery, Powered, Walk, Behind, Floor, Scrubber, (Pad, Driver, Brush, Battery, Options), Gallons",
    "sku": "EAG-CT51B50-OBCB-115",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-pacific-floorcare-s20-automatic-floor-scrubber",
    "name": "Pacific Floorcare® 20\" Automatic Push Floor Scrubber (#S-20) - Brush Assist",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s20-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 6692.81,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-s20-automatic-floor-scrubber-battery-powered_35e68e8e-e844-4675-8e09-1514e0227b84.jpg?v=1782639802",
    "searchKeywords": "Pacific, Floorcare├é┬«, Automatic, Push, Floor, Scrubber, (#S-20), Brush, Assist",
    "sku": "PAC-855401",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-tennant-t290-pad-assist-20-inch-walk-behind-floor-scrubber",
    "name": "Tennant® T290 Pad Assist 20\" Walk Behind Automatic Floor Scrubber w/ Pad Driver - 10.5 Gallons",
    "url": "https://thecleaningbusiness.com/products/tennant-t290-pad-assist-20-inch-walk-behind-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6691,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t290-floor-scrubber-right.jpg?v=1782639812",
    "searchKeywords": "Tennant├é┬«, T290, Assist, Walk, Behind, Automatic, Floor, Scrubber, Driver, 10.5, Gallons",
    "sku": "TEN-2182143",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-minuteman-20-inch-floor-scrubber-for-hospitals-w-antimicrobial-tank",
    "name": "Minuteman® H20 Automatic Floor Scrubber for Hospitals w/ Antimicrobial Tank & Pad Driver - 12 Gallon",
    "url": "https://thecleaningbusiness.com/products/minuteman-20-inch-floor-scrubber-for-hospitals-w-antimicrobial-tank",
    "type": "product",
    "productCategory": "machine",
    "price": 6654.71,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_h20_lg.jpg?v=1782639826",
    "searchKeywords": "Minuteman├é┬«, Automatic, Floor, Scrubber, Hospitals, Antimicrobial, Tank, Driver, Gallons",
    "sku": "MIN-H20BDQP",
    "bestFor": [
      "hard_floor_scrubbing",
      "healthcare",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "3000_7500"
    ]
  },
  {
    "id": "part-18-inch-cylindrical-brush-floor-scrubber",
    "name": "Tornado® 'BR 18/11\" Cylindrical Floor Scrubber w/ Brushes - 11 Gallons",
    "url": "https://thecleaningbusiness.com/products/18-inch-cylindrical-brush-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 6599,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/br_18_11_lg.jpg?v=1782639838",
    "searchKeywords": "Tornado├é┬«, 18/11\", Cylindrical, Floor, Scrubber, Brushes, Gallons",
    "sku": "TOR-99685C",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-advance-sc401-compact-17-inch-automatic-floor-scrubber-w-brush-105-ah-batteries",
    "name": "Advance® SC401™ Compact 17\" Automatic Floor Scrubber w/ Brush & 105 Ah Batteries",
    "url": "https://thecleaningbusiness.com/products/advance-sc401-compact-17-inch-automatic-floor-scrubber-w-brush-105-ah-batteries",
    "type": "product",
    "productCategory": "part",
    "price": 6551,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc401-floor-scrubber-right.jpg?v=1782639849",
    "searchKeywords": "Advance├é┬«, SC401├óΓÇ₧┬ó, Compact, Automatic, Floor, Scrubber, Brush, Batteries",
    "sku": "NFA-56385360",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-310as-20-inch-battery-auto-scrubber",
    "name": "Pioneer Eclipse #310AS Battery Powered 20\" Traction Drive Auto Scrubber w/ Pad Driver - 12 Gallons",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-310as-20-inch-battery-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 6389.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-310as-traction-drive-auto-scrubber_e6aab458-1d2e-4feb-8642-2b5217f1aed1.jpg?v=1782639862",
    "searchKeywords": "Pioneer, Eclipse, #310AS, Battery, Powered, Traction, Drive, Auto, Scrubber, Driver, Gallons",
    "sku": "PIO-310AS20TDSL",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-ipc-eagle-20-inch-brush-driven-scrubber",
    "name": "IPC Eagle CT40 Brush Driven 20\" Auto Scrubber w/ Brush - 10 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-20-inch-brush-driven-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 6197,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct40-cleantime-20-in-scrubber.jpg?v=1782639872",
    "searchKeywords": "Eagle, CT40, Brush, Driven, Auto, Scrubber, Brush, Gallons",
    "sku": "EAG-CT40B50-OBC-B-115",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-brush-driven-scrubber-traction-option",
    "name": "IPC Eagle 20\" Brush Driven Scrubber - CT70 - Traction Option",
    "url": "https://thecleaningbusiness.com/products/brush-driven-scrubber-traction-option",
    "type": "product",
    "productCategory": "part",
    "price": 6167.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct70-w-single-brush.jpg?v=1782639882",
    "searchKeywords": "Eagle, Brush, Driven, Scrubber, CT70, Traction, Option",
    "sku": "EAG-CT70B50-OBC-B-145",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "chemical-clarke-tfc-400-hands-free-bathroom-cleaner-and-carpet-extractor",
    "name": "Clarke® TFC 400 Hands Free Bathroom Cleaner & Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/clarke-tfc-400-hands-free-bathroom-cleaner-and-carpet-extractor",
    "type": "product",
    "productCategory": "chemical",
    "price": 6035,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-tfc-400-cleaner-and-carpet-extractor-squeege_1.jpg?v=1782639893",
    "searchKeywords": "Clarke├é┬«, Hands, Free, Bathroom, Cleaner, Carpet, Extractor",
    "sku": "CRK-56380773",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "hard_floor",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "part-ipc-eagle-20-inch-compact-automatic-floor-scrubber-ct45",
    "name": "IPC Eagle CT45 Low Profile 20\" Compact Automatic Floor Scrubber w/ Brush - 11 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-20-inch-compact-automatic-floor-scrubber-ct45",
    "type": "product",
    "productCategory": "part",
    "price": 5976,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ct45-floor-scrubber.jpg?v=1782639904",
    "searchKeywords": "Eagle, CT45, Profile, Compact, Automatic, Floor, Scrubber, Brush, Gallons",
    "sku": "EAG-CT45B50-XD",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-ipc-eagle-ct46-automatic-floor-scrubber",
    "name": "IPC Eagle CT46 Low Profile 20\" Automatic Floor Scrubber w/ Brush - 11 Gallons",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct46-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 5955,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct46-automatic-floor-scrubber_1.jpg?v=1782639914",
    "searchKeywords": "Eagle, CT46, Profile, Automatic, Floor, Scrubber, Brush, Gallons",
    "sku": "EAG-CT46B50-OBC-B-145",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-cafeteria-gymnasium-floor-scrubber",
    "name": "IPC Eagle CT30 Compact 18\" Automatic Floor Scrubber w/ Brush - 8 Gallons",
    "url": "https://thecleaningbusiness.com/products/cafeteria-gymnasium-floor-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 5751,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct30b45-automatic-floor-scrubber.jpg?v=1782639924",
    "searchKeywords": "Eagle, CT30, Compact, Automatic, Floor, Scrubber, Brush, Gallons",
    "sku": "EAG-CT30B45-XD",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-17-inch-minuteman-electric-auto-scrubber",
    "name": "Minuteman® 17\" Cord Electric Auto Floor Scrubber w/ Pad Driver",
    "url": "https://thecleaningbusiness.com/products/17-inch-minuteman-electric-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5607.02,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_e17_lg.jpg?v=1782639932",
    "searchKeywords": "Minuteman├é┬«, Cord, Electric, Auto, Floor, Scrubber, Driver",
    "sku": "MIN-E17115BD",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-ice-i20nbv-contractor-grade-20-inch-floor-scrubber",
    "name": "ICE i20NBV Contractor Grade 20\" Automatic Floor Scrubber w/ Pad Driver - 15 Gallons",
    "url": "https://thecleaningbusiness.com/products/ice-i20nbv-contractor-grade-20-inch-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5601,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ice-i20nbv-contractor-grade-20-inch-floor-scrubber.jpg?v=1782639938",
    "searchKeywords": "i20NBV, Contractor, Grade, 20├óΓé¼┬¥, Automatic, Floor, Scrubber, Driver, Gallons",
    "sku": "ICE-I20NBV-LA",
    "bestFor": [
      "hard_floor_scrubbing",
      "contractor",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-viper-as5160-walk-behind-20-auto-scrubber",
    "name": "Viper AS5160™ Walk Behind 20\" Floor Scrubber w/ Pad Driver - 16 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as5160-walk-behind-20-auto-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5532,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as5160-auto-scrubber-w-brush-and-skirt.jpg?v=1782639946",
    "searchKeywords": "Viper, AS5160├óΓÇ₧┬ó, Walk, Behind, Floor, Scrubber, Driver, Gallons",
    "sku": "VIP-56384810",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "machine-dri-eaz-motorized-high-volume-extractor-hve",
    "name": "Dri-Eaz® Rover HVE Rider Flood Water Deep Extraction Tool",
    "url": "https://thecleaningbusiness.com/products/dri-eaz-motorized-high-volume-extractor-hve",
    "type": "product",
    "productCategory": "machine",
    "price": 5489,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/dri-eaz-112125-rover-hve-ride-on-high-volume-extractor.jpg?v=1782639956",
    "searchKeywords": "Dri-Eaz├é┬«, Rover, Rider, Flood, Water, Deep, Extraction, Tool",
    "sku": "DRI-112125",
    "bestFor": [
      "carpet_extraction",
      "restoration",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "carpet",
      "carpet_extractor",
      "3000_7500"
    ]
  },
  {
    "id": "machine-advance-sc370-17-inch-battery-powered-floor-scrubber",
    "name": "Advance® SC370 Battery Powered 17\" Floor Scrubber w/ Pad Holder - 6.6 Gallons",
    "url": "https://thecleaningbusiness.com/products/advance-sc370-17-inch-battery-powered-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5468,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc370-floor-scrubber.jpg?v=1782639962",
    "searchKeywords": "Advance├é┬«, SC370, Battery, Powered, Floor, Scrubber, Holder, Gallons",
    "sku": "NFA-50000638",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-tennant-t1-15-walk-behind-micro-scrubber",
    "name": "Tennant® T1 15\" Walk Behind Micro Scrubber w/ Cylindrical Brush (Battery & Electric Options) - 3 Gal",
    "url": "https://thecleaningbusiness.com/products/tennant-t1-15-walk-behind-micro-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 5394,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t1-cord-electric-15-micro-scrubber.jpg?v=1782639973",
    "searchKeywords": "Tennant├é┬«, 15├óΓé¼┬¥, Walk, Behind, Micro, Scrubber, Cylindrical, Brush, (Battery, Electric, Options), Gallons",
    "sku": "TEN-9004191",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "3000_7500"
    ]
  },
  {
    "id": "chemical-mytee-ltd12-speedster-carpet-extractor-and-tile-cleaner",
    "name": "Mytee® LTD120-LX Speedster® Carpet Extractor & Tile Cleaner (50 -1200 PSI)",
    "url": "https://thecleaningbusiness.com/products/mytee-ltd12-speedster-carpet-extractor-and-tile-cleaner",
    "type": "product",
    "productCategory": "chemical",
    "price": 5377,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/mytee-ltd12-lx-1200-psi-tile-and-carpet-cleaning-machine.jpg?v=1782639985",
    "searchKeywords": "Mytee├é┬«, LTD120-LX, Speedster├é┬«, Carpet, Extractor, Tile, Cleaner, -1200, PSI)",
    "sku": "MYT-LTD12-LX",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "tile",
      "hard_floor",
      "chemicals",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "part-sandia-80-5000-carpet-extractor-and-hard-surface-cleaner",
    "name": "Sandia Sniper 400 - 1200 PSI Adjustable Pump Carpet Extractor & Hard Surface Cleaner w/ 25' Vac Hose",
    "url": "https://thecleaningbusiness.com/products/sandia-80-5000-carpet-extractor-and-hard-surface-cleaner",
    "type": "product",
    "productCategory": "part",
    "price": 5349,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/80-5000-sandia-12-gal-extractor.jpg?v=1782639995",
    "searchKeywords": "Sandia, Sniper, 1200, Adjustable, Pump, Carpet, Extractor, Hard, Surface, Cleaner, Hose, Auto-Fill, Auto-Dump, Hoses",
    "sku": "SAN-80-5000",
    "bestFor": [
      "carpet_extraction",
      "carpet",
      "hard_floor",
      "parts",
      "carpet_extractor",
      "15000_plus",
      "3000_7500"
    ]
  },
  {
    "id": "machine-powr-flite-predator-20-inch-traction-drive-automatic-floor-scrubber",
    "name": "Powr-Flite® Phantom 20\" Traction Drive Automatic Floor Scrubber w/ Pad Driver - 16 Gallons",
    "url": "https://thecleaningbusiness.com/products/powr-flite-predator-20-inch-traction-drive-automatic-floor-scrubber",
    "type": "product",
    "productCategory": "machine",
    "price": 5323,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/powr-flite-pfs20-20-inch-floor-scrubber.jpg?v=1782640002",
    "searchKeywords": "Powr-Flite├é┬«, Phantom, Traction, Drive, Automatic, Floor, Scrubber, Driver, Gallons",
    "sku": "POW-PFS20",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "chemical-advance-fm810-14x20-orbital-floor-scrubber",
    "name": "Advance® FM810™ 14\" x 20\" Orbital Floor Scrubber (Baseboard Cleaner Option Available)",
    "url": "https://thecleaningbusiness.com/products/advance-fm810-14x20-orbital-floor-scrubber",
    "type": "product",
    "productCategory": "chemical",
    "price": 5245,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-fm810-orbital-scrubber.jpg?v=1782640008",
    "searchKeywords": "Advance├é┬«, FM810├óΓÇ₧┬ó, Orbital, Floor, Scrubber, (Baseboard, Cleaner, Option, Available)",
    "sku": "NFA-56105614",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "chemicals",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-aztec-proscrub-gas-station-auto-scrubber",
    "name": "Aztec 20\" ProScrub Automatic Floor Scrubber w/ Pad Holder or Nylon Brush",
    "url": "https://thecleaningbusiness.com/products/aztec-proscrub-gas-station-auto-scrubber",
    "type": "product",
    "productCategory": "part",
    "price": 5173,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/aztec-20-inch-proscrub-automatic-floor-scrubber-conf.jpg?v=1782640016",
    "searchKeywords": "Aztec, ProScrub, Automatic, Floor, Scrubber, Holder, Nylon, Brush",
    "sku": "AZT-030-20-B",
    "bestFor": [
      "hard_floor_scrubbing",
      "rubber",
      "hard_floor",
      "parts",
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "3000_7500"
    ]
  },
  {
    "id": "part-minuteman-x-250-dual-electric-motor-vacuum",
    "name": "Minuteman® X-250 Dual Electric Motor Vacuum for Hazardous Dust & Non-Toxic Fine Powders",
    "url": "https://thecleaningbusiness.com/products/minuteman-x-250-dual-electric-motor-vacuum",
    "type": "product",
    "productCategory": "part",
    "price": 5072.43,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman-x-250-dual-electric-motor-vacuum.jpg?v=1782640024",
    "searchKeywords": "Minuteman├é┬«, X-250, Dual, Electric, Motor, Vacuum, Hazardous, Dust, Non-Toxic, Fine, Powders",
    "sku": "MIN-XC81455-05",
    "bestFor": [
      "daily_vacuuming",
      "parts",
      "commercial_vacuum",
      "3000_7500"
    ]
  },
  {
    "id": "machine-remote-monitoring-dri-eaz-dehumidifier",
    "name": "Dri-Eaz® LGR 3500i Large Capacity Dehumidifier w/ Remote Monitoring - 400 CFM",
    "url": "https://thecleaningbusiness.com/products/remote-monitoring-dri-eaz-dehumidifier",
    "type": "product",
    "productCategory": "machine",
    "price": 5071,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/dri-eaz-lgr-3500i-dehumidifier.jpg?v=1782640031",
    "searchKeywords": "Dri-Eaz├é┬«, 3500i, Large, Capacity, Dehumidifier, Remote, Monitoring",
    "sku": "DRI-110133",
    "bestFor": [
      "restoration",
      "3000_7500"
    ]
  }
];

window.TCB_FINDER_DATA.packages = [
  {
    "id": "package-cleanfreak-17-scrubber",
    "name": "CleanFreak 17\" Scrubber Package",
    "url": "/pages/package-cleanfreak-17-scrubber",
    "facility": "all",
    "bestFor": [
      "floor_scrubber",
      "rubber"
    ]
  },
  {
    "id": "package-mytee-2008cs-extractor",
    "name": "Mytee 2008CS Extractor Package",
    "url": "/pages/package-mytee-2008cs-extractor",
    "facility": "all",
    "bestFor": [
      "carpet_extractor"
    ]
  },
  {
    "id": "package-mytee-220-hose-extractor",
    "name": "Mytee 220 PSI Hose Package",
    "url": "/pages/package-mytee-220-hose-extractor",
    "facility": "all",
    "bestFor": [
      "carpet_extractor"
    ]
  },
  {
    "id": "package-trusted-clean-maximum-contractor",
    "name": "Trusted Clean Maximum Contractor Package",
    "url": "/pages/package-trusted-clean-maximum-contractor",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-clarke-boost-stripping",
    "name": "Clarke Boost Stripping Package",
    "url": "/pages/package-clarke-boost-stripping",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-cleanfreak-performer-20",
    "name": "CleanFreak Performer 20 Scrubber Package",
    "url": "/pages/package-cleanfreak-performer-20",
    "facility": "all",
    "bestFor": [
      "floor_scrubber",
      "rubber"
    ]
  },
  {
    "id": "package-contractor-facility",
    "name": "Contractor Cleaning Package",
    "url": "/pages/package-contractor-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-warehouse-facility",
    "name": "Warehouse Cleaning Package",
    "url": "/pages/package-warehouse-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-school-facility",
    "name": "School & Church Package",
    "url": "/pages/package-school-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-hotel-facility",
    "name": "Hotel & Property Package",
    "url": "/pages/package-hotel-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-healthcare-facility",
    "name": "Healthcare Facility Package",
    "url": "/pages/package-healthcare-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-starter-business",
    "name": "Starter Business Package",
    "url": "/pages/package-starter-business",
    "facility": "all",
    "bestFor": [
      "starter"
    ]
  },
  {
    "id": "package-carpet-extractor-starter",
    "name": "Carpet Extractor Starter Package",
    "url": "/pages/package-carpet-extractor-starter",
    "facility": "all",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "starter"
    ]
  },
  {
    "id": "package-floor-scrubber-starter",
    "name": "Floor Scrubber Starter Package",
    "url": "/pages/package-floor-scrubber-starter",
    "facility": "all",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "starter"
    ]
  },
  {
    "id": "school-cleaning-packages",
    "name": "School Cleaning Packages",
    "url": "/pages/school-cleaning-packages",
    "facility": "school",
    "bestFor": [
      "school"
    ]
  },
  {
    "id": "church-cleaning-packages",
    "name": "Church Cleaning Packages",
    "url": "/pages/church-cleaning-packages",
    "facility": "church",
    "bestFor": [
      "church"
    ]
  },
  {
    "id": "gym-cleaning-packages",
    "name": "Gym Cleaning Packages",
    "url": "/pages/gym-cleaning-packages",
    "facility": "gym",
    "bestFor": [
      "gym",
      "gym_floors"
    ]
  },
  {
    "id": "restaurant-cleaning-packages",
    "name": "Restaurant Cleaning Packages",
    "url": "/pages/restaurant-cleaning-packages",
    "facility": "restaurant",
    "bestFor": [
      "restaurant"
    ]
  },
  {
    "id": "warehouse-cleaning-packages",
    "name": "Warehouse Cleaning Packages",
    "url": "/pages/warehouse-cleaning-packages",
    "facility": "warehouse",
    "bestFor": [
      "warehouse"
    ]
  },
  {
    "id": "hotel-cleaning-packages",
    "name": "Hotel & Property Cleaning Packages",
    "url": "/pages/hotel-cleaning-packages",
    "facility": "hotel",
    "bestFor": [
      "hotel"
    ]
  },
  {
    "id": "property-manager-cleaning-packages",
    "name": "Property Manager Cleaning Packages",
    "url": "/pages/property-manager-cleaning-packages",
    "facility": "property_manager",
    "bestFor": [
      "property_manager"
    ]
  },
  {
    "id": "office-cleaning-packages",
    "name": "Office Building Cleaning Packages",
    "url": "/pages/office-cleaning-packages",
    "facility": "office",
    "bestFor": [
      "office"
    ]
  },
  {
    "id": "healthcare-cleaning-packages",
    "name": "Healthcare Cleaning Packages",
    "url": "/pages/healthcare-cleaning-packages",
    "facility": "healthcare",
    "bestFor": [
      "healthcare"
    ]
  },
  {
    "id": "contractor-cleaning-packages",
    "name": "Janitorial Contractor Packages",
    "url": "/pages/contractor-cleaning-packages",
    "facility": "contractor",
    "bestFor": [
      "contractor"
    ]
  },
  {
    "id": "starter-business-packages",
    "name": "Cleaning Business Starter Packages",
    "url": "/pages/starter-business-packages",
    "facility": "startup",
    "bestFor": [
      "startup",
      "starter"
    ]
  },
  {
    "id": "carpet-extractor-packages",
    "name": "Carpet Extractor Packages",
    "url": "/pages/carpet-extractor-packages",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "floor-scrubber-packages",
    "name": "Floor Scrubber Packages",
    "url": "/pages/floor-scrubber-packages",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber"
    ]
  },
  {
    "id": "package-school-starter-cleaning-package",
    "name": "School Starter Cleaning Package",
    "url": "/pages/package-school-starter-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "starter",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-classroom-daily-cleaning-package",
    "name": "Classroom Daily Cleaning Package",
    "url": "/pages/package-classroom-daily-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "starter",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-hallway-floor-scrubber-package",
    "name": "School Hallway Floor Scrubber Package",
    "url": "/pages/package-school-hallway-floor-scrubber-package",
    "facility": "school",
    "bestFor": [
      "school",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-restroom-cleaning-package",
    "name": "School Restroom Cleaning Package",
    "url": "/pages/package-school-restroom-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-cafeteria-cleaning-package",
    "name": "School Cafeteria Cleaning Package",
    "url": "/pages/package-school-cafeteria-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-gym-floor-cleaning-package",
    "name": "School Gym Floor Cleaning Package",
    "url": "/pages/package-school-gym-floor-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "professional",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-carpet-office-cleaning-package",
    "name": "School Carpet & Office Cleaning Package",
    "url": "/pages/package-school-carpet-office-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "professional",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "hallways",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-full-facility-package",
    "name": "School Full Facility Package",
    "url": "/pages/package-school-full-facility-package",
    "facility": "school",
    "bestFor": [
      "school",
      "professional",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors",
      "entire_facility"
    ]
  },
  {
    "id": "package-school-maintenance-parts-refill-package",
    "name": "School Maintenance Parts Refill Package",
    "url": "/pages/package-school-maintenance-parts-refill-package",
    "facility": "school",
    "bestFor": [
      "school",
      "entire_facility",
      "restrooms",
      "hallways",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-summer-deep-cleaning-package",
    "name": "School Summer Deep Cleaning Package",
    "url": "/pages/package-school-summer-deep-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-church-starter-cleaning-package",
    "name": "Church Starter Cleaning Package",
    "url": "/pages/package-church-starter-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "starter",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-sanctuary-vacuum-floor-care-package",
    "name": "Sanctuary Vacuum & Floor Care Package",
    "url": "/pages/package-sanctuary-vacuum-floor-care-package",
    "facility": "church",
    "bestFor": [
      "church",
      "starter",
      "carpet",
      "carpet_extractor",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-fellowship-hall-cleaning-package",
    "name": "Fellowship Hall Cleaning Package",
    "url": "/pages/package-fellowship-hall-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-restroom-cleaning-package",
    "name": "Church Restroom Cleaning Package",
    "url": "/pages/package-church-restroom-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-carpet-cleaning-package",
    "name": "Church Carpet Cleaning Package",
    "url": "/pages/package-church-carpet-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "sanctuary",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-event-cleanup-package",
    "name": "Church Event Cleanup Package",
    "url": "/pages/package-church-event-cleanup-package",
    "facility": "church",
    "bestFor": [
      "church",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "events",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-volunteer-friendly-cleaning-package",
    "name": "Church Volunteer-Friendly Cleaning Package",
    "url": "/pages/package-church-volunteer-friendly-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "rubber",
      "volunteer",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-full-facility-package",
    "name": "Church Full Facility Package",
    "url": "/pages/package-church-full-facility-package",
    "facility": "church",
    "bestFor": [
      "church",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship",
      "entire_facility"
    ]
  },
  {
    "id": "package-church-maintenance-storage-package",
    "name": "Church Maintenance & Storage Package",
    "url": "/pages/package-church-maintenance-storage-package",
    "facility": "church",
    "bestFor": [
      "church",
      "entire_facility",
      "restrooms",
      "sanctuary",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-budget-cleaning-package",
    "name": "Church Budget Cleaning Package",
    "url": "/pages/package-church-budget-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "entire_facility",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-gym-starter-cleaning-package",
    "name": "Gym Starter Cleaning Package",
    "url": "/pages/package-gym-starter-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "starter",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-rubber-floor-cleaning-package",
    "name": "Rubber Floor Cleaning Package",
    "url": "/pages/package-rubber-floor-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "starter",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-locker-room-restroom-cleaning-package",
    "name": "Locker Room & Restroom Cleaning Package",
    "url": "/pages/package-locker-room-restroom-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-weight-room-disinfection-package",
    "name": "Weight Room Disinfection Package",
    "url": "/pages/package-weight-room-disinfection-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-cardio-area-cleaning-package",
    "name": "Cardio Area Cleaning Package",
    "url": "/pages/package-cardio-area-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-odor-control-package",
    "name": "Gym Odor Control Package",
    "url": "/pages/package-gym-odor-control-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "odor",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-floor-scrubber-package",
    "name": "Gym Floor Scrubber Package",
    "url": "/pages/package-gym-floor-scrubber-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "professional",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-full-facility-package",
    "name": "Gym Full Facility Package",
    "url": "/pages/package-gym-full-facility-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "professional",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors",
      "entire_facility"
    ]
  },
  {
    "id": "package-gym-microfiber-spray-system-package",
    "name": "Gym Microfiber & Spray System Package",
    "url": "/pages/package-gym-microfiber-spray-system-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-maintenance-parts-package",
    "name": "Gym Maintenance Parts Package",
    "url": "/pages/package-gym-maintenance-parts-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "entire_facility",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-restaurant-starter-cleaning-package",
    "name": "Restaurant Starter Cleaning Package",
    "url": "/pages/package-restaurant-starter-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "starter",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "greasy_floors",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-commercial-kitchen-degreasing-package",
    "name": "Commercial Kitchen Degreasing Package",
    "url": "/pages/package-commercial-kitchen-degreasing-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "starter",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "greasy_floors",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-dining-room-cleaning-package",
    "name": "Dining Room Cleaning Package",
    "url": "/pages/package-dining-room-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-restroom-cleaning-package",
    "name": "Restaurant Restroom Cleaning Package",
    "url": "/pages/package-restaurant-restroom-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-floor-scrubber-package",
    "name": "Restaurant Floor Scrubber Package",
    "url": "/pages/package-restaurant-floor-scrubber-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-wet-dry-vacuum-package",
    "name": "Restaurant Wet/Dry Vacuum Package",
    "url": "/pages/package-restaurant-wet-dry-vacuum-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "commercial_vacuum",
      "restrooms",
      "kitchen",
      "wet_dry",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-closing-shift-cleaning-package",
    "name": "Restaurant Closing Shift Cleaning Package",
    "url": "/pages/package-restaurant-closing-shift-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "kitchen",
      "rubber",
      "wet_dry",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-full-facility-package",
    "name": "Restaurant Full Facility Package",
    "url": "/pages/package-restaurant-full-facility-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "kitchen",
      "rubber",
      "wet_dry",
      "dining",
      "entire_facility"
    ]
  },
  {
    "id": "package-restaurant-grease-control-package",
    "name": "Restaurant Grease Control Package",
    "url": "/pages/package-restaurant-grease-control-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "greasy_floors",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-safety-wet-floor-package",
    "name": "Restaurant Safety & Wet Floor Package",
    "url": "/pages/package-restaurant-safety-wet-floor-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-warehouse-starter-cleaning-package",
    "name": "Warehouse Starter Cleaning Package",
    "url": "/pages/package-warehouse-starter-cleaning-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "starter",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-concrete-floor-scrubber-package",
    "name": "Concrete Floor Scrubber Package",
    "url": "/pages/package-concrete-floor-scrubber-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "starter",
      "floor_scrubber",
      "restrooms",
      "warehouse_concrete",
      "rubber",
      "large"
    ]
  },
  {
    "id": "package-warehouse-dust-debris-package",
    "name": "Warehouse Dust & Debris Package",
    "url": "/pages/package-warehouse-dust-debris-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "commercial_vacuum",
      "restrooms",
      "sweeper"
    ]
  },
  {
    "id": "package-loading-dock-cleaning-package",
    "name": "Loading Dock Cleaning Package",
    "url": "/pages/package-loading-dock-cleaning-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "rubber"
    ]
  },
  {
    "id": "package-warehouse-sweeper-package",
    "name": "Warehouse Sweeper Package",
    "url": "/pages/package-warehouse-sweeper-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "floor_scrubber",
      "restrooms",
      "sweeper",
      "rubber",
      "large"
    ]
  },
  {
    "id": "package-warehouse-wet-dry-vacuum-package",
    "name": "Warehouse Wet/Dry Vacuum Package",
    "url": "/pages/package-warehouse-wet-dry-vacuum-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "commercial_vacuum",
      "restrooms",
      "wet_dry"
    ]
  },
  {
    "id": "package-warehouse-heavy-duty-floor-care-package",
    "name": "Warehouse Heavy-Duty Floor Care Package",
    "url": "/pages/package-warehouse-heavy-duty-floor-care-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "professional",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "rubber"
    ]
  },
  {
    "id": "package-warehouse-full-facility-package",
    "name": "Warehouse Full Facility Package",
    "url": "/pages/package-warehouse-full-facility-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "professional",
      "floor_scrubber",
      "restrooms",
      "sweeper",
      "rubber",
      "entire_facility"
    ]
  },
  {
    "id": "package-warehouse-maintenance-parts-package",
    "name": "Warehouse Maintenance Parts Package",
    "url": "/pages/package-warehouse-maintenance-parts-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-warehouse-safety-spill-response-package",
    "name": "Warehouse Safety & Spill Response Package",
    "url": "/pages/package-warehouse-safety-spill-response-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-hotel-starter-cleaning-package",
    "name": "Hotel Starter Cleaning Package",
    "url": "/pages/package-hotel-starter-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "starter",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-carpet-extractor-package",
    "name": "Hotel Carpet Extractor Package",
    "url": "/pages/package-hotel-carpet-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-hotel-hallway-lobby-package",
    "name": "Hotel Hallway & Lobby Package",
    "url": "/pages/package-hotel-hallway-lobby-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-guest-room-cleaning-package",
    "name": "Guest Room Cleaning Package",
    "url": "/pages/package-guest-room-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "hallways",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-restroom-cleaning-package",
    "name": "Hotel Restroom Cleaning Package",
    "url": "/pages/package-hotel-restroom-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-housekeeping-cart-package",
    "name": "Housekeeping Cart Package",
    "url": "/pages/package-housekeeping-cart-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "lobby",
      "guest_rooms"
    ]
  },
  {
    "id": "package-odor-control-package",
    "name": "Odor Control Package",
    "url": "/pages/package-odor-control-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "professional",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "odor",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-full-facility-package",
    "name": "Hotel Full Facility Package",
    "url": "/pages/package-hotel-full-facility-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "professional",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "lobby",
      "entire_facility"
    ]
  },
  {
    "id": "package-property-turnover-cleaning-package",
    "name": "Property Turnover Cleaning Package",
    "url": "/pages/package-property-turnover-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "entire_facility",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "turnover",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-maintenance-parts-package",
    "name": "Hotel Maintenance Parts Package",
    "url": "/pages/package-hotel-maintenance-parts-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "entire_facility",
      "restrooms",
      "hallways",
      "lobby"
    ]
  },
  {
    "id": "package-apartment-turnover-cleaning-package",
    "name": "Apartment Turnover Cleaning Package",
    "url": "/pages/package-apartment-turnover-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "starter",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber",
      "turnover"
    ]
  },
  {
    "id": "package-property-common-area-cleaning-package",
    "name": "Property Common Area Cleaning Package",
    "url": "/pages/package-property-common-area-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "starter",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-leasing-office-cleaning-package",
    "name": "Leasing Office Cleaning Package",
    "url": "/pages/package-leasing-office-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-property-carpet-cleaning-package",
    "name": "Property Carpet Cleaning Package",
    "url": "/pages/package-property-carpet-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet",
      "carpet_extractor",
      "hallways"
    ]
  },
  {
    "id": "package-property-hallway-floor-care-package",
    "name": "Property Hallway Floor Care Package",
    "url": "/pages/package-property-hallway-floor-care-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet",
      "carpet_extractor",
      "hallways"
    ]
  },
  {
    "id": "package-move-in-move-out-cleaning-package",
    "name": "Move-In / Move-Out Cleaning Package",
    "url": "/pages/package-move-in-move-out-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-property-restroom-cleaning-package",
    "name": "Property Restroom Cleaning Package",
    "url": "/pages/package-property-restroom-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "professional",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "wet_dry"
    ]
  },
  {
    "id": "package-multi-building-cleaning-package",
    "name": "Multi-Building Cleaning Package",
    "url": "/pages/package-multi-building-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "professional",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-property-maintenance-parts-package",
    "name": "Property Maintenance Parts Package",
    "url": "/pages/package-property-maintenance-parts-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "entire_facility",
      "hallways"
    ]
  },
  {
    "id": "package-full-property-manager-package",
    "name": "Full Property Manager Package",
    "url": "/pages/package-full-property-manager-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "entire_facility",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-office-starter-cleaning-package",
    "name": "Office Starter Cleaning Package",
    "url": "/pages/package-office-starter-cleaning-package",
    "facility": "office",
    "bestFor": [
      "office",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-office-vacuum-package",
    "name": "Office Vacuum Package",
    "url": "/pages/package-office-vacuum-package",
    "facility": "office",
    "bestFor": [
      "office",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-office-restroom-cleaning-package",
    "name": "Office Restroom Cleaning Package",
    "url": "/pages/package-office-restroom-cleaning-package",
    "facility": "office",
    "bestFor": [
      "office",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-office-lobby-floor-care-package",
    "name": "Office Lobby Floor Care Package",
    "url": "/pages/package-office-lobby-floor-care-package",
    "facility": "office",
    "bestFor": [
      "office",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-office-carpet-cleaning-package",
    "name": "Office Carpet Cleaning Package",
    "url": "/pages/package-office-carpet-cleaning-package",
    "facility": "office",
    "bestFor": [
      "office",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-office-trash-touchpoint-package",
    "name": "Office Trash & Touchpoint Package",
    "url": "/pages/package-office-trash-touchpoint-package",
    "facility": "office",
    "bestFor": [
      "office",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-office-hard-floor-scrubber-package",
    "name": "Office Hard Floor Scrubber Package",
    "url": "/pages/package-office-hard-floor-scrubber-package",
    "facility": "office",
    "bestFor": [
      "office",
      "professional",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "hard_floors",
      "lobby"
    ]
  },
  {
    "id": "package-office-full-facility-package",
    "name": "Office Full Facility Package",
    "url": "/pages/package-office-full-facility-package",
    "facility": "office",
    "bestFor": [
      "office",
      "professional",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber",
      "lobby",
      "entire_facility"
    ]
  },
  {
    "id": "package-office-maintenance-parts-package",
    "name": "Office Maintenance Parts Package",
    "url": "/pages/package-office-maintenance-parts-package",
    "facility": "office",
    "bestFor": [
      "office",
      "entire_facility",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-corporate-janitorial-package",
    "name": "Corporate Janitorial Package",
    "url": "/pages/package-corporate-janitorial-package",
    "facility": "office",
    "bestFor": [
      "office",
      "entire_facility",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-healthcare-starter-cleaning-package",
    "name": "Healthcare Starter Cleaning Package",
    "url": "/pages/package-healthcare-starter-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "starter",
      "carpet",
      "carpet_extractor",
      "restrooms"
    ]
  },
  {
    "id": "package-clinic-cleaning-package",
    "name": "Clinic Cleaning Package",
    "url": "/pages/package-clinic-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "starter",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-patient-area-cleaning-package",
    "name": "Patient Area Cleaning Package",
    "url": "/pages/package-patient-area-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-waiting-room-cleaning-package",
    "name": "Waiting Room Cleaning Package",
    "url": "/pages/package-waiting-room-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "carpet",
      "carpet_extractor",
      "restrooms"
    ]
  },
  {
    "id": "package-healthcare-restroom-cleaning-package",
    "name": "Healthcare Restroom Cleaning Package",
    "url": "/pages/package-healthcare-restroom-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-floor-care-package",
    "name": "Healthcare Floor Care Package",
    "url": "/pages/package-healthcare-floor-care-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-microfiber-system-package",
    "name": "Healthcare Microfiber System Package",
    "url": "/pages/package-healthcare-microfiber-system-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-full-facility-package",
    "name": "Healthcare Full Facility Package",
    "url": "/pages/package-healthcare-full-facility-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber",
      "entire_facility"
    ]
  },
  {
    "id": "package-healthcare-safety-ppe-package",
    "name": "Healthcare Safety & PPE Package",
    "url": "/pages/package-healthcare-safety-ppe-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "entire_facility",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-maintenance-parts-package",
    "name": "Healthcare Maintenance Parts Package",
    "url": "/pages/package-healthcare-maintenance-parts-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-contractor-starter-package",
    "name": "Contractor Starter Package",
    "url": "/pages/package-contractor-starter-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "starter",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-office-route-package",
    "name": "Contractor Office Route Package",
    "url": "/pages/package-contractor-office-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "starter",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-school-church-route-package",
    "name": "Contractor School & Church Route Package",
    "url": "/pages/package-contractor-school-church-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "carpet",
      "carpet_extractor",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-restaurant-route-package",
    "name": "Contractor Restaurant Route Package",
    "url": "/pages/package-contractor-restaurant-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-carpet-cleaning-package",
    "name": "Contractor Carpet Cleaning Package",
    "url": "/pages/package-contractor-carpet-cleaning-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "carpet",
      "carpet_extractor",
      "routes"
    ]
  },
  {
    "id": "package-contractor-floor-scrubber-package",
    "name": "Contractor Floor Scrubber Package",
    "url": "/pages/package-contractor-floor-scrubber-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "professional",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-multi-surface-package",
    "name": "Contractor Multi-Surface Package",
    "url": "/pages/package-contractor-multi-surface-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "professional",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-full-route-package",
    "name": "Contractor Full Route Package",
    "url": "/pages/package-contractor-full-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "professional",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-replacement-parts-package",
    "name": "Contractor Replacement Parts Package",
    "url": "/pages/package-contractor-replacement-parts-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "entire_facility",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-van-ready-equipment-package",
    "name": "Contractor Van-Ready Equipment Package",
    "url": "/pages/package-contractor-van-ready-equipment-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "entire_facility",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-solo-cleaner-starter-package",
    "name": "Solo Cleaner Starter Package",
    "url": "/pages/package-solo-cleaner-starter-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "solo",
      "first_account"
    ]
  },
  {
    "id": "package-first-commercial-account-package",
    "name": "First Commercial Account Package",
    "url": "/pages/package-first-commercial-account-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "first_account"
    ]
  },
  {
    "id": "package-office-cleaning-startup-package",
    "name": "Office Cleaning Startup Package",
    "url": "/pages/package-office-cleaning-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-floor-care-startup-package",
    "name": "Floor Care Startup Package",
    "url": "/pages/package-floor-care-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-carpet-cleaning-startup-package",
    "name": "Carpet Cleaning Startup Package",
    "url": "/pages/package-carpet-cleaning-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-janitorial-cart-startup-package",
    "name": "Janitorial Cart Startup Package",
    "url": "/pages/package-janitorial-cart-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "professional",
      "restrooms",
      "routes",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-budget-startup-package",
    "name": "Budget Startup Package",
    "url": "/pages/package-budget-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "professional",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-professional-startup-package",
    "name": "Professional Startup Package",
    "url": "/pages/package-professional-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "professional",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-contractor-growth-package",
    "name": "Contractor Growth Package",
    "url": "/pages/package-contractor-growth-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "entire_facility",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-complete-cleaning-business-launch-package",
    "name": "Complete Cleaning Business Launch Package",
    "url": "/pages/package-complete-cleaning-business-launch-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "entire_facility",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-carpet-extractor-starter-package",
    "name": "Carpet Extractor Starter Package",
    "url": "/pages/package-carpet-extractor-starter-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "starter",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-office-carpet-extractor-package",
    "name": "Office Carpet Extractor Package",
    "url": "/pages/package-office-carpet-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "starter",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-church-carpet-extractor-package",
    "name": "Church Carpet Extractor Package",
    "url": "/pages/package-church-carpet-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-property-manager-carpet-package",
    "name": "Property Manager Carpet Package",
    "url": "/pages/package-property-manager-carpet-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-auto-detailing-extractor-package",
    "name": "Auto Detailing Extractor Package",
    "url": "/pages/package-auto-detailing-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-high-psi-extractor-package",
    "name": "High-PSI Extractor Package",
    "url": "/pages/package-high-psi-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-heated-extractor-package",
    "name": "Heated Extractor Package",
    "url": "/pages/package-heated-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-extractor-hose-wand-package",
    "name": "Extractor Hose & Wand Package",
    "url": "/pages/package-extractor-hose-wand-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "entire_facility",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-extractor-maintenance-parts-package",
    "name": "Extractor Maintenance Parts Package",
    "url": "/pages/package-extractor-maintenance-parts-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "entire_facility",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-floor-scrubber-starter-package",
    "name": "Floor Scrubber Starter Package",
    "url": "/pages/package-floor-scrubber-starter-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "starter",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-small-facility-scrubber-package",
    "name": "Small Facility Scrubber Package",
    "url": "/pages/package-small-facility-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "starter",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-medium-facility-scrubber-package",
    "name": "Medium Facility Scrubber Package",
    "url": "/pages/package-medium-facility-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-large-facility-scrubber-package",
    "name": "Large Facility Scrubber Package",
    "url": "/pages/package-large-facility-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "hard_floors",
      "gym_floors",
      "large"
    ]
  },
  {
    "id": "package-warehouse-scrubber-package",
    "name": "Warehouse Scrubber Package",
    "url": "/pages/package-warehouse-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-scrubber-package",
    "name": "School Scrubber Package",
    "url": "/pages/package-school-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "professional",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-restaurant-scrubber-package",
    "name": "Restaurant Scrubber Package",
    "url": "/pages/package-restaurant-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "professional",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-scrubber-package",
    "name": "Gym Scrubber Package",
    "url": "/pages/package-gym-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "professional",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-scrubber-pads-chemicals-package",
    "name": "Scrubber Pads & Chemicals Package",
    "url": "/pages/package-scrubber-pads-chemicals-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "entire_facility",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-scrubber-maintenance-parts-package",
    "name": "Scrubber Maintenance Parts Package",
    "url": "/pages/package-scrubber-maintenance-parts-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "entire_facility",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  }
];

window.TCB_FINDER_DATA.productDescriptions = {
  "walk-behind-floor-scrubbers": "Best for routine hard-floor cleaning in offices, schools, churches, restaurants, gyms, and medium facilities.",
  "ride-on-floor-scrubbers": "Best for large facilities, long cleaning routes, warehouses, schools, and high-square-footage spaces.",
  "floor-scrubbers": "Compare commercial scrubbers for daily hard-floor cleaning, wet recovery, and labor savings.",
  "sweepers": "Best for dust, debris, warehouse aisles, loading docks, and industrial floor pickup.",
  "wet-dry-vacuums": "Best for wet spills, dry debris, restrooms, kitchens, warehouses, and versatile facility cleanup.",
  "commercial-vacuums": "Best for daily janitorial routes, carpet pickup, office cleaning, schools, hotels, and churches.",
  "carpet-extractors": "Best for carpet cleaning, upholstery cleaning, spot removal, hotels, churches, and property turnover.",
  "floor-buffers": "Best for floor maintenance, scrubbing, stripping support, and polishing prep.",
  "burnishers": "Best for maintaining a high-gloss floor appearance in commercial facilities.",
  "industrial-cleaning-equipment": "Best for large facilities, heavy-duty cleanup, concrete floors, and industrial environments.",
  "parts": "Find pads, brushes, filters, bags, hoses, wands, squeegee blades, batteries, chargers, and maintenance parts.",
  "chemicals": "Shop floor cleaners, degreasers, restroom cleaners, carpet chemicals, disinfectant options, and odor control.",
  "machine-tennant-t20-industrial-ride-on-floor-scrubber-80-gallon": "Tennant® T20 Industrial Ride-On Floor Scrubber w/ ES® Extended Scrub & ec-H2O™ Technology Options –  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t16-automatic-floor-scrubber": "Tennant® T16 36\" Ride-On Automatic Floor Scrubber w/ ec-H2O™ Technology (Disk Scrub Deck) – 50 Gallo — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-outdoor-gas-powered-ride-on-sweeper": "IPC Eagle Genius 58\" Outdoor Gas Powered Ride On Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-battery-operated-ride-on-airport-sweeper": "IPC Eagle 1404 Battery Operated Ride On Vacuum Sweeper - 58\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advancer-sw4000tm-rider-sweeper": "Advance® SW4000™ Rider Sweeper - 49\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-4": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/ — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-3": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/ — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-r14-rider-self-contained-carpet-cleaning-extractor": "Tennant® R14 Rider Self-Contained Carpet Cleaning Extractor (32 Gallons) - 28\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-2": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/ — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t7-ride-on-automatic-floor-scrubber": "Tennant® T7 Ride-On Automatic Floor Scrubber w/ Conventional & ec-H2O NanoClean® Options – 29 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-34-disc-rider-autoscrubber-clk-56114031": "Clarke Focus II 34\" Disc Rider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc4000-ride-on-floor-scrubber": "Advance® SC4000® Ride-On Floor Scrubber w/ REV Technology (Battery, EcoFlex™ & High Performance Opti — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-gal-tvl-85": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate - 32 GAL - TVL 850/ — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-advenger-ride-on-floor-scrubber-with-rev-technology": "28\" Advance® Advenger® Ride-On Floor Scrubber w/ REV Technology — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-focus-ii-28-boost-rider-autoscrubber-clk-56114020": "Focus II 28\" BOOST Rider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-1280-battery-power-rider-sweeper": "IPC Eagle 1280 Battery Powered Rider Vacuum Sweeper - 48\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-36-inch-automatic-ride-on-scrubber": "IPC Eagle CT160 Industrial Automatic Ride On Floor Scrubber (36\" Scrub Deck) - 39 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-28-disc-rider-autoscrubber-clk-56114012": "Clarke Focus II 28\" Disc Rider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-boost-automatic-ride-on-floor-scrubber": "Clarke® Focus® II BOOST® Automatic Ride on Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t600-self-propelled-walk-behind-floor-scrubber": "Tennant® T600 Self-Propelled Walk Behind Automatic Floor Scrubber w/ Pad Drivers (28\", 32\" & 36\" Dec — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-rs28-rider-scrubber-with-deck-option": "Pacific Floorcare® RS28 Ride On Automatic Floor Scrubber (28\" Disc or 14\" x 28\" Orbital) - 30 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-terra-4300b-compact-rider-sweeper": "Advance Terra® 4300B Compact Rider Sweeper - 46\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-33-cylindrical-sm3332cqp-284": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 33\" Cylindrical (SM3332CQP) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-28-cylindrical-sm2832cqp-284": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 28\" Cylindrical (SM2832CQP) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-green-cleaning-rider-scrubber": "IPC Eagle CT110 ECS Low Moisture Rider Floor Scrubber (32\" Scrub Deck) - 29 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-35-disc-sm3532dqp-28406": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 35\" Disc (SM3532DQP) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-torando-bd-33-30-rider-auto-scrubber-w-pad-drivers": "Torando® BD 33/30 Rider Auto Scrubber w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-kleen-sweep-47r-ride-on-floor-sweeper-large-area-vacuum-financing-available-base-unit-wi": "Kleen Sweep 47R Ride On Floor Sweeper - Large Area Vacuum | Financing Available - Base Unit with Cha — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-focus-ii-28-boost-microrider-autoscrubber-clk-56382630": "Focus II 28\" BOOST MicroRider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-30-disc-sm3032dqp-28405": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 30\" Disc (SM3032DQP) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-28-inch-350bu-battery-floor-burnisher": "Pioneer Eclipse 28\" 350BU High Speed Battery Floor Burnisher - 2,000 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-focus-ii-26-disc-microrider-autoscrubber-clk-56382626": "Focus II 26\" Disc MicroRider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-microrider-auto-scrubber": "Clarke® Focus® II MicroRider™ Auto Floor Scrubber (26\" or 14\" x 28\" Deck Options) - 21 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-adgressor-3220d-industrial-32-inch-ride-on-floor-scrubber": "Advance® Adgressor® 3220D Industrial 32\" Ride on Floor Scrubber - 42 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-nilfisk-sw3000-li-ion-ride-on-industrial-floor-sweeper": "Nilfisk® SW3000™ Ride-On Industrial Floor Sweeper w/ Li-Ion Batteries - 53\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-clean-track-l24-battery-powered-self-contained-carpet-extractor": "Clarke® Clean Track® L24 Battery Powered Self-Contained Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-large-ride-on-automatic-floor-scrubber": "IPC Eagle CT110 Compact Ride-On Automatic Floor Scrubber (32\" Scrub Deck) - 29 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-battery-powered-rider-warehouse-sweeper": "IPC Eagle 1050 Battery Powered Rider Warehouse Vacuum Sweeper - 42\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-aquaplus-axp-battery-powered-self-contained-carpet-extractor-by-advance": "Advance® AquaPLUS™ AXP™ Battery Powered Self-Contained Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as850r-312-rider-auto-scrubber-32-cleaning-path-vp-as850r-312": "Viper AS850R-312 Rider Auto Scrubber - 32\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc800-st-34-inch-battery-floor-scrubber": "Advance® SC800™ ST 34\" Battery Powered Floor Scrubber w/ Pad Holders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as850r-242-rider-auto-scrubber-32-cleaning-path-vp-as850r-242": "Viper AS850R-242 Rider Auto Scrubber - 32\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as850r-32-inch-rider-automatic-floor-scrubber": "Viper AS850R 32\" Rider Automatic Floor Scrubber - 32 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as710r-ride-on-auto-floor-scrubber-28-cleaning-path-vp-as710r": "Viper AS710R Ride On Auto Floor Scrubber - 28\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-ros1300-ride-on-sweeper": "Viper ROS1300 Rider Floor Sweeper w/ Dust Control - 53\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t500e-26-inch-walk-behind-floor-scrubber": "Tennant® T500e Self-Propelled 26\" Walk Behind Automatic Floor Scrubber w/ Pad Drivers - 22.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc750-28-inch-battery-floor-scrubber-w-pad-holders": "Advance® SC750™ 28\" Battery Floor Scrubber w/ Pad Holders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc901-28-inch-commercial-battery-floor-scrubber-w-pad-driver": "Advance® SC901™ 28\" Commercial Battery Floor Scrubber w/ Pad Driver — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber": "Clarke® Focus® II Boost® 14\" x 28\" Orbital Auto Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s-28-orbital-floor-scrubber-14x28": "Pacific Floorcare® S-28 Orbital Automatic Floor Scrubber (22 Gallons) - 14\" x 28\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber": "Pacific Floorcare® 32\" Battery Powered S-32 Auto Scrubber (22 Gallon) w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tornado-bd-26-27-rider-auto-scrubber-w-pad-drivers-27-gallons": "Tornado® BD 26/27 Rider Auto Scrubber w/ Pad Drivers - 27 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-24-in-ride-on-automatic-floor-scrubber-ct80-series": "IPC Eagle CT80 Compact Ride on Automatic Floor Scrubber (24\" Scrub Deck) - 21 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc750-st-26-inch-battery-floor-scrubber": "Advance® SC750™ ST 26\" Battery Floor Scrubber w/ Pad Holders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-28-inch-battery-powered-s-28-floor-scrubber": "Pacific Floorcare® 28\" Battery Powered S-28 Floor Scrubber (22 Gallon) w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as7190to-walk-behind-orbital-automatic-floor-scrubber-w-traction-drive": "Viper AS7190TO Walk Behind Orbital Automatic Floor Scrubber (14\" x 28\" Head) w/ Traction Drive - 22  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-nilfisk-sc550-cylindrical-floor-scrubber-li-ion-battery": "Nilfisk® SC550 Cylindrical 20\" Floor Scrubber w/ Li-ion Battery - 13 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-40-inch-dust-control-propane-burnisher": "Pioneer Eclipse High Speed 40\" Propane Floor Burnisher w/ 18 HP Kawasaki Enigine & Dust Control - 1, — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-adfinity-x20c-cylindrical-battery-floor-scrubber-with-ecoflex": "Advance® Adfinity™ X20C Cylindrical 20\" Battery Floor Scrubber w/ EcoFlex™ - 14.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-max-ride-26-automatic-floor-scrubber": "Minuteman® Max Ride 26 Automatic Floor Scrubber (Battery Upgrade Option Available) - 21 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc1500-commercial-20-inch-stand-up-floor-scrubber": "Advance® SC1500™ Commercial 20\" Stand-On Floor Scrubber w/ EcoFlex™ & Optional REV Technology — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-4-gpm-trailer-mount-pressure-washer-with-tank-and-100-foot-hose": "CleanFreak® 4.0 GPM Hot Water Pressure Washing Skid w/ Tank, Reels & Spray Gun (Gas Engine) – 3,500  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-315asr-30-inch-ride-on-floor-scrubber": "Pioneer Eclipse 315ASR 30\" Ride On Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-32-inch-auto-scrubber": "Viper Fang 32 inch Automatic Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber-demo": "Clarke® Focus® II Boost® 28 inch Orbital Auto Scrubber (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as7690t-walk-behind-30-inch-automatic-floor-scrubber": "Viper AS7690T Walk Behind 30\" Automatic Floor Scrubber - 22 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-3040qh-hot-water-gas-pressure-washer-cs-3040qh": "3040QH Hot Water Gas Pressure Washer — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ca60-24b-boost-automatic-floor-scrubber-14x24-inch-head": "Clarke® CA60 24B Boost® Orbital Automatic Floor Scrubber - 14\" x 24\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-top-stripping-orbital-auto-scrubber": "Pacific Floorcare® S-20 Orbital Auto Scrubber - 14\" x 20\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as530r-ride-on-auto-floor-scrubber-no-batteries-20-cleaning-path-vp-50000417": "Viper AS530R Ride On Auto Floor Scrubber - No Batteries - 20\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as6690t-walk-behind-26-inch-automatic-floor-scrubber": "Viper AS6690T Walk Behind 26\" Automatic Floor Scrubber - 22 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s-20-automatic-floor-scrubber": "Pacific Floorcare® 20\" Automatic Floor Scrubber (#S-20) - Traction Drive w/ Battery Options — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-battery-powered-gas-station-sweeper": "IPC Eagle 712ET Battery Powered 36\" Vacuum Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-inch-tornado-floor-scrubbing-machine": "Tornado® 28\" BD 28/20 Automatic Floor Scrubber - 20 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-20-inch-300bu-battery-floor-burnisher": "Pioneer Eclipse 20\" 300BU Ultra-High Speed (UHS) Battery Floor Burnisher - 2,000 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-large-carpet-area-self-contained-carpet-cleaning-extractor-machine-mm-c8420-115": "Large Carpet Area Self-Contained Carpet Cleaning Extractor Machine — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-microfiber-bonnet-auto-floor-scrubber": "IPC Eagle CT70 ECS 28\" Auto Floor Scrubber w/ Microfiber Bonnet Drivers - 19 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-eco-stripping-orbital-auto-scrubber-package": "Clarke® Boost® 14\" x 20\" Oscillating Auto Scrubber Floor Stripping Package — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-24-inch-propane-burnisher": "Pioneer Eclipse 24\" Propane Floor Burnisher w/ Dust Control & Emissions Monitoring - 1,800 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-compact-rider-sweeper-ipc-eagle-512r": "IPC Eagle 512R Compact Industrial Rider Floor & Carpet Vacuum Sweeper - 28\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct71xp-600-rpm-high-speed-28-automatic-floor-polisher-and-scrubber-19-gallons": "IPC Eagle CT71XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ Pad Drivers - 19 Gall — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc2000-20-inch-compact-ride-on-floor-scrubber": "Advance® SC2000™ 20\" Compact Ride-on Floor Scrubber w/ Pad Drivers - 18.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t581-micro-20-inch-ride-on-floor-scrubber": "Tennant® T581 Micro 20\" Ride-On Floor Scrubber w/ Pad Driver - 20 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ra40-20d-micro-rider-scrubber": "Clarke® RA40™ 20D Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 18.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct71-traction-drive-automatic-floor-scrubber-24-or-28-inch": "IPC Eagle CT71 Traction Drive Automatic Floor Scrubber w/ Pad Drivers (24\" & 28\" Deck Options) - 19  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-h26-hospital-floor-scrubber": "Minuteman® H26 Compact Automatic Floor Scrubber for Hospitals w/ Pad Drivers - 19 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct51xp-600-rpm-high-speed-28-inch-automatic-floor-polisher-and-scrubber-13-gallo": "IPC Eagle CT51XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ Pad Drivers - 13 Gall — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-26-inch-self-propelled-battery-floor-scrubber": "Minuteman® 26\" Self Propelled Battery Floor Scrubber w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-powr-flite-crossover-26-inch-rider-automatic-floor-scrubber-pas26r": "Powr-Flite® Crossover 26\" Rider Automatic Floor Scrubber w/ Pad Drivers (#PAS26R) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s-24xm-24-inch-battery-powered-floor-scrubber-11-gallon": "Pacific Floorcare® S-24XM 24\" Battery Powered Floor Scrubber (11 Gallon) w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t390-self-propelled-28-inch-floor-scrubber": "Tennant® T390 Self-Propelled 28\" Walk Behind Automatic Floor Scrubber w/ Pad Drivers - 17 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as530r-micro-rider-floor-scrubber": "Viper AS530R™ Micro Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 19 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-portable-carpet-extractor-15-gallon": "Commercial Portable Carpet Extractor — 15 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-mytee-2002cs-contractor-s-special-carpet-cleaner-extractor": "Mytee 2002CS Contractor's Special Carpet Cleaner Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-rt50-lithium-floor-scrubber-22-inch": "22\" Walk-Behind Commercial Floor Scrubber — RT50 Series — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-120-psi-heated-extractor": "CleanFreak 120 PSI Heated Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-2008cs-220-psi-heated-extractor": "Mytee 2008CS 220 PSI Heated Carpet Extractor Package — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-1001dx-200-speedster-deluxe": "Mytee 1001DX-200 Speedster Deluxe Heated Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-500-psi-heated-portable-extractor": "CleanFreak 500 PSI Heated Portable Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-trusted-clean-ultimate-heated-extractor": "Trusted Clean Ultimate Heated Box Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-trusted-clean-maximum-220-psi-heated-extractor": "Trusted Clean Maximum 220 PSI Heated Extractor — 17 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-500-psi-commercial-extractor": "CleanFreak 500 PSI Commercial Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-220-psi-extractor-25ft-hose": "Mytee 220 PSI Carpet Extractor with 25' Hose Package — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-sandia-sniper-100-psi-heated-extractor": "Sandia Sniper 100 PSI Heated Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-120-psi-non-heated-12-gallon-extractor": "CleanFreak 120 PSI Non-Heated 12 Gallon Box Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-extraction-care-carpet-upholstery-cleaner-2-5-gal": "CleanFreak Extraction Care Carpet & Upholstery Cleaner (2.5 Gallon FlexMax Pouch) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cleanfreak-defoamer-vacuum-motor-protectant-2-5-gal": "CleanFreak Defoamer Vacuum Motor Protectant (2.5 Gallon FlexMax Pouch) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-extraction-rinse-carpet-cleaner-2-5-gal": "CleanFreak Extraction Rinse Carpet Cleaner (2.5 Gallon FlexMax Pouch) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-prespray-traffic-lane-cleaner-1-gal": "CleanFreak Prespray Traffic Lane Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-urine-odor-neutralizer-1-gal": "CleanFreak Urine Odor Neutralizer (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-enzyme-digestant-carpet-cleaner-1-gal": "CleanFreak Enzyme Digestant Carpet Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-winterizing-windshield-washer-fluid-1-gal-2-pack": "Winterizing Windshield Washer Fluid (1 Gallon, 2-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-8400-stainless-steel-upholstery-tool-4-inch": "Mytee #8400 Stainless Steel Upholstery Tool — 4\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-8400g-glider-upholstery-tool-4-inch": "Mytee #8400G Glider Upholstery Tool — 4\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-t-rex-12-inch-dual-jet-drag-wand": "Mytee T-Rex 12\" Dual Jet Drag Wand — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-15-foot-crush-proof-vac-solution-hose": "Mytee 15' Crush-Proof Vacuum & Solution Hose Combo — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-25-foot-extension-solution-hose": "Mytee 25' Extension Solution Hose — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-h141v-hose-connector-adapter": "Mytee #H141V Hose Connector Adapter (1.5\" to 2\") — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-air-lite-upholstery-tool": "Mytee Air Lite Upholstery Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-6-inch-upholstery-hand-tool": "Mytee 6\" Upholstery Hand Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mytee-vacuum-motor-gasket-kit-2002cs": "Mytee Vacuum Motor Gasket Kit (2002CS / 2008CS) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mytee-pump-diaphragm-replacement-kit": "Mytee Pump Diaphragm Replacement Kit (120 PSI) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mytee-inline-heater-element-1200w": "Mytee In-Line Heater Element — 1200W — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mytee-vacuum-switch-assembly-2002cs": "Mytee Vacuum Switch Assembly (2002CS Series) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-commercial-carpet-dryer-air-mover-3-speed": "XPOWER X-800TF 3-Speed Commercial Air Mover — Timer & Filter Kit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-trusted-clean-dura-17-floor-scrubber-13-gallon": "Trusted Clean Dura 17 Electric Auto Floor Scrubber w/ Pad Driver — 13 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-trusted-clean-dura-20-floor-scrubber": "Trusted Clean Dura 20 Automatic Floor Scrubber w/ Pad Driver — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-easysweep-carpet-floor-vacuum-sweeper": "CleanFreak EasySweep Carpet & Floor Vacuum Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-17-heavy-duty-floor-buffer": "CleanFreak 17\" Heavy Duty Floor Buffer w/ Pad Driver — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cleanfreak-20-high-speed-floor-burnisher-1500-rpm": "CleanFreak 20\" High Speed Floor Burnisher w/ 1.5 HP Motor — 1,500 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-trusted-clean-quench-18-gallon-wet-vacuum": "Trusted Clean Quench Wet Push Vacuum — 18 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-heated-carpet-spot-cleaner-3-gallon": "CleanFreak Heated Carpet Spot Cleaner w/ 4\" Stainless Steel Tool — 3 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-commercial-carpet-spot-machine-3-gallon": "CleanFreak Commercial Carpet Spot Cleaning Machine w/ 4\" Plastic Hand Tool — 3 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cleanfreak-flood-master-portable-flood-pumper": "CleanFreak Flood Master Portable Flood Pumper & Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-oscillating-floor-machine-14x20": "CleanFreak Oscillating Floor Machine (14\" x 20\" Head) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-trusted-clean-dura-18hd-floor-scrubber-9-gallon": "Trusted Clean Dura 18HD Cord Electric 18\" Automatic Floor Scrubber w/ Brush — 9 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cleanfreak-17-auto-scrubber-floor-cleaning-package": "CleanFreak 17\" Electric Auto Scrubber Floor Cleaning Package w/ Brush, Pads & Chemicals — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-sandia-super-scout-6-gallon-portable-extractor": "Sandia Super Scout 6 Gallon Portable Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-lite-ii-5-gallon-portable-extractor": "Mytee Lite II 5 Gallon Portable Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-3000-psi-gas-pressure-washer": "CleanFreak 3000 PSI Commercial Pressure Washer — Gas Powered — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-4000-psi-gas-pressure-washer": "CleanFreak 4000 PSI Commercial Pressure Washer — Gas Powered — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-trusted-clean-dura-13-floor-scrubber": "Trusted Clean Dura 13 Gallon Electric Auto Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-10-gallon-wet-dry-shop-vacuum": "CleanFreak 10 Gallon Wet/Dry Shop Vacuum — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-17-high-speed-burnisher-1500-rpm": "CleanFreak 17\" High Speed Burnisher — 1,500 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mytee-water-hog-flood-extractor-pump": "Mytee Water Hog Flood Extractor & Pump — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-supernova-1200psn-two-way-self-contained-extractor-dual-vac-12-gallon-1200psn": "Supernova 1200PSN Two-Way Self Contained Extractor, Dual Vac- 12-Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-supernova-800psn-two-way-self-contained-extractor-dual-vac-8-gallon-800psn": "Supernova 800PSN Two-Way Self Contained Extractor, Dual Vac - 8-Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-1500shde-oil-fired-hot-water-pressure-washer-1500-psi-cs-1500shde": "1500SHDE Oil Fired Hot Water Pressure Washer - 1500 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-portable-diesel-fired-electric-powered-3-gpm-1000-psi-hot-water-pressure-washer-cs-1000shd": "Portable Diesel Fired Electric Powered 3 gpm, 1000 psi Hot Water Pressure Washer — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-28-walk-behind-floor-sweeper-kleen-sweep-ks28-mm-ks28bqp": "28\" Walk-Behind Floor Sweeper - Kleen Sweep KS28 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-bsw-28-floor-sweeper-28-floor-sweeping-path-clk-9084705010": "BSW 28 Floor Sweeper - 28\" Floor Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ex40-18lx-walk-behind-carpet-extractor-18-cleaning-path-clk-56265505": "EX40 18LX Walk Behind Carpet Extractor - 18\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-vantage-14-battery-powered-floor-scrubber-clk-9087345020": "Clarke Vantage 14 Battery Powered Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-3000xar-tube-cart-electric-series-pressure-washer-3000-psi-cs-3000xar": "3000XAR Tube Cart Electric Series Pressure Washer - 3000 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-polaris-1201ps-self-contained-extractor-12-gallon-1201ps": "Polaris 1201PS Self Contained Extractor - 12-Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-3000wm-ss-wall-mount-electric-pressure-washer-3000-psi-cs-3000wm-ss": "3000WM/SS Wall Mount Electric Pressure Washer - 3000 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-3000wm-ss3-wall-mount-electric-pressure-washer-3000-psi-3-phase-cs-3000wm-ssm3": "3000WM/SS3 Wall Mount Electric Pressure Washer - 3000 PSI, 3 Phase — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-stinger-20-battery-powered-automatic-floor-scrubber-20-uno-20fsb": "Stinger 20 Battery Powered Automatic Floor Scrubber - 20\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-stinger-battery-powered-automatic-floor-scrubber-20-uno-510b": "Stinger Battery Powered Automatic Floor Scrubber - 20\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-polaris-701ps-self-contained-extractor-7-gallon-701ps": "Polaris 701PS Self Contained Extractor - 7-Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-2000wm-ss-wall-mount-electric-pressure-washer-2000-psi-cs-2000wm-ss": "2000WM/SS Wall Mount Electric Pressure Washer - 2000 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-2000wm-ssm3-wall-mount-electric-pressure-washer-2000-psi-3-phase-cs-2000wm-ssm3": "2000WM/SSM3 Wall Mount Electric Pressure Washer - 2000 PSI, 3 Phase — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ma50-15b-battery-powered-automatic-floor-scrubber-clk-clarke380b": "Clarke MA50 15B Battery Powered Automatic Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-floodbuster-flood-pumper-fb50": "FloodBuster Flood Pumper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ex40-16st-self-contained-carpet-extractor-16-cleaning-path-clk-56265504": "EX40 16ST Self-Contained Carpet Extractor - 16\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-2000xar-tube-cart-electric-series-pressure-washer-2000-psi-cs-2000xar": "2000XAR Tube Cart Electric Series Pressure Washer - 2000 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-kleen-sweep-carpet-sweeper-ks25wqp-mm-ks25wqp": "Kleen Sweep Carpet Sweeper KS25WQP — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-7000lx-flood-hog-flood-extractor-12-gallon-my7000lx": "Mytee 7000LX Flood Hog Flood Extractor - 12 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ice-18-electric-automatic-floor-scrubber-uno-18fse-ice": "ICE 18\" Electric Automatic Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-1500wm-ss3-wall-mount-electric-pressure-washer-1500-psi-3-phase-cs-1500wm-ss3": "1500WM/SS3 Wall Mount Electric Pressure Washer - 1500 PSI, 3 Phase — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-1500wm-ss-wall-mount-electric-pressure-washer-1500-psi-cs-1500wm-ss": "1500WM/SS Wall Mount Electric Pressure Washer - 1500 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-stinger-electric-automatic-floor-scrubber-17-uno-17fse": "Stinger Electric Automatic Floor Scrubber - 17\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-clarke-vf91040-polypropylene-brush-clk-vf91040": "Clarke VF91040 Polypropylene Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-cam-spray-526575-swivel-hose-reel-wall-mount-bracket-cs-526575": "Cam Spray 526575 Swivel Hose Reel Wall Mount Bracket — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pressure-washer-sprayer-foamer-attachment-cs-527100m": "Pressure Washer Sprayer Foamer Attachment — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-camspray-gen-d30001kit-50-capacity-pressure-washer-hose-reel-cs-gen-d30001": "CamSpray GEN D30001KIT 50' Capacity Pressure Washer Hose Reel — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cam-spray-gen-d30002kit-100-capacity-pressure-washer-hose-reel-cs-gen-d30002": "Cam Spray GEN D30002KIT 100' Capacity Pressure Washer Hose Reel — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cam-spray-527660-100-pressure-washer-hose-extension-cs-527660": "Cam Spray 527660 100' Pressure Washer Hose Extension — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-100-capacity-swivel-pressure-washer-hose-reel-cs-526496-1kit": "100' Capacity Swivel Pressure Washer Hose Reel — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cam-spray-526496-kit-200-capacity-swivel-pressure-washer-hose-reel-cs-526496-kit": "Cam Spray 526496.KIT 200' Capacity Swivel Pressure Washer Hose Reel — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-341ac-8-vacuum-hose-solution-hose-assembly-341ac": "341AC 8' Vacuum Hose & Solution Hose Assembly — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-19-pad-driver-w-molded-in-clutch-plate-1903br": "19\" Pad Driver w/ Molded-in Clutch Plate — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-1039ac-stainless-steel-auto-detailer-tool-1-5-diameter-1039-9502fb": "1039AC Stainless Steel Auto Detailer Tool - 1.5\" Diameter — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-edic-1037ac-clear-plastic-detailer-tool-edic-1037ac": "EDIC 1037AC Clear Plastic Detailer Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-988cs-circuit-locator-988cs": "988CS Circuit Locator — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-circuit-locator-w-2-wall-outlets-989cs": "Circuit Locator w/ 2 Wall Outlets — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-9000ac-high-pressure-spray-gun-9000ac": "9000AC High Pressure Spray Gun — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-839ack-upholstery-tool-hose-assembly-kit-839ack": "839ACK Upholstery Tool & Hose Assembly Kit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-357ac-fivestar-extractor-upholstery-tool-kit-357ac": "357AC Fivestar Extractor Upholstery Tool Kit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-edic-358ac-polaris-extractor-upholstery-tool-hose-hose-bag-358ac": "EDIC 358AC Polaris Extractor Upholstery Tool, Hose & Hose Bag — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-single-jet-tool-kit-12-wand-15-hose-assembly-1533ack": "Single Jet Tool Kit - 12\" Wand & 15' Hose Assembly — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-334ach-aluminum-squeegee-wand-1-5-dia-334ach": "334ACH Aluminum Squeegee Wand - 1.5\" Dia. — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-dual-jet-tool-kit-12-s-bend-wand-25-hose-assembly-2534ack": "Dual Jet Tool Kit - 12\" S-Bend Wand & 25' Hose Assembly — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-dual-jet-tool-kit-12-s-bend-wand-25-hose-assy-for-500-psi-units-2534ack-500": "Dual Jet Tool Kit - 12\" S-Bend Wand & 25' Hose Assy. For 500 PSI Units — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-external-in-line-heater-w-50-ft-extension-cord-2000-watt-705hr": "External In-Line Heater w/ 50 ft. Extension Cord - 2000 Watt — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-7-revolution-hand-held-tile-cleaning-tool-700rev": "7\" Revolution Hand-Held Tile Cleaning Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-12-revolution-tile-cleaning-tool-1200rev": "12\" Revolution Tile Cleaning Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mastercraft-connector-1-5-in-steel-mc-305022": "Mastercraft Connector 1.5 in. Steel — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-352845-secondary-cord-hook-mc-352845": "352845 Secondary Cord Hook — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mastercraft-349445-1-1-2-swivel-hose-connector-mc-349445": "Mastercraft [349445]1 1/2\" SWIVEL HOSE CONNECTOR — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mastercraft-1-25-in-steel-straight-wand-slotted-19-in-long-per-piece-mc-310433": "Mastercraft 1.25 in. Steel Straight Wand Slotted 19 in. Long Per Piece — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mastercraft-14-in-hose-cage-for-sootmaster-vacuums-mc-313408": "Mastercraft 14 in. Hose Cage for Sootmaster Vacuums — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-458155-ct9-enviromaster-9-compact-hepa-dry-vacuum-filter-cassette-mc-458155": "458155 CT9 Enviromaster 9 Compact HEPA Dry Vacuum Filter Cassette — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-457981-ct9-enviromaster-9-compact-hepa-dry-vacuum-bags-10-pack-mc-457981": "457981 CT9 Enviromaster 9 Compact HEPA Dry Vacuum Bags - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mastercraft-1-25-in-plastic-dry-toolkit-mc-362727": "Mastercraft 1.25 in. Plastic Dry Toolkit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-compact-hepa-dry-canister-vacuum-cartridge-filter-mc-458295": "Compact HEPA Dry Canister Vacuum Cartridge Filter — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-floor-machine-stripping-pad-6-5-dia-brown-10-pack-mc-354368": "Floor Machine Stripping Pad - 6.5\" Dia. - Brown - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-floor-machine-buffing-polishing-pad-6-5-dia-white-10-pack-mc-418595": "Floor Machine Buffing & Polishing Pad - 6.5\" Dia. - White - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-floor-machine-buffing-cleaning-pad-6-5-dia-red-10-pack-mc-417742": "Floor Machine Buffing & Cleaning Pad - 6.5\" Dia. - Red - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-floor-machine-cleaning-scrubbing-pad-6-5-blue-10-pack-mc-257907": "Floor Machine Cleaning & Scrubbing Pad - 6.5\" - Blue - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-floor-machine-scrubbing-light-stripping-pad-6-5-dia-green-10-pack-mc-420050": "Floor Machine Scrubbing & Light Stripping Pad - 6.5\" Dia. - Green - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-floor-machine-stripping-heavy-cleaning-pad-6-5-dia-black-10-pack-mc-417734": "Floor Machine Stripping & Heavy Cleaning Pad - 6.5\" Dia. - Black - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-413224-msr-15e-ra-300-replacement-scrub-brush-2-mc-413224": "413224 MSR-15E/RA 300 Replacement Scrub Brush (2) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-253626-cleanfix-scrubby-2-in-1-scrubber-nylon-scrub-brush-6-mc-253626": "253626 Cleanfix Scrubby 2-in-1 Scrubber Nylon Scrub Brush - 6\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mastercraft-1-5-in-toolkit-with-squeegee-mc-459305": "Mastercraft 1.5 in. Toolkit with Squeegee — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mastercraft-dry-pick-up-55-gallon-drum-adapter-112-cfm-106-in-waterlift-mc-320064": "Mastercraft Dry Pick Up, 55 Gallon Drum Adapter 112 CFM 106 in. Waterlift — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mytee-p533-injection-sprayer-holder-myp533": "Mytee P533 Injection Sprayer Holder — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-mytee-a109-nylon-glide-w-removable-brush-mya109": "Mytee A109 Nylon Glide w/Removable Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-3-prong-electrical-circuit-230v-115v-converter-kit-dual-outlet-my5003": "3-Prong Electrical Circuit 230V/115V Converter Kit - Dual Outlet — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-4-prong-electrical-circuit-230v-115v-converter-kit-dual-outlet-my5004": "4-Prong Electrical Circuit 230V/115V Converter Kit - Dual Outlet — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-box-extractor-system-maintainer-12-1-qt-bottles-my3601": "Box Extractor System Maintainer - (12) 1 qt. Bottles — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-8501v-1-25-x-15-vacuum-solution-hose-combo-my8501v": "8501V 1.25\" x 15' Vacuum/Solution Hose Combo — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-stainless-steel-crevice-upholstery-tool-external-spray-my8700": "Stainless Steel Crevice Upholstery Tool, External Spray — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mytee-8400-stainless-steel-upholstery-tool-external-spray-my8400": "Mytee 8400 Stainless Steel Upholstery Tool, External Spray — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-8100-1-5-x-25-vacuum-solution-hose-combo-my8100": "Mytee 8100 1.5\" x 25' Vacuum/Solution Hose Combo — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-8101-2-x-25-vacuum-solution-hose-combo-my8101": "Mytee 8101 2\" X 25' Vacuum/Solution Hose Combo — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-a138-flood-hog-accessory-kit-mya138": "A138 Flood Hog Accessory Kit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-mytee-8300-ez-12-dual-jet-wand-my8300-ez": "Mytee 8300-EZ 12\" Dual Jet Wand — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-counter-style-spinner-tile-grout-cleaning-tool-my8908": "Counter Style Spinner Tile & Grout Cleaning Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-spinner-tile-grout-cleaning-tool-1-5-wand-style-my8903": "Spinner Tile & Grout Cleaning Tool - 1.5\" Wand Style — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-spinner-tile-grout-cleaning-tool-1-5-t-handle-style-my8904": "Spinner Tile & Grout Cleaning Tool - 1.5\" T-Handle Style — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-hot-turbo-in-line-portable-water-heater-2400-watt-my240-120": "Hot Turbo In-Line Portable Water Heater - 2400 Watt — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-air-hog-vacuum-booster-my7303lx": "Mytee Air Hog Vacuum Booster — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-fang-18c-replacement-front-squeegee-blade-vp-vf82117": "Viper Fang 18C Replacement Front Squeegee Blade — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-cuda2600-replacement-paper-bags-10-pack-vp-va51025p-p10": "Viper CUDA2600 Replacement Paper Bags - 10 Pack — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-fang-18c-replacement-rear-squeegee-blade-vp-vf82119": "Viper Fang 18C Replacement Rear Squeegee Blade — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-fang-18c-replacement-rear-squeegee-blade-vp-vf82063": "Viper Fang 18C Replacement Rear Squeegee Blade — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-fang-18c-replacement-front-squeegee-blade-vp-vf82062": "Viper Fang 18C Replacement Front Squeegee Blade — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-vv78406-air-mover-trolley-kit-vp-vv78406": "Viper VV78406 Air Mover Trolley Kit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-vf90411-16-polypropylene-brush-vp-vf90411": "Viper VF90411 16\" Polypropylene Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-fang-18c-poly-scrubbing-brush-plastic-block-17-dia-vp-vf80211b": "Fang 18C Poly Scrubbing Brush - Plastic Block - 17\" Dia. — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-fang-20-polypropylene-scrubbing-brush-plastic-block-19-dia-vp-vf82056": "Viper Fang 20 Polypropylene Scrubbing Brush - Plastic Block - 19\" Dia. — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-single-nozzle-hand-sprayer-kit-for-wolf130-spotter-vp-vv78350": "Viper Single Nozzle Hand Sprayer Kit for WOLF130 Spotter — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ca60-20b-boost-orbital-auto-scrubber-14x20": "Clarke® CA60 20B Boost 14\" x 20\" Orbital Auto Floor Scrubber - 16 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-propane-floor-buffer": "IPC Eagle 27\" Propane Floor Burnisher - 1,700 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-bb2000-battery-floor-burnisher": "IPC Eagle BB2000 20\" Battery Powered Floor Burnisher - 2000 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct71-28-inch-automatic-floor-scrubber-demo": "IPC Eagle CT71 Traction Drive 28\" Automatic Floor Scrubber - 19 Gallons (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-hotsy-cwc-53-stationary-pressure-washer": "Hotsy® CWC-53 Stationary 4.0 GPM Pressure Washer (Electric) - 3,000 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-fang-26t-automatic-floor-scrubber": "Viper Fang 26T Automatic Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as5160to-walk-behind-orbital-auto-scrubber": "Viper AS5160TO™ Walk Behind Orbital Auto Floor Scrubber (14\" x 20\" Head) w/ Traction Drive — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-large-capacity-self-contained-extractor": "Tornado® Marathon 2000 Self Contained Extractor (20 Gallons) - 19\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-kawasaki-high-speed-propane-buffer": "Pioneer Eclipse High Speed 28\" Propane Burnisher w/ 18 HP Kawasaki Engine - 1,500 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-fang-26t-automatic-floor-scrubber-demo": "Viper Fang 26T Automatic Floor Scrubber (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-edic-1200psn-supernova-2-way-self-contained-carpet-extractor": "EDIC 1200PSN Supernova™ 2-Way Self-Contained Carpet Extractor (12 Gallons) - 19\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-24-inch-420bu-propane-floor-burnisher": "Pioneer Eclipse High Speed 24\" Propane Floor Burnisher w/ 18 HP Kawasaki Engine - 1,800 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-cfh-4035g-b-hot-water-pressure-washer-gas-engine": "CleanFreak® Hot Water 4.0 GPM Pressure Washer (Gas Engine) – 3,500 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-2-way-carpet-scrubbing-machine": "EDIC 800PSN Supernova™ 2-Way Carpet Scrubbing Machine (8 Gallons) - 19\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-green-eco-friendly-auto-scrubber": "IPC Eagle CT40 ECS Green Eco-Friendly 20\" Automatic Floor Scrubber w/ Bonnet Driver - 10 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tile-cleaning-extractor": "EDIC Endeavor™ Tile Cleaning Extractor (Heated & Non-Heated Options) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-5-gpm-3500-psi-hot-water-pressure-washer-skid": "CleanFreak® Hot Water 5.0 GPM Pressure Washer Skid & Cage (Gas Engine) – 3,500 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-21-inch-propane-burnisher": "IPC Eagle 21\" Propane Floor Burnisher - 2,100 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-14x24-inch-automatic-floor-scrubber-demo": "Clarke® CA60 24B Boost® Automatic Floor Scrubber - 14\" x 24\" Head (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-gas-powered-hard-floor-vacuum-sweeper": "IPC Eagle 36\" Gas Powered Hard Floor Vacuum Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as5160t-walk-behind-20-inch-floor-scrubber-with-traction-drive": "Viper AS5160T™ Walk Behind 20\" Floor Scrubber w/ Traction Drive - 16 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-28-inch-walk-behind-battery-sweeper": "IPC Eagle 512ET Battery Powered 28\" Walk Behind Vacuum Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-es400-xlp-self-contained-carpet-extractor": "Advance® ES400™ XLP Self Contained Carpet Extractor (12 Gallons) - 18\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-20-in-ipc-eagle-ecs-auto-scrubber-demo": "20 inch IPC Eagle ECS Auto Scrubber (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ca30-20b-battery-powered-automatic-floor-scrubber": "Clarke® CA30™ 20B Battery Powered Automatic Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focusr-ii-l20-boost-auto-scrubber": "Clarke® Focus® II L20 Boost Auto Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-edic-endeavor-heated-tile-cleaning-extractor-demo": "EDIC Endeavor™ Heated Carpet & Tile Cleaning Extractor (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-20-inch-minuteman-12-gallon-commercial-auto-scrubber": "Minuteman® 20\" Commercial E20 Automatic Floor Scrubber (#E20BDQP) - 12 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ca60-20d-walk-behind-auto-scrubber": "Clarke® CA60 20D Walk Behind Auto Scrubber - 20\" Disc Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-contractors-carpet-cleaning-package": "Trusted Clean 'Maximum' Contractor Carpet Cleaning Package w/ Extractor, Floor Buffer & Spotter — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-direct-drive-auto-scrubber": "Viper Fang 20\" Direct Drive Auto Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-28-inch-vacuum-floor-sweeper": "Clarke® BSW 28\" Battery Powered Floor Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-hard-surface-floor-scrubber-package": "CleanFreak® 'Performer 20' Automatic Floor Scrubber Package — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-mytee-escape-adjustable-500-psi-portable-truckmount-carpet-extractor": "Mytee® Escape™ Adjustable 500 PSI Portable Truckmount Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-large-area-carpet-cleaning-scrubber": "IPC Eagle SC12 Fastracts Large Area Self-Contained Carpet Cleaning Scrubber (12 Gallons) - 19\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-task-pro-20-inch-16-gallon-automatic-floor-scrubber-demo": "Task-Pro™ 20\" Battery Powered TP5160 Automatic Floor Scrubber - 16 Gallon (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-task-pro-tp5160-20-inch-battery-powered-automatic-floor-scrubber-16-gallon": "Task-Pro™ 20\" Battery Powered TP5160 Automatic Floor Scrubber - 16 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s20-automatic-floor-scrubber-demo": "Pacific Floorcare® S-20 Automatic Push Floor Scrubber (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-400-series-28-inch-propane-floor-burnisher": "Pioneer Eclipse 400 Series 28\" High Speed Propane Floor Burnisher - 1,500 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-battery-floor-scrubber": "Viper Battery Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-21-inch-economy-propane-burnisher": "Pioneer Eclipse High Speed 21\" Economy Propane Floor Burnisher w/ 18 HP Kawasaki Engine - 2,000 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-fm40-orbital-floor-buffer": "Clarke® FM40™ Orbital Floor Buffer — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cleanfreak-3500-psi-skid-mount-gas-pressure-washer": "CleanFreak® Skid Mount Honda GX690 Engine w/ 8.0 GPM General Pump Pressure Washer (Gas) - 3,500 PSI — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-ex-sc-1020-self-contained-carpet-extractor": "Tennant® EX-SC-1020 Self-Contained Carpet Extractor (10 Gallons) - 17\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-wide-area-industrial-floor-scrubber-demo": "CleanFreak® 'Performer 24' Wide Area Floor Scrubber (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-vantage-14-auto-scrubber": "Clarke® Vantage 14 Auto Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ex40-18lx-self-contained-2-way-carpet-shampooer": "Clarke® EX40™ 18LX Self Contained 2-Way Carpet Scrubber (12 Gallons) - 18\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-concrete-grinder-recovery-vacuum": "Concrete Grinder Recovery Vacuum — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-sce-20-self-contained-extractor": "Pacific Floorcare® SCE-20 Self-Contained Extractor (9 Gallons) - 20\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-i-mop-walk-behind-floor-scrubber": "Tennant® i-mop® Walk Behind Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-ct231-automatic-ride-on-floor-scrubber": "IPC Eagle CT231 Automatic Ride-On Floor Scrubber w/ Brushes (42\" Scrub Deck) - 54 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-as1050r-ride-on-floor-scrubber": "Viper AS1050R 39\" Ride-On Floor Scrubber w/ Pad Drivers & Brushes - 53 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-32-inch-auto-rider-scrubber": "IPC Eagle CT160 Automatic Rider Floor Scrubber w/ Brushes (32\" Scrub Deck) - 39 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-28-inch-automatic-ride-on-scrubber": "IPC Eagle CT160 Industrial Automatic Ride On Floor Scrubber w/ Brushes (28\" Scrub Deck) - 39 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-tornado-br-33-30-rider-auto-scrubber-w-cylindrical-brushes": "Tornado® BR 33/30 Rider Auto Scrubber w/ Cylindrical Brushes — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-tornado-br-28-27-rider-auto-scrubber-w-cylindrical-brushes-27-gallons": "Tornado® BR 28/27 Rider Auto Scrubber w/ Cylindrical Brushes - 27 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-compact-floor-scrubbing-rider-machine": "IPC Eagle CT110 Compact Rider Floor Scrubber w/ Brushes (28\" Scrub Deck) - 29 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-viper-as710r-28-rider-scrubber": "Viper AS710R™ Rider Floor Scrubber w/ Brushes (28\" Scrub Deck) - 32 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-28-in-rider-automatic-scrubber-ct80-series": "IPC Eagle CT80 Compact Rider Automatic Floor Scrubber w/ Brushes (28\" Scrub Deck) - 21 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-ct105-battery-powered-floor-scrubber": "IPC Eagle CT105 Battery Powered Walk Behind Floor Scrubber w/ Brushes (28\" & 32\" Deck Options) - 26  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-br-33-30-ride-on-automatic-scrubber-33-30-gal-cylindrical-brush-includes-batteri-2": "BR 33/30 Ride-On Automatic Scrubber - 33\" - 30 GAL - Cylindrical Brush - Includes Batteries and Stan — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-br-33-30-ride-on-automatic-scrubber-33-30-gal-cylindrical-brush-includes-batteries-and-s": "BR 33/30 Ride-On Automatic Scrubber - 33\" - 30 GAL - Cylindrical Brush - Includes Batteries and Stan — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-commercial-microfiber-cleaning-cloths-12-pack": "Commercial Microfiber Cleaning Cloths (12-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-caution-wet-floor-sign-26-inch": "Caution Wet Floor Sign — 26\" A-Frame — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-rubbermaid-high-capacity-janitorial-cart": "Rubbermaid High-Capacity Janitorial Cleaning Cart — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-neutral-all-purpose-floor-cleaner-1-gal": "Neutral All-Purpose Floor Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-auto-scrubber-maintenance-parts-kit": "Auto Scrubber Maintenance Parts Kit — Pads & Squeegee — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-commercial-restroom-cleaning-cart-mop-system": "Commercial Restroom Cleaning Cart with Mop System — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-commercial-kitchen-degreaser-1-gal": "CleanFreak Commercial Kitchen Degreaser (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-cleanfreak-restroom-bowl-cleaner-1-gal": "CleanFreak Restroom Bowl Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-wet-mop-head-large-looped-end": "Commercial Wet Mop Head — Large Looped End — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-dust-mop-head-24-inch": "Commercial Dust Mop Head — 24 Inch — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-janitor-mop-handle-60-inch-aluminum": "Janitor Mop Handle — 60 Inch Aluminum — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-dual-compartment-mop-bucket-wringer-35-quart": "Dual Compartment Mop Bucket & Wringer — 35 Quart — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-nitrile-disposable-gloves-box-100-count": "Nitrile Disposable Gloves — Box of 100 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-trash-can-liner-33-gallon-100-pack": "Commercial Trash Can Liners — 33 Gallon (100-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-spray-bottle-32oz-3-pack": "Commercial Spray Bottle — 32 oz (3-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-caution-wet-floor-cone-sign-36-inch": "Caution Wet Floor Cone Sign — 36 Inch Bilingual — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-rubbermaid-brute-trash-can-32-gallon": "Rubbermaid BRUTE Trash Can — 32 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-color-coded-microfiber-mop-pad-18-inch": "Color-Coded Microfiber Mop Pad — 18 Inch — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-floor-squeegee-24-inch": "Commercial Floor Squeegee — 24 Inch — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "accessory-housekeeping-laundry-bag-commercial": "Housekeeping Laundry Bag — Commercial Heavy-Duty — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-commercial-glass-mirror-cleaner-1-gal": "Commercial Glass & Mirror Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-multipurpose-disinfectant-cleaner-1-gal": "Multipurpose Disinfectant Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-safety-glasses-clear-lens-12-pack": "Safety Glasses — Clear Lens (12-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-chemical-splash-goggles-adjustable": "Chemical Splash Goggles — Adjustable — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-commercial-toilet-bowl-brush-caddy-set": "Commercial Toilet Bowl Brush & Caddy Set — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-urinal-screen-deodorizer-10-pack": "Urinal Screen Deodorizer (10-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-handheld-carpet-grooming-brush": "Handheld Carpet Grooming Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-heavy-duty-deck-scrub-brush": "Heavy-Duty Deck Scrub Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-commercial-grout-cleaning-brush": "Commercial Grout Cleaning Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-chemical-measuring-cup-32oz": "Chemical Measuring Cup — 32 oz — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-inline-vacuum-filter-replacement-3-pack": "Inline Vacuum Filter Replacement (3-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-commercial-multi-surface-cleaner-1-gal": "Commercial Multi-Surface Cleaner (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-commercial-restroom-descaler-1-gal": "Commercial Restroom Descaler (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-foodservice-safe-sanitizer-1-gal": "Foodservice-Safe Sanitizer (1 Gallon) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-floor-scrubber-pad-set-red-blue-17-inch": "Floor Scrubber Pad Set — Red/Blue (17\", 5-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-floor-strip-pad-black-17-inch-3-pack": "Floor Strip Pad — Black (17\", 3-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-auto-scrubber-squeegee-blade-set": "Auto Scrubber Squeegee Blade Set — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-auto-scrubber-recovery-tank-gasket-kit": "Auto Scrubber Recovery Tank Gasket Kit — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-commercial-vacuum-hepa-filter-bags-10-pack": "Commercial Vacuum HEPA Filter Bags (10-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-carpet-extractor-vac-hose-cuff-set": "Carpet Extractor Vac Hose Cuff Set (2-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-carpet-extractor-wand-spray-jet-set": "Carpet Extractor Wand Spray Jet Set — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-carpet-extractor-solution-hose-50ft": "Carpet Extractor Solution/Vac Hose — 50 ft — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-chemical-resistant-nitrile-gloves-long-cuff": "Chemical-Resistant Nitrile Gloves — Long Cuff (50 Count) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-grease-resistant-nitrile-gloves-50-count": "Grease-Resistant Nitrile Gloves (50 Count) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-chemical-splash-apron-commercial": "Chemical Splash Apron — Commercial — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-tilt-truck-waste-1-cubic-yard": "Commercial Tilt Truck — 1 Cubic Yard — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-floor-scraper-tool": "Commercial Floor Scraper Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-dust-control-wipes-150-count": "Dust-Control Wipes Canister (150 Count) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-commercial-trigger-sprayer-heads-3-pack": "Commercial Trigger Sprayer Heads (3-Pack) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-large-area-walk-behind-floor-scrubber": "IPC Eagle CT90 Large Area 28\" Walk Behind Floor Scrubber w/ Brushes - 24 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-28-inch-traction-drive-auto-scrubber": "IPC Eagle CT70 Traction Drive 28\" Automatic Floor Scrubber w/ Pad Drivers or Brushes - 19 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-tornado-br-22-14t-automatic-cylindrical-floor-scrubber": "Tornado® 'BR 22/14T' Traction Drive Automatic Cylindrical Floor Scrubber w/ Brushes - 14 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tornado-floorkeeper-24-inch-99124dp-automatic-floor-scrubber": "Tornado® 'Floorkeeper 24' Walk Behind 24\" Automatic Floor Scrubber w/ 2 Pad Drivers & Traction Drive — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc500-20d-commercial-20-inch-battery-floor-scrubber": "Advance® SC500™ 20D Commercial 20\" Auto Floor Scrubber w/ Pad Driver - 12 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-20-inch-t300e-automatic-floor-scrubber": "Tennant® T300e 20\" Walk Behind Automatic Floor Scrubber w/ Pad Driver (Pad Assist & Traction Drive O — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-28-inch-walk-behind-automatic-scrubber": "Viper Fang 28T Walk Behind Automatic Floor Scrubber w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-cleantime-24-auto-scrubber": "IPC Eagle CT70 Walk Behind 24\" Auto Scrubber w/ Brushes - 19 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tornado-floorkeeper-20-walk-behind-20-inch-floor-scrubber": "Tornado® 'Floorkeeper 20' Walk Behind 20\" Automatic Floor Scrubber w/ Pad Driver - 11 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc450-20-inch-battery-automatic-floor-scrubber-w-pad-holder": "Advance® SC450™ 20\" Battery Powered Automatic Floor Scrubber w/ Pad Holder - 10.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-advance-sc450-20-inch-battery-automatic-floor-scrubber-w-brush": "Advance® SC450™ 20\" Battery Powered Automatic Floor Scrubber w/ Brush - 10.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-powr-flite-phantom-24-inch-traction-drive-automatic-floor-scrubber": "Powr-Flite® Phantom 24\" Traction Drive Automatic Floor Scrubber w/ Pad Drivers - 16 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-ct51-walk-behind-20-inch-floor-scrubber": "IPC Eagle CT51 Battery Powered 20\" Walk Behind Floor Scrubber (Pad Driver / Brush & Battery Options) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-pacific-floorcare-s20-automatic-floor-scrubber": "Pacific Floorcare® 20\" Automatic Push Floor Scrubber (#S-20) - Brush Assist — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t290-pad-assist-20-inch-walk-behind-floor-scrubber": "Tennant® T290 Pad Assist 20\" Walk Behind Automatic Floor Scrubber w/ Pad Driver - 10.5 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-20-inch-floor-scrubber-for-hospitals-w-antimicrobial-tank": "Minuteman® H20 Automatic Floor Scrubber for Hospitals w/ Antimicrobial Tank & Pad Driver - 12 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-18-inch-cylindrical-brush-floor-scrubber": "Tornado® 'BR 18/11\" Cylindrical Floor Scrubber w/ Brushes - 11 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-advance-sc401-compact-17-inch-automatic-floor-scrubber-w-brush-105-ah-batteries": "Advance® SC401™ Compact 17\" Automatic Floor Scrubber w/ Brush & 105 Ah Batteries — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-310as-20-inch-battery-auto-scrubber": "Pioneer Eclipse #310AS Battery Powered 20\" Traction Drive Auto Scrubber w/ Pad Driver - 12 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-20-inch-brush-driven-scrubber": "IPC Eagle CT40 Brush Driven 20\" Auto Scrubber w/ Brush - 10 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-brush-driven-scrubber-traction-option": "IPC Eagle 20\" Brush Driven Scrubber - CT70 - Traction Option — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-clarke-tfc-400-hands-free-bathroom-cleaner-and-carpet-extractor": "Clarke® TFC 400 Hands Free Bathroom Cleaner & Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-20-inch-compact-automatic-floor-scrubber-ct45": "IPC Eagle CT45 Low Profile 20\" Compact Automatic Floor Scrubber w/ Brush - 11 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-ipc-eagle-ct46-automatic-floor-scrubber": "IPC Eagle CT46 Low Profile 20\" Automatic Floor Scrubber w/ Brush - 11 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-cafeteria-gymnasium-floor-scrubber": "IPC Eagle CT30 Compact 18\" Automatic Floor Scrubber w/ Brush - 8 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-17-inch-minuteman-electric-auto-scrubber": "Minuteman® 17\" Cord Electric Auto Floor Scrubber w/ Pad Driver — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ice-i20nbv-contractor-grade-20-inch-floor-scrubber": "ICE i20NBV Contractor Grade 20\" Automatic Floor Scrubber w/ Pad Driver - 15 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as5160-walk-behind-20-auto-scrubber": "Viper AS5160™ Walk Behind 20\" Floor Scrubber w/ Pad Driver - 16 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-dri-eaz-motorized-high-volume-extractor-hve": "Dri-Eaz® Rover HVE Rider Flood Water Deep Extraction Tool — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc370-17-inch-battery-powered-floor-scrubber": "Advance® SC370 Battery Powered 17\" Floor Scrubber w/ Pad Holder - 6.6 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-tennant-t1-15-walk-behind-micro-scrubber": "Tennant® T1 15\" Walk Behind Micro Scrubber w/ Cylindrical Brush (Battery & Electric Options) - 3 Gal — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-mytee-ltd12-speedster-carpet-extractor-and-tile-cleaner": "Mytee® LTD120-LX Speedster® Carpet Extractor & Tile Cleaner (50 -1200 PSI) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-sandia-80-5000-carpet-extractor-and-hard-surface-cleaner": "Sandia Sniper 400 - 1200 PSI Adjustable Pump Carpet Extractor & Hard Surface Cleaner w/ 25' Vac Hose — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-powr-flite-predator-20-inch-traction-drive-automatic-floor-scrubber": "Powr-Flite® Phantom 20\" Traction Drive Automatic Floor Scrubber w/ Pad Driver - 16 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "chemical-advance-fm810-14x20-orbital-floor-scrubber": "Advance® FM810™ 14\" x 20\" Orbital Floor Scrubber (Baseboard Cleaner Option Available) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-aztec-proscrub-gas-station-auto-scrubber": "Aztec 20\" ProScrub Automatic Floor Scrubber w/ Pad Holder or Nylon Brush — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "part-minuteman-x-250-dual-electric-motor-vacuum": "Minuteman® X-250 Dual Electric Motor Vacuum for Hazardous Dust & Non-Toxic Fine Powders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-remote-monitoring-dri-eaz-dehumidifier": "Dri-Eaz® LGR 3500i Large Capacity Dehumidifier w/ Remote Monitoring - 400 CFM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration."
};

window.TCB_FINDER_DATA.packageDescriptions = {
  "packages-hub": "Start here when you need a full custom package with machines, supplies, chemicals, parts, and expert support.",
  "school-cleaning-packages": "School Cleaning Packages for commercial cleaning buyers.",
  "package-school-starter-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-hallway-floor-scrubber-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-restroom-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-full-facility-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "church-cleaning-packages": "Church Cleaning Packages for commercial cleaning buyers.",
  "package-church-starter-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-sanctuary-vacuum-floor-care-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-full-facility-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "gym-cleaning-packages": "Gym Cleaning Packages for commercial cleaning buyers.",
  "package-rubber-floor-cleaning-package": "Gym buyers focused on rubber floors, weight room, cardio area and repeatable commercial cleaning routines.",
  "package-locker-room-restroom-cleaning-package": "Gym buyers focused on locker rooms, weight room, cardio area and repeatable commercial cleaning routines.",
  "package-gym-full-facility-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "restaurant-cleaning-packages": "Restaurant Cleaning Packages for commercial cleaning buyers.",
  "package-commercial-kitchen-degreasing-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-floor-scrubber-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-full-facility-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "warehouse-cleaning-packages": "Warehouse Cleaning Packages for commercial cleaning buyers.",
  "package-concrete-floor-scrubber-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-sweeper-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "warehouse-wet-dry-vacuum-package": "Best for wet spills, dry debris, docks, restrooms, and versatile warehouse cleanup routes.",
  "package-warehouse-full-facility-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "hotel-cleaning-packages": "Hotel & Property Cleaning Packages for commercial cleaning buyers.",
  "package-hotel-carpet-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-housekeeping-cart-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-hotel-full-facility-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "property-manager-cleaning-packages": "Property Manager Cleaning Packages for commercial cleaning buyers.",
  "package-apartment-turnover-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-property-carpet-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-full-property-manager-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "office-cleaning-packages": "Office Building Cleaning Packages for commercial cleaning buyers.",
  "package-office-vacuum-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-restroom-cleaning-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-full-facility-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "healthcare-cleaning-packages": "Healthcare Cleaning Packages for commercial cleaning buyers.",
  "package-clinic-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-restroom-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-full-facility-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "contractor-cleaning-packages": "Janitorial Contractor Packages for commercial cleaning buyers.",
  "package-contractor-starter-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-carpet-cleaning-package": "Janitorial Contractor buyers focused on carpet jobs, office routes, schools and repeatable commercial cleaning routines.",
  "package-contractor-full-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "starter-business-packages": "Cleaning Business Starter Packages for commercial cleaning buyers.",
  "package-solo-cleaner-starter-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-first-commercial-account-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-complete-cleaning-business-launch-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "carpet-extractor-packages": "Carpet Extractor Packages for commercial cleaning buyers.",
  "package-carpet-extractor-starter-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-heated-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "floor-scrubber-packages": "Floor Scrubber Packages for commercial cleaning buyers.",
  "package-floor-scrubber-starter-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-medium-facility-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-gym-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-cleanfreak-17-scrubber": "CleanFreak 17 inch auto scrubber package for hard-floor cleaning teams. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemic",
  "package-mytee-2008cs-extractor": "Mytee 2008CS heated extractor package for carpet cleaning and upholstery jobs. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories,",
  "package-mytee-220-hose-extractor": "Mytee 220 PSI extractor with 25 foot hose package for portable carpet cleaning. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories",
  "package-trusted-clean-maximum-contractor": "Trusted Clean contractor carpet cleaning package for route-based cleaning businesses. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, acces",
  "package-clarke-boost-stripping": "Clarke Boost orbital stripping package for floor care crews. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, freigh",
  "package-cleanfreak-performer-20": "CleanFreak Performer 20 hard-surface floor scrubber package. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, freigh",
  "package-contractor-facility": "Contractor cleaning equipment collection for multi-account janitorial routes. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, ",
  "package-warehouse-facility": "Warehouse cleaning equipment collection for concrete floors, dust, and debris. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories,",
  "package-school-facility": "School and church cleaning equipment collection for halls, restrooms, and common areas. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, acc",
  "package-hotel-facility": "Hotel and property cleaning equipment collection for carpets, rooms, lobbies, and turnover work. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine",
  "package-healthcare-facility": "Healthcare facility cleaning equipment collection for patient-facing environments. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessor",
  "package-starter-business": "Starter cleaning business package collection for first commercial accounts. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, ch",
  "package-carpet-extractor-starter": "Carpet extractor starter collection for carpet cleaning teams. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, frei",
  "package-floor-scrubber-starter": "Floor scrubber starter collection for hard-floor care teams. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, freigh",
  "package-classroom-daily-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-cafeteria-cleaning-package": "School buyers focused on cafeteria, classrooms, hallways and repeatable commercial cleaning routines.",
  "package-school-gym-floor-cleaning-package": "School buyers focused on gym, classrooms, hallways and repeatable commercial cleaning routines.",
  "package-school-carpet-office-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-maintenance-parts-refill-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-summer-deep-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-fellowship-hall-cleaning-package": "Church buyers focused on fellowship hall, sanctuary, restrooms and repeatable commercial cleaning routines.",
  "package-church-restroom-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-carpet-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-event-cleanup-package": "Church buyers focused on event areas, sanctuary, fellowship hall and repeatable commercial cleaning routines.",
  "package-church-volunteer-friendly-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-maintenance-storage-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-budget-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-gym-starter-cleaning-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-weight-room-disinfection-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-cardio-area-cleaning-package": "Gym buyers focused on cardio area, weight room, locker rooms and repeatable commercial cleaning routines.",
  "package-gym-odor-control-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-gym-floor-scrubber-package": "Gym buyers focused on rubber floors, weight room, cardio area and repeatable commercial cleaning routines.",
  "package-gym-microfiber-spray-system-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-gym-maintenance-parts-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-restaurant-starter-cleaning-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-dining-room-cleaning-package": "Restaurant buyers focused on dining room, kitchen, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-restroom-cleaning-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-wet-dry-vacuum-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-closing-shift-cleaning-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-grease-control-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-safety-wet-floor-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-warehouse-starter-cleaning-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-dust-debris-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-loading-dock-cleaning-package": "Warehouse buyers focused on loading docks, aisles, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-wet-dry-vacuum-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-heavy-duty-floor-care-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-maintenance-parts-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-safety-spill-response-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-hotel-starter-cleaning-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-hotel-hallway-lobby-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-guest-room-cleaning-package": "Hotel & Property buyers focused on guest rooms, lobby, hallways and repeatable commercial cleaning routines.",
  "package-hotel-restroom-cleaning-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-odor-control-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-property-turnover-cleaning-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-hotel-maintenance-parts-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-property-common-area-cleaning-package": "Property Manager buyers focused on common areas, apartments, leasing office and repeatable commercial cleaning routines.",
  "package-leasing-office-cleaning-package": "Property Manager buyers focused on leasing office, apartments, hallways and repeatable commercial cleaning routines.",
  "package-property-hallway-floor-care-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-move-in-move-out-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-property-restroom-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-multi-building-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-property-maintenance-parts-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-office-starter-cleaning-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-lobby-floor-care-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-carpet-cleaning-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-trash-touchpoint-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-hard-floor-scrubber-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-maintenance-parts-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-corporate-janitorial-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-healthcare-starter-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-patient-area-cleaning-package": "Healthcare buyers focused on patient rooms, waiting rooms, exam areas and repeatable commercial cleaning routines.",
  "package-waiting-room-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-floor-care-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-microfiber-system-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-safety-ppe-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-maintenance-parts-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-contractor-office-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-school-church-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-restaurant-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-floor-scrubber-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-multi-surface-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-replacement-parts-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-van-ready-equipment-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-office-cleaning-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-floor-care-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-carpet-cleaning-startup-package": "Cleaning Business Starter buyers focused on carpet areas, first accounts, offices and repeatable commercial cleaning routines.",
  "package-janitorial-cart-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-budget-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-professional-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-contractor-growth-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-office-carpet-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-church-carpet-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-property-manager-carpet-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-auto-detailing-extractor-package": "Carpet Extractor buyers focused on auto interiors, offices, hotels and repeatable commercial cleaning routines.",
  "package-high-psi-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-extractor-hose-wand-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-extractor-maintenance-parts-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-small-facility-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-large-facility-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-warehouse-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-school-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-restaurant-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-scrubber-pads-chemicals-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-scrubber-maintenance-parts-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines."
};
